/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: Dlxm4vvfq1tf

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import FeaturesProductHeader from "../../FeaturesProductHeader"; // plasmic-import: nCl4kJqd_uCB/component
import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import FeaturesCard from "../../FeaturesCard"; // plasmic-import: eBFTaYn0ldI-/component
import ListItem from "../../ListItem"; // plasmic-import: vpKD71-ztgZQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFeaturesMyEvaluations.module.css"; // plasmic-import: Dlxm4vvfq1tf/css

import Icon93Icon from "./icons/PlasmicIcon__Icon93"; // plasmic-import: VguYknml6de0/icon
import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: z8Bk5fXmTx-P/icon

createPlasmicElementProxy;

export type PlasmicFeaturesMyEvaluations__VariantMembers = {};
export type PlasmicFeaturesMyEvaluations__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesMyEvaluations__VariantsArgs;
export const PlasmicFeaturesMyEvaluations__VariantProps =
  new Array<VariantPropType>();

export type PlasmicFeaturesMyEvaluations__ArgsType = {};
type ArgPropType = keyof PlasmicFeaturesMyEvaluations__ArgsType;
export const PlasmicFeaturesMyEvaluations__ArgProps = new Array<ArgPropType>();

export type PlasmicFeaturesMyEvaluations__OverridesType = {
  myEvaluations?: Flex__<"section">;
  desktop?: Flex__<"div">;
  row?: Flex__<"div">;
  logo?: Flex__<typeof Logo>;
  key2?: Flex__<"div">;
  header?: Flex__<"header">;
  list?: Flex__<"div">;
  row2?: Flex__<"div">;
  row3?: Flex__<"div">;
  row4?: Flex__<"div">;
  all?: Flex__<"div">;
  title?: Flex__<"div">;
  sections?: Flex__<"div">;
  col?: Flex__<"div">;
  header5?: Flex__<"div">;
  list5?: Flex__<"div">;
  item?: Flex__<"div">;
  left?: Flex__<"div">;
  icon?: Flex__<"div">;
  title98?: Flex__<"div">;
  item2?: Flex__<"div">;
  left2?: Flex__<"div">;
  icon2?: Flex__<"div">;
  title99?: Flex__<"div">;
  item3?: Flex__<"div">;
  left3?: Flex__<"div">;
  icon3?: Flex__<"div">;
  title4?: Flex__<"div">;
  item4?: Flex__<"div">;
  left4?: Flex__<"div">;
  icon4?: Flex__<"div">;
  title5?: Flex__<"div">;
  item5?: Flex__<"div">;
  left5?: Flex__<"div">;
  icon5?: Flex__<"div">;
  title6?: Flex__<"div">;
  item6?: Flex__<"div">;
  left6?: Flex__<"div">;
  icon6?: Flex__<"div">;
  title7?: Flex__<"div">;
  item7?: Flex__<"div">;
  left7?: Flex__<"div">;
  icon7?: Flex__<"div">;
  title8?: Flex__<"div">;
  item8?: Flex__<"div">;
  left8?: Flex__<"div">;
  icon8?: Flex__<"div">;
  title9?: Flex__<"div">;
  item9?: Flex__<"div">;
  left9?: Flex__<"div">;
  icon9?: Flex__<"div">;
  title10?: Flex__<"div">;
  item10?: Flex__<"div">;
  left10?: Flex__<"div">;
  icon10?: Flex__<"div">;
  title11?: Flex__<"div">;
  item11?: Flex__<"div">;
  left11?: Flex__<"div">;
  icon11?: Flex__<"div">;
  title12?: Flex__<"div">;
  item12?: Flex__<"div">;
  left12?: Flex__<"div">;
  icon12?: Flex__<"div">;
  title13?: Flex__<"div">;
  item13?: Flex__<"div">;
  left13?: Flex__<"div">;
  icon13?: Flex__<"div">;
  title14?: Flex__<"div">;
  item14?: Flex__<"div">;
  left14?: Flex__<"div">;
  icon14?: Flex__<"div">;
  title15?: Flex__<"div">;
  item15?: Flex__<"div">;
  left15?: Flex__<"div">;
  icon15?: Flex__<"div">;
  title16?: Flex__<"div">;
  item16?: Flex__<"div">;
  left16?: Flex__<"div">;
  icon16?: Flex__<"div">;
  title17?: Flex__<"div">;
  item17?: Flex__<"div">;
  left17?: Flex__<"div">;
  icon17?: Flex__<"div">;
  title18?: Flex__<"div">;
  item18?: Flex__<"div">;
  left18?: Flex__<"div">;
  icon18?: Flex__<"div">;
  title19?: Flex__<"div">;
  item19?: Flex__<"div">;
  left19?: Flex__<"div">;
  icon19?: Flex__<"div">;
  title20?: Flex__<"div">;
  item20?: Flex__<"div">;
  left20?: Flex__<"div">;
  icon20?: Flex__<"div">;
  title21?: Flex__<"div">;
  item21?: Flex__<"div">;
  left21?: Flex__<"div">;
  icon21?: Flex__<"div">;
  title22?: Flex__<"div">;
  item22?: Flex__<"div">;
  left22?: Flex__<"div">;
  icon22?: Flex__<"div">;
  title23?: Flex__<"div">;
  item23?: Flex__<"div">;
  left23?: Flex__<"div">;
  icon23?: Flex__<"div">;
  title24?: Flex__<"div">;
  item24?: Flex__<"div">;
  left24?: Flex__<"div">;
  icon24?: Flex__<"div">;
  title25?: Flex__<"div">;
  col2?: Flex__<"div">;
  section?: Flex__<"div">;
  header6?: Flex__<"div">;
  list2?: Flex__<"div">;
  item25?: Flex__<"div">;
  left25?: Flex__<"div">;
  icon25?: Flex__<"div">;
  title26?: Flex__<"div">;
  item26?: Flex__<"div">;
  left26?: Flex__<"div">;
  icon26?: Flex__<"div">;
  title27?: Flex__<"div">;
  item27?: Flex__<"div">;
  left27?: Flex__<"div">;
  icon27?: Flex__<"div">;
  title28?: Flex__<"div">;
  item28?: Flex__<"div">;
  left28?: Flex__<"div">;
  icon28?: Flex__<"div">;
  title29?: Flex__<"div">;
  item29?: Flex__<"div">;
  left29?: Flex__<"div">;
  icon29?: Flex__<"div">;
  title30?: Flex__<"div">;
  item30?: Flex__<"div">;
  left30?: Flex__<"div">;
  icon30?: Flex__<"div">;
  title31?: Flex__<"div">;
  item31?: Flex__<"div">;
  left31?: Flex__<"div">;
  icon31?: Flex__<"div">;
  title32?: Flex__<"div">;
  item32?: Flex__<"div">;
  left32?: Flex__<"div">;
  icon32?: Flex__<"div">;
  title33?: Flex__<"div">;
  item33?: Flex__<"div">;
  left33?: Flex__<"div">;
  icon33?: Flex__<"div">;
  title34?: Flex__<"div">;
  item34?: Flex__<"div">;
  left34?: Flex__<"div">;
  icon34?: Flex__<"div">;
  title35?: Flex__<"div">;
  item35?: Flex__<"div">;
  left35?: Flex__<"div">;
  icon35?: Flex__<"div">;
  title36?: Flex__<"div">;
  item36?: Flex__<"div">;
  left36?: Flex__<"div">;
  icon36?: Flex__<"div">;
  title37?: Flex__<"div">;
  item37?: Flex__<"div">;
  left37?: Flex__<"div">;
  icon37?: Flex__<"div">;
  title38?: Flex__<"div">;
  item38?: Flex__<"div">;
  left38?: Flex__<"div">;
  icon38?: Flex__<"div">;
  title39?: Flex__<"div">;
  item39?: Flex__<"div">;
  left39?: Flex__<"div">;
  icon39?: Flex__<"div">;
  title40?: Flex__<"div">;
  item40?: Flex__<"div">;
  left40?: Flex__<"div">;
  icon40?: Flex__<"div">;
  title41?: Flex__<"div">;
  item41?: Flex__<"div">;
  left41?: Flex__<"div">;
  icon41?: Flex__<"div">;
  title42?: Flex__<"div">;
  item42?: Flex__<"div">;
  left42?: Flex__<"div">;
  icon42?: Flex__<"div">;
  title43?: Flex__<"div">;
  item43?: Flex__<"div">;
  left43?: Flex__<"div">;
  icon43?: Flex__<"div">;
  title44?: Flex__<"div">;
  item44?: Flex__<"div">;
  left44?: Flex__<"div">;
  icon44?: Flex__<"div">;
  title45?: Flex__<"div">;
  item45?: Flex__<"div">;
  left45?: Flex__<"div">;
  icon45?: Flex__<"div">;
  title46?: Flex__<"div">;
  item46?: Flex__<"div">;
  left46?: Flex__<"div">;
  icon46?: Flex__<"div">;
  title47?: Flex__<"div">;
  item47?: Flex__<"div">;
  left47?: Flex__<"div">;
  icon47?: Flex__<"div">;
  title48?: Flex__<"div">;
  item48?: Flex__<"div">;
  left48?: Flex__<"div">;
  icon48?: Flex__<"div">;
  title49?: Flex__<"div">;
  section2?: Flex__<"div">;
  header7?: Flex__<"div">;
  list3?: Flex__<"div">;
  item49?: Flex__<"div">;
  left49?: Flex__<"div">;
  icon49?: Flex__<"div">;
  title50?: Flex__<"div">;
  item50?: Flex__<"div">;
  left50?: Flex__<"div">;
  icon50?: Flex__<"div">;
  title51?: Flex__<"div">;
  item51?: Flex__<"div">;
  left51?: Flex__<"div">;
  icon51?: Flex__<"div">;
  title52?: Flex__<"div">;
  item52?: Flex__<"div">;
  left52?: Flex__<"div">;
  icon52?: Flex__<"div">;
  title53?: Flex__<"div">;
  item53?: Flex__<"div">;
  left53?: Flex__<"div">;
  icon53?: Flex__<"div">;
  title54?: Flex__<"div">;
  item54?: Flex__<"div">;
  left54?: Flex__<"div">;
  icon54?: Flex__<"div">;
  title55?: Flex__<"div">;
  item55?: Flex__<"div">;
  left55?: Flex__<"div">;
  icon55?: Flex__<"div">;
  title56?: Flex__<"div">;
  item56?: Flex__<"div">;
  left56?: Flex__<"div">;
  icon56?: Flex__<"div">;
  title57?: Flex__<"div">;
  item57?: Flex__<"div">;
  left57?: Flex__<"div">;
  icon57?: Flex__<"div">;
  title58?: Flex__<"div">;
  item58?: Flex__<"div">;
  left58?: Flex__<"div">;
  icon58?: Flex__<"div">;
  title59?: Flex__<"div">;
  item59?: Flex__<"div">;
  left59?: Flex__<"div">;
  icon59?: Flex__<"div">;
  title60?: Flex__<"div">;
  item60?: Flex__<"div">;
  left60?: Flex__<"div">;
  icon60?: Flex__<"div">;
  title61?: Flex__<"div">;
  item61?: Flex__<"div">;
  left61?: Flex__<"div">;
  icon61?: Flex__<"div">;
  title62?: Flex__<"div">;
  item62?: Flex__<"div">;
  left62?: Flex__<"div">;
  icon62?: Flex__<"div">;
  title63?: Flex__<"div">;
  item63?: Flex__<"div">;
  left63?: Flex__<"div">;
  icon63?: Flex__<"div">;
  title64?: Flex__<"div">;
  item64?: Flex__<"div">;
  left64?: Flex__<"div">;
  icon64?: Flex__<"div">;
  title65?: Flex__<"div">;
  item65?: Flex__<"div">;
  left65?: Flex__<"div">;
  icon65?: Flex__<"div">;
  title66?: Flex__<"div">;
  item66?: Flex__<"div">;
  left66?: Flex__<"div">;
  icon66?: Flex__<"div">;
  title67?: Flex__<"div">;
  item67?: Flex__<"div">;
  left67?: Flex__<"div">;
  icon67?: Flex__<"div">;
  title68?: Flex__<"div">;
  item68?: Flex__<"div">;
  left68?: Flex__<"div">;
  icon68?: Flex__<"div">;
  title69?: Flex__<"div">;
  item69?: Flex__<"div">;
  left69?: Flex__<"div">;
  icon69?: Flex__<"div">;
  title70?: Flex__<"div">;
  item70?: Flex__<"div">;
  left70?: Flex__<"div">;
  icon70?: Flex__<"div">;
  title71?: Flex__<"div">;
  item71?: Flex__<"div">;
  left71?: Flex__<"div">;
  icon71?: Flex__<"div">;
  title72?: Flex__<"div">;
  item72?: Flex__<"div">;
  left72?: Flex__<"div">;
  icon72?: Flex__<"div">;
  title73?: Flex__<"div">;
  col3?: Flex__<"div">;
  header8?: Flex__<"div">;
  list4?: Flex__<"div">;
  item73?: Flex__<"div">;
  left73?: Flex__<"div">;
  icon73?: Flex__<"div">;
  title74?: Flex__<"div">;
  item74?: Flex__<"div">;
  left74?: Flex__<"div">;
  icon74?: Flex__<"div">;
  title75?: Flex__<"div">;
  item75?: Flex__<"div">;
  left75?: Flex__<"div">;
  icon75?: Flex__<"div">;
  title76?: Flex__<"div">;
  item76?: Flex__<"div">;
  left76?: Flex__<"div">;
  icon76?: Flex__<"div">;
  title77?: Flex__<"div">;
  item77?: Flex__<"div">;
  left77?: Flex__<"div">;
  icon77?: Flex__<"div">;
  title78?: Flex__<"div">;
  item78?: Flex__<"div">;
  left78?: Flex__<"div">;
  icon78?: Flex__<"div">;
  title79?: Flex__<"div">;
  item79?: Flex__<"div">;
  left79?: Flex__<"div">;
  icon79?: Flex__<"div">;
  title80?: Flex__<"div">;
  item80?: Flex__<"div">;
  left80?: Flex__<"div">;
  icon80?: Flex__<"div">;
  title81?: Flex__<"div">;
  item81?: Flex__<"div">;
  left81?: Flex__<"div">;
  icon81?: Flex__<"div">;
  title82?: Flex__<"div">;
  item82?: Flex__<"div">;
  left82?: Flex__<"div">;
  icon82?: Flex__<"div">;
  title83?: Flex__<"div">;
  item83?: Flex__<"div">;
  left83?: Flex__<"div">;
  icon83?: Flex__<"div">;
  title84?: Flex__<"div">;
  item84?: Flex__<"div">;
  left84?: Flex__<"div">;
  icon84?: Flex__<"div">;
  title85?: Flex__<"div">;
  item85?: Flex__<"div">;
  left85?: Flex__<"div">;
  icon85?: Flex__<"div">;
  title86?: Flex__<"div">;
  item86?: Flex__<"div">;
  left86?: Flex__<"div">;
  icon86?: Flex__<"div">;
  title87?: Flex__<"div">;
  item87?: Flex__<"div">;
  left87?: Flex__<"div">;
  icon87?: Flex__<"div">;
  title88?: Flex__<"div">;
  item88?: Flex__<"div">;
  left88?: Flex__<"div">;
  icon88?: Flex__<"div">;
  title89?: Flex__<"div">;
  item89?: Flex__<"div">;
  left89?: Flex__<"div">;
  icon89?: Flex__<"div">;
  title90?: Flex__<"div">;
  item90?: Flex__<"div">;
  left90?: Flex__<"div">;
  icon90?: Flex__<"div">;
  title91?: Flex__<"div">;
  item91?: Flex__<"div">;
  left91?: Flex__<"div">;
  icon91?: Flex__<"div">;
  title92?: Flex__<"div">;
  item92?: Flex__<"div">;
  left92?: Flex__<"div">;
  icon92?: Flex__<"div">;
  title93?: Flex__<"div">;
  item93?: Flex__<"div">;
  left93?: Flex__<"div">;
  icon93?: Flex__<"div">;
  title94?: Flex__<"div">;
  item94?: Flex__<"div">;
  left94?: Flex__<"div">;
  icon94?: Flex__<"div">;
  title95?: Flex__<"div">;
  item95?: Flex__<"div">;
  left95?: Flex__<"div">;
  icon95?: Flex__<"div">;
  title96?: Flex__<"div">;
  item96?: Flex__<"div">;
  left96?: Flex__<"div">;
  icon96?: Flex__<"div">;
  title97?: Flex__<"div">;
  tablet?: Flex__<"div">;
  row6?: Flex__<"div">;
  key4?: Flex__<"div">;
  header4?: Flex__<"header">;
  list11?: Flex__<"div">;
  row7?: Flex__<"div">;
  row8?: Flex__<"div">;
  row9?: Flex__<"div">;
  row10?: Flex__<"div">;
  row11?: Flex__<"div">;
  all3?: Flex__<"div">;
  title3?: Flex__<"h2">;
  sections3?: Flex__<"div">;
  col8?: Flex__<"div">;
  list12?: Flex__<"div">;
  col9?: Flex__<"div">;
  section5?: Flex__<"div">;
  list13?: Flex__<"div">;
  section6?: Flex__<"div">;
  list14?: Flex__<"div">;
  col10?: Flex__<"div">;
  list15?: Flex__<"div">;
  mobile?: Flex__<"div">;
  header3?: Flex__<"div">;
  key3?: Flex__<"div">;
  header2?: Flex__<"header">;
  list6?: Flex__<"div">;
  all2?: Flex__<"div">;
  title100?: Flex__<"div">;
  sections2?: Flex__<"div">;
  section7?: Flex__<"div">;
  header9?: Flex__<"div">;
  list7?: Flex__<"div">;
  item97?: Flex__<"div">;
  left97?: Flex__<"div">;
  icon97?: Flex__<"div">;
  title2?: Flex__<"div">;
  item98?: Flex__<"div">;
  left98?: Flex__<"div">;
  icon98?: Flex__<"div">;
  title101?: Flex__<"div">;
  item99?: Flex__<"div">;
  left99?: Flex__<"div">;
  icon99?: Flex__<"div">;
  title102?: Flex__<"div">;
  item100?: Flex__<"div">;
  left100?: Flex__<"div">;
  icon100?: Flex__<"div">;
  title103?: Flex__<"div">;
  item101?: Flex__<"div">;
  left101?: Flex__<"div">;
  icon101?: Flex__<"div">;
  title104?: Flex__<"div">;
  item102?: Flex__<"div">;
  left102?: Flex__<"div">;
  icon102?: Flex__<"div">;
  title105?: Flex__<"div">;
  item103?: Flex__<"div">;
  left103?: Flex__<"div">;
  icon103?: Flex__<"div">;
  title106?: Flex__<"div">;
  item104?: Flex__<"div">;
  left104?: Flex__<"div">;
  icon104?: Flex__<"div">;
  title107?: Flex__<"div">;
  item105?: Flex__<"div">;
  left105?: Flex__<"div">;
  icon105?: Flex__<"div">;
  title108?: Flex__<"div">;
  item106?: Flex__<"div">;
  left106?: Flex__<"div">;
  icon106?: Flex__<"div">;
  title109?: Flex__<"div">;
  item107?: Flex__<"div">;
  left107?: Flex__<"div">;
  icon107?: Flex__<"div">;
  title110?: Flex__<"div">;
  item108?: Flex__<"div">;
  left108?: Flex__<"div">;
  icon108?: Flex__<"div">;
  title111?: Flex__<"div">;
  item109?: Flex__<"div">;
  left109?: Flex__<"div">;
  icon109?: Flex__<"div">;
  title112?: Flex__<"div">;
  item110?: Flex__<"div">;
  left110?: Flex__<"div">;
  icon110?: Flex__<"div">;
  title113?: Flex__<"div">;
  item111?: Flex__<"div">;
  left111?: Flex__<"div">;
  icon111?: Flex__<"div">;
  title114?: Flex__<"div">;
  item112?: Flex__<"div">;
  left112?: Flex__<"div">;
  icon112?: Flex__<"div">;
  title115?: Flex__<"div">;
  item113?: Flex__<"div">;
  left113?: Flex__<"div">;
  icon113?: Flex__<"div">;
  title116?: Flex__<"div">;
  item114?: Flex__<"div">;
  left114?: Flex__<"div">;
  icon114?: Flex__<"div">;
  title117?: Flex__<"div">;
  item115?: Flex__<"div">;
  left115?: Flex__<"div">;
  icon115?: Flex__<"div">;
  title118?: Flex__<"div">;
  item116?: Flex__<"div">;
  left116?: Flex__<"div">;
  icon116?: Flex__<"div">;
  title119?: Flex__<"div">;
  item117?: Flex__<"div">;
  left117?: Flex__<"div">;
  icon117?: Flex__<"div">;
  title120?: Flex__<"div">;
  item118?: Flex__<"div">;
  left118?: Flex__<"div">;
  icon118?: Flex__<"div">;
  title121?: Flex__<"div">;
  item119?: Flex__<"div">;
  left119?: Flex__<"div">;
  icon119?: Flex__<"div">;
  title122?: Flex__<"div">;
  item120?: Flex__<"div">;
  left120?: Flex__<"div">;
  icon120?: Flex__<"div">;
  title123?: Flex__<"div">;
  section8?: Flex__<"div">;
  header10?: Flex__<"div">;
  list8?: Flex__<"div">;
  item121?: Flex__<"div">;
  left121?: Flex__<"div">;
  icon121?: Flex__<"div">;
  title124?: Flex__<"div">;
  item122?: Flex__<"div">;
  left122?: Flex__<"div">;
  icon122?: Flex__<"div">;
  title125?: Flex__<"div">;
  item123?: Flex__<"div">;
  left123?: Flex__<"div">;
  icon123?: Flex__<"div">;
  title126?: Flex__<"div">;
  item124?: Flex__<"div">;
  left124?: Flex__<"div">;
  icon124?: Flex__<"div">;
  title127?: Flex__<"div">;
  item125?: Flex__<"div">;
  left125?: Flex__<"div">;
  icon125?: Flex__<"div">;
  title128?: Flex__<"div">;
  item126?: Flex__<"div">;
  left126?: Flex__<"div">;
  icon126?: Flex__<"div">;
  title129?: Flex__<"div">;
  item127?: Flex__<"div">;
  left127?: Flex__<"div">;
  icon127?: Flex__<"div">;
  title130?: Flex__<"div">;
  item128?: Flex__<"div">;
  left128?: Flex__<"div">;
  icon128?: Flex__<"div">;
  title131?: Flex__<"div">;
  item129?: Flex__<"div">;
  left129?: Flex__<"div">;
  icon129?: Flex__<"div">;
  title132?: Flex__<"div">;
  item130?: Flex__<"div">;
  left130?: Flex__<"div">;
  icon130?: Flex__<"div">;
  title133?: Flex__<"div">;
  item131?: Flex__<"div">;
  left131?: Flex__<"div">;
  icon131?: Flex__<"div">;
  title134?: Flex__<"div">;
  item132?: Flex__<"div">;
  left132?: Flex__<"div">;
  icon132?: Flex__<"div">;
  title135?: Flex__<"div">;
  item133?: Flex__<"div">;
  left133?: Flex__<"div">;
  icon133?: Flex__<"div">;
  title136?: Flex__<"div">;
  item134?: Flex__<"div">;
  left134?: Flex__<"div">;
  icon134?: Flex__<"div">;
  title137?: Flex__<"div">;
  item135?: Flex__<"div">;
  left135?: Flex__<"div">;
  icon135?: Flex__<"div">;
  title138?: Flex__<"div">;
  item136?: Flex__<"div">;
  left136?: Flex__<"div">;
  icon136?: Flex__<"div">;
  title139?: Flex__<"div">;
  item137?: Flex__<"div">;
  left137?: Flex__<"div">;
  icon137?: Flex__<"div">;
  title140?: Flex__<"div">;
  item138?: Flex__<"div">;
  left138?: Flex__<"div">;
  icon138?: Flex__<"div">;
  title141?: Flex__<"div">;
  item139?: Flex__<"div">;
  left139?: Flex__<"div">;
  icon139?: Flex__<"div">;
  title142?: Flex__<"div">;
  item140?: Flex__<"div">;
  left140?: Flex__<"div">;
  icon140?: Flex__<"div">;
  title143?: Flex__<"div">;
  item141?: Flex__<"div">;
  left141?: Flex__<"div">;
  icon141?: Flex__<"div">;
  title144?: Flex__<"div">;
  item142?: Flex__<"div">;
  left142?: Flex__<"div">;
  icon142?: Flex__<"div">;
  title145?: Flex__<"div">;
  item143?: Flex__<"div">;
  left143?: Flex__<"div">;
  icon143?: Flex__<"div">;
  title146?: Flex__<"div">;
  item144?: Flex__<"div">;
  left144?: Flex__<"div">;
  icon144?: Flex__<"div">;
  title147?: Flex__<"div">;
  section3?: Flex__<"div">;
  header11?: Flex__<"div">;
  list9?: Flex__<"div">;
  item145?: Flex__<"div">;
  left145?: Flex__<"div">;
  icon145?: Flex__<"div">;
  title148?: Flex__<"div">;
  item146?: Flex__<"div">;
  left146?: Flex__<"div">;
  icon146?: Flex__<"div">;
  title149?: Flex__<"div">;
  item147?: Flex__<"div">;
  left147?: Flex__<"div">;
  icon147?: Flex__<"div">;
  title150?: Flex__<"div">;
  item148?: Flex__<"div">;
  left148?: Flex__<"div">;
  icon148?: Flex__<"div">;
  title151?: Flex__<"div">;
  item149?: Flex__<"div">;
  left149?: Flex__<"div">;
  icon149?: Flex__<"div">;
  title152?: Flex__<"div">;
  item150?: Flex__<"div">;
  left150?: Flex__<"div">;
  icon150?: Flex__<"div">;
  title153?: Flex__<"div">;
  item151?: Flex__<"div">;
  left151?: Flex__<"div">;
  icon151?: Flex__<"div">;
  title154?: Flex__<"div">;
  item152?: Flex__<"div">;
  left152?: Flex__<"div">;
  icon152?: Flex__<"div">;
  title155?: Flex__<"div">;
  item153?: Flex__<"div">;
  left153?: Flex__<"div">;
  icon153?: Flex__<"div">;
  title156?: Flex__<"div">;
  item154?: Flex__<"div">;
  left154?: Flex__<"div">;
  icon154?: Flex__<"div">;
  title157?: Flex__<"div">;
  item155?: Flex__<"div">;
  left155?: Flex__<"div">;
  icon155?: Flex__<"div">;
  title158?: Flex__<"div">;
  item156?: Flex__<"div">;
  left156?: Flex__<"div">;
  icon156?: Flex__<"div">;
  title159?: Flex__<"div">;
  item157?: Flex__<"div">;
  left157?: Flex__<"div">;
  icon157?: Flex__<"div">;
  title160?: Flex__<"div">;
  item158?: Flex__<"div">;
  left158?: Flex__<"div">;
  icon158?: Flex__<"div">;
  title161?: Flex__<"div">;
  item159?: Flex__<"div">;
  left159?: Flex__<"div">;
  icon159?: Flex__<"div">;
  title162?: Flex__<"div">;
  item160?: Flex__<"div">;
  left160?: Flex__<"div">;
  icon160?: Flex__<"div">;
  title163?: Flex__<"div">;
  item161?: Flex__<"div">;
  left161?: Flex__<"div">;
  icon161?: Flex__<"div">;
  title164?: Flex__<"div">;
  item162?: Flex__<"div">;
  left162?: Flex__<"div">;
  icon162?: Flex__<"div">;
  title165?: Flex__<"div">;
  item163?: Flex__<"div">;
  left163?: Flex__<"div">;
  icon163?: Flex__<"div">;
  title166?: Flex__<"div">;
  item164?: Flex__<"div">;
  left164?: Flex__<"div">;
  icon164?: Flex__<"div">;
  title167?: Flex__<"div">;
  item165?: Flex__<"div">;
  left165?: Flex__<"div">;
  icon165?: Flex__<"div">;
  title168?: Flex__<"div">;
  item166?: Flex__<"div">;
  left166?: Flex__<"div">;
  icon166?: Flex__<"div">;
  title169?: Flex__<"div">;
  item167?: Flex__<"div">;
  left167?: Flex__<"div">;
  icon167?: Flex__<"div">;
  title170?: Flex__<"div">;
  item168?: Flex__<"div">;
  left168?: Flex__<"div">;
  icon168?: Flex__<"div">;
  title171?: Flex__<"div">;
  section4?: Flex__<"div">;
  header12?: Flex__<"div">;
  list10?: Flex__<"div">;
  item169?: Flex__<"div">;
  left169?: Flex__<"div">;
  icon169?: Flex__<"div">;
  title172?: Flex__<"div">;
  item170?: Flex__<"div">;
  left170?: Flex__<"div">;
  icon170?: Flex__<"div">;
  title173?: Flex__<"div">;
  item171?: Flex__<"div">;
  left171?: Flex__<"div">;
  icon171?: Flex__<"div">;
  title174?: Flex__<"div">;
  item172?: Flex__<"div">;
  left172?: Flex__<"div">;
  icon172?: Flex__<"div">;
  title175?: Flex__<"div">;
  item173?: Flex__<"div">;
  left173?: Flex__<"div">;
  icon173?: Flex__<"div">;
  title176?: Flex__<"div">;
  item174?: Flex__<"div">;
  left174?: Flex__<"div">;
  icon174?: Flex__<"div">;
  title177?: Flex__<"div">;
  item175?: Flex__<"div">;
  left175?: Flex__<"div">;
  icon175?: Flex__<"div">;
  title178?: Flex__<"div">;
  item176?: Flex__<"div">;
  left176?: Flex__<"div">;
  icon176?: Flex__<"div">;
  title179?: Flex__<"div">;
  item177?: Flex__<"div">;
  left177?: Flex__<"div">;
  icon177?: Flex__<"div">;
  title180?: Flex__<"div">;
  item178?: Flex__<"div">;
  left178?: Flex__<"div">;
  icon178?: Flex__<"div">;
  title181?: Flex__<"div">;
  item179?: Flex__<"div">;
  left179?: Flex__<"div">;
  icon179?: Flex__<"div">;
  title182?: Flex__<"div">;
  item180?: Flex__<"div">;
  left180?: Flex__<"div">;
  icon180?: Flex__<"div">;
  title183?: Flex__<"div">;
  item181?: Flex__<"div">;
  left181?: Flex__<"div">;
  icon181?: Flex__<"div">;
  title184?: Flex__<"div">;
  item182?: Flex__<"div">;
  left182?: Flex__<"div">;
  icon182?: Flex__<"div">;
  title185?: Flex__<"div">;
  item183?: Flex__<"div">;
  left183?: Flex__<"div">;
  icon183?: Flex__<"div">;
  title186?: Flex__<"div">;
  item184?: Flex__<"div">;
  left184?: Flex__<"div">;
  icon184?: Flex__<"div">;
  title187?: Flex__<"div">;
  item185?: Flex__<"div">;
  left185?: Flex__<"div">;
  icon185?: Flex__<"div">;
  title188?: Flex__<"div">;
  item186?: Flex__<"div">;
  left186?: Flex__<"div">;
  icon186?: Flex__<"div">;
  title189?: Flex__<"div">;
  item187?: Flex__<"div">;
  left187?: Flex__<"div">;
  icon187?: Flex__<"div">;
  title190?: Flex__<"div">;
  item188?: Flex__<"div">;
  left188?: Flex__<"div">;
  icon188?: Flex__<"div">;
  title191?: Flex__<"div">;
  item189?: Flex__<"div">;
  left189?: Flex__<"div">;
  icon189?: Flex__<"div">;
  title192?: Flex__<"div">;
  item190?: Flex__<"div">;
  left190?: Flex__<"div">;
  icon190?: Flex__<"div">;
  title193?: Flex__<"div">;
  item191?: Flex__<"div">;
  left191?: Flex__<"div">;
  icon191?: Flex__<"div">;
  title194?: Flex__<"div">;
  item192?: Flex__<"div">;
  left192?: Flex__<"div">;
  icon192?: Flex__<"div">;
  title195?: Flex__<"div">;
};

export interface DefaultFeaturesMyEvaluationsProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesMyEvaluations__RenderFunc(props: {
  variants: PlasmicFeaturesMyEvaluations__VariantsArgs;
  args: PlasmicFeaturesMyEvaluations__ArgsType;
  overrides: PlasmicFeaturesMyEvaluations__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"myEvaluations"}
      data-plasmic-override={overrides.myEvaluations}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.myEvaluations
      )}
      id={"MyEvaluations"}
    >
      {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
        <PlasmicImg__
          alt={""}
          className={classNames(sty.img__pAi5O)}
          displayHeight={"527px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"1770px"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/67f04ddfb024c31590f097503108861e.svg",
            fullWidth: 1770,
            fullHeight: 527,
            aspectRatio: 3.358634
          }}
        />
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? false
            : true
      ) ? (
        <div
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          className={classNames("all", sty.desktop)}
        >
          <div
            data-plasmic-name={"row"}
            data-plasmic-override={overrides.row}
            className={classNames("all", sty.row)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__uSqkg
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            >
              <Logo
                data-plasmic-name={"logo"}
                data-plasmic-override={overrides.logo}
                className={classNames("__wab_instance", sty.logo)}
                product={"myEvaluations"}
              />
            </FeaturesProductHeader>
          </div>
          <div
            data-plasmic-name={"key2"}
            data-plasmic-override={overrides.key2}
            className={classNames("all", sty.key2)}
          >
            <header
              data-plasmic-name={"header"}
              data-plasmic-override={overrides.header}
              className={classNames("all", sty.header)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2___92Hls
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list"}
              data-plasmic-override={overrides.list}
              className={classNames("all", sty.list)}
            >
              <div
                data-plasmic-name={"row2"}
                data-plasmic-override={overrides.row2}
                className={classNames("all", sty.row2)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__gYmKq
                  )}
                  desciption={
                    "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                  }
                  title={"Evaluations, Milestones & EPAs"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__jDttS)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/69de85f9b9c68c24c8ca5311dc63a8f4.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard___74Wv2
                  )}
                  desciption={
                    "Create guided PIPs to proactively identify weaknesses and systematically improve your program. Utilize Clinical Learning Contracts, set for nursing students, to align expectations and facilitate feedback for focused growth."
                  }
                  title={
                    "Performance Improvement Plans & Clinical Learning Contracts"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__quc19)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/ccf489cc6e4dd6d7891ca26ab1aa9d64.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__jUs1H
                  )}
                  desciption={
                    "Create custom curriculum for each rotation consisting of EPAs, evaluations, procedures, learning materials, quizzes, and more. Experience efficient planning, flexibility, and structured pathways for comprehensive and innovative education."
                  }
                  title={"Curriculum Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__qsMQp)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/57568576c4f865353621f436e40045c0.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row3"}
                data-plasmic-override={overrides.row3}
                className={classNames("all", sty.row3)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__avF8
                  )}
                  desciption={
                    "Stay on top of tasks, messages, and schedules. Ensure staff and students stay compliant effortlessly. Analyze individual academic performance, identify achievements and areas for improvement. Compare to benchmarks, and set improvement plans."
                  }
                  title={"Educational Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__wXnn2)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/0fdfef14aa9342c9451f04c9e0d2b0f0.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__g3HJb
                  )}
                  desciption={
                    "Fulfill ACGME requirements using Annual Program Evaluations. Streamline monitoring to ensure your program consistently meets high standards. Gain insights and strategic oversight to elevate program reputation. "
                  }
                  title={"ACGME Compliance Tracking"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__eYfc)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/7fb7d351803b5f40669e1b01fbd0693b.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard___0PREf
                  )}
                  desciption={
                    "Simplify onboarding and credentialing for new trainees. Print certificates and diplomas effortlessly. Manage ERAS data with accuracy. Streamline contract management with electronic signatures."
                  }
                  title={"Administrative Tools"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___8A12H)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/0e42d0298ff99dc0a5c2e5541534e537.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row4"}
                data-plasmic-override={overrides.row4}
                className={classNames("all", sty.row4)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__cGbli
                  )}
                  desciption={
                    "Enhance training with accurate logs of procedural skills and patient encounters. Turn every clinical activity into a learning opportunity, ensuring a comprehensive educational experience."
                  }
                  title={"Procedure & Patient Logging"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__or2A9)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/35855286a3c25fe56cbcd38d6817476d.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__iKKzg
                  )}
                  desciption={
                    "Effortlessly manage GME schedules with built-in MySchedule module. Sync with AMION, QGenda, Momentum. Simplify clinical hour tracking with MyQuickPass. Streamline workflow, stay informed with instant updates."
                  }
                  title={"Scheduling & Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__xLsj)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/7bf18a5993f775a256528457d410d589.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__jzGAk
                  )}
                  desciption={
                    "Tailor tasks, diverse materials for student engagement. Assess with interactive quizzes, focusing on meaningful learning, knowledge retention, and efficient exam creation. Get valuable performance feedback."
                  }
                  title={"MyQuiz & Learning Assignments"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___8JUpx)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/1ff4688848589b8f499d76d1b3aeac64.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"all"}
            data-plasmic-override={overrides.all}
            className={classNames("all", sty.all)}
          >
            <div
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames("all", "__wab_text", sty.title)}
            >
              {"Full Feature List"}
            </div>
            <div
              data-plasmic-name={"sections"}
              data-plasmic-override={overrides.sections}
              className={classNames("all", sty.sections)}
            >
              <div
                data-plasmic-name={"col"}
                data-plasmic-override={overrides.col}
                className={classNames("all", sty.col)}
              >
                <div
                  data-plasmic-name={"header5"}
                  data-plasmic-override={overrides.header5}
                  className={classNames("all", "__wab_text", sty.header5)}
                >
                  {"All Use Cases"}
                </div>
                <div
                  data-plasmic-name={"list5"}
                  data-plasmic-override={overrides.list5}
                  className={classNames("all", sty.list5)}
                >
                  <div
                    data-plasmic-name={"item"}
                    data-plasmic-override={overrides.item}
                    className={classNames("all", sty.item)}
                  >
                    <div
                      data-plasmic-name={"left"}
                      data-plasmic-override={overrides.left}
                      className={classNames("all", sty.left)}
                    >
                      <div
                        data-plasmic-name={"icon"}
                        data-plasmic-override={overrides.icon}
                        className={classNames("all", sty.icon)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__ppeZb)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title98"}
                      data-plasmic-override={overrides.title98}
                      className={classNames("all", "__wab_text", sty.title98)}
                    >
                      {"Evaluations/Assessments"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item2"}
                    data-plasmic-override={overrides.item2}
                    className={classNames("all", sty.item2)}
                  >
                    <div
                      data-plasmic-name={"left2"}
                      data-plasmic-override={overrides.left2}
                      className={classNames("all", sty.left2)}
                    >
                      <div
                        data-plasmic-name={"icon2"}
                        data-plasmic-override={overrides.icon2}
                        className={classNames("all", sty.icon2)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___93Lt)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title99"}
                      data-plasmic-override={overrides.title99}
                      className={classNames("all", "__wab_text", sty.title99)}
                    >
                      {"MyInsight"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item3"}
                    data-plasmic-override={overrides.item3}
                    className={classNames("all", sty.item3)}
                  >
                    <div
                      data-plasmic-name={"left3"}
                      data-plasmic-override={overrides.left3}
                      className={classNames("all", sty.left3)}
                    >
                      <div
                        data-plasmic-name={"icon3"}
                        data-plasmic-override={overrides.icon3}
                        className={classNames("all", sty.icon3)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__pmkmx)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title4"}
                      data-plasmic-override={overrides.title4}
                      className={classNames("all", "__wab_text", sty.title4)}
                    >
                      {"Milestones & EPAs"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item4"}
                    data-plasmic-override={overrides.item4}
                    className={classNames("all", sty.item4)}
                  >
                    <div
                      data-plasmic-name={"left4"}
                      data-plasmic-override={overrides.left4}
                      className={classNames("all", sty.left4)}
                    >
                      <div
                        data-plasmic-name={"icon4"}
                        data-plasmic-override={overrides.icon4}
                        className={classNames("all", sty.icon4)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___5PCmV)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title5"}
                      data-plasmic-override={overrides.title5}
                      className={classNames("all", "__wab_text", sty.title5)}
                    >
                      {"Performance Improvement Plans"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item5"}
                    data-plasmic-override={overrides.item5}
                    className={classNames("all", sty.item5)}
                  >
                    <div
                      data-plasmic-name={"left5"}
                      data-plasmic-override={overrides.left5}
                      className={classNames("all", sty.left5)}
                    >
                      <div
                        data-plasmic-name={"icon5"}
                        data-plasmic-override={overrides.icon5}
                        className={classNames("all", sty.icon5)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__aa1Cp)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title6"}
                      data-plasmic-override={overrides.title6}
                      className={classNames("all", "__wab_text", sty.title6)}
                    >
                      {"Clinical Hours and MyQuickPass"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item6"}
                      data-plasmic-override={overrides.item6}
                      className={classNames("all", sty.item6)}
                    >
                      <div
                        data-plasmic-name={"left6"}
                        data-plasmic-override={overrides.left6}
                        className={classNames("all", sty.left6)}
                      >
                        <div
                          data-plasmic-name={"icon6"}
                          data-plasmic-override={overrides.icon6}
                          className={classNames("all", sty.icon6)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__wO4B1)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title7"}
                        data-plasmic-override={overrides.title7}
                        className={classNames("all", "__wab_text", sty.title7)}
                      >
                        {"MyQuickPass"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"item7"}
                    data-plasmic-override={overrides.item7}
                    className={classNames("all", sty.item7)}
                  >
                    <div
                      data-plasmic-name={"left7"}
                      data-plasmic-override={overrides.left7}
                      className={classNames("all", sty.left7)}
                    >
                      <div
                        data-plasmic-name={"icon7"}
                        data-plasmic-override={overrides.icon7}
                        className={classNames("all", sty.icon7)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__oHztp)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title8"}
                      data-plasmic-override={overrides.title8}
                      className={classNames("all", "__wab_text", sty.title8)}
                    >
                      {"Conference Tracking"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item8"}
                    data-plasmic-override={overrides.item8}
                    className={classNames("all", sty.item8)}
                  >
                    <div
                      data-plasmic-name={"left8"}
                      data-plasmic-override={overrides.left8}
                      className={classNames("all", sty.left8)}
                    >
                      <div
                        data-plasmic-name={"icon8"}
                        data-plasmic-override={overrides.icon8}
                        className={classNames("all", sty.icon8)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___6ZOv5)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title9"}
                      data-plasmic-override={overrides.title9}
                      className={classNames("all", "__wab_text", sty.title9)}
                    >
                      {"Burnout Monitoring"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item9"}
                      data-plasmic-override={overrides.item9}
                      className={classNames("all", sty.item9)}
                    >
                      <div
                        data-plasmic-name={"left9"}
                        data-plasmic-override={overrides.left9}
                        className={classNames("all", sty.left9)}
                      >
                        <div
                          data-plasmic-name={"icon9"}
                          data-plasmic-override={overrides.icon9}
                          className={classNames("all", sty.icon9)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__pmAlU)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title10"}
                        data-plasmic-override={overrides.title10}
                        className={classNames("all", "__wab_text", sty.title10)}
                      >
                        {"EHR Connectivity under HME Programs"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item10"}
                      data-plasmic-override={overrides.item10}
                      className={classNames("all", sty.item10)}
                    >
                      <div
                        data-plasmic-name={"left10"}
                        data-plasmic-override={overrides.left10}
                        className={classNames("all", sty.left10)}
                      >
                        <div
                          data-plasmic-name={"icon10"}
                          data-plasmic-override={overrides.icon10}
                          className={classNames("all", sty.icon10)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__w2QL4)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title11"}
                        data-plasmic-override={overrides.title11}
                        className={classNames("all", "__wab_text", sty.title11)}
                      >
                        {"Clinical Log (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"item11"}
                    data-plasmic-override={overrides.item11}
                    className={classNames("all", sty.item11)}
                  >
                    <div
                      data-plasmic-name={"left11"}
                      data-plasmic-override={overrides.left11}
                      className={classNames("all", sty.left11)}
                    >
                      <div
                        data-plasmic-name={"icon11"}
                        data-plasmic-override={overrides.icon11}
                        className={classNames("all", sty.icon11)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__qbQyi)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title12"}
                      data-plasmic-override={overrides.title12}
                      className={classNames("all", "__wab_text", sty.title12)}
                    >
                      {"Learning Assignments"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item12"}
                    data-plasmic-override={overrides.item12}
                    className={classNames("all", sty.item12)}
                  >
                    <div
                      data-plasmic-name={"left12"}
                      data-plasmic-override={overrides.left12}
                      className={classNames("all", sty.left12)}
                    >
                      <div
                        data-plasmic-name={"icon12"}
                        data-plasmic-override={overrides.icon12}
                        className={classNames("all", sty.icon12)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__gwReE)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title13"}
                      data-plasmic-override={overrides.title13}
                      className={classNames("all", "__wab_text", sty.title13)}
                    >
                      {"MyQuiz (Quizzes/Exams)"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item13"}
                    data-plasmic-override={overrides.item13}
                    className={classNames("all", sty.item13)}
                  >
                    <div
                      data-plasmic-name={"left13"}
                      data-plasmic-override={overrides.left13}
                      className={classNames("all", sty.left13)}
                    >
                      <div
                        data-plasmic-name={"icon13"}
                        data-plasmic-override={overrides.icon13}
                        className={classNames("all", sty.icon13)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__p7Mf4)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title14"}
                      data-plasmic-override={overrides.title14}
                      className={classNames("all", "__wab_text", sty.title14)}
                    >
                      {"Demographic Management"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item14"}
                    data-plasmic-override={overrides.item14}
                    className={classNames("all", sty.item14)}
                  >
                    <div
                      data-plasmic-name={"left14"}
                      data-plasmic-override={overrides.left14}
                      className={classNames("all", sty.left14)}
                    >
                      <div
                        data-plasmic-name={"icon14"}
                        data-plasmic-override={overrides.icon14}
                        className={classNames("all", sty.icon14)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__vwEh0)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title15"}
                      data-plasmic-override={overrides.title15}
                      className={classNames("all", "__wab_text", sty.title15)}
                    >
                      {"Onboarding & Credentialing"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item15"}
                    data-plasmic-override={overrides.item15}
                    className={classNames("all", sty.item15)}
                  >
                    <div
                      data-plasmic-name={"left15"}
                      data-plasmic-override={overrides.left15}
                      className={classNames("all", sty.left15)}
                    >
                      <div
                        data-plasmic-name={"icon15"}
                        data-plasmic-override={overrides.icon15}
                        className={classNames("all", sty.icon15)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__yt9WR)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title16"}
                      data-plasmic-override={overrides.title16}
                      className={classNames("all", "__wab_text", sty.title16)}
                    >
                      {"Certificate/Diploma Management"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item16"}
                      data-plasmic-override={overrides.item16}
                      className={classNames("all", sty.item16)}
                    >
                      <div
                        data-plasmic-name={"left16"}
                        data-plasmic-override={overrides.left16}
                        className={classNames("all", sty.left16)}
                      >
                        <div
                          data-plasmic-name={"icon16"}
                          data-plasmic-override={overrides.icon16}
                          className={classNames("all", sty.icon16)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___05HQq)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title17"}
                        data-plasmic-override={overrides.title17}
                        className={classNames("all", "__wab_text", sty.title17)}
                      >
                        {"Schedule Management"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"item17"}
                    data-plasmic-override={overrides.item17}
                    className={classNames("all", sty.item17)}
                  >
                    <div
                      data-plasmic-name={"left17"}
                      data-plasmic-override={overrides.left17}
                      className={classNames("all", sty.left17)}
                    >
                      <div
                        data-plasmic-name={"icon17"}
                        data-plasmic-override={overrides.icon17}
                        className={classNames("all", sty.icon17)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__cqFuu)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title18"}
                      data-plasmic-override={overrides.title18}
                      className={classNames("all", "__wab_text", sty.title18)}
                    >
                      {"Automatic Scheduling & Lottery"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item18"}
                    data-plasmic-override={overrides.item18}
                    className={classNames("all", sty.item18)}
                  >
                    <div
                      data-plasmic-name={"left18"}
                      data-plasmic-override={overrides.left18}
                      className={classNames("all", sty.left18)}
                    >
                      <div
                        data-plasmic-name={"icon18"}
                        data-plasmic-override={overrides.icon18}
                        className={classNames("all", sty.icon18)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__xTMx7)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title19"}
                      data-plasmic-override={overrides.title19}
                      className={classNames("all", "__wab_text", sty.title19)}
                    >
                      {"Schedule (3rd Party) Integration"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item19"}
                    data-plasmic-override={overrides.item19}
                    className={classNames("all", sty.item19)}
                  >
                    <div
                      data-plasmic-name={"left19"}
                      data-plasmic-override={overrides.left19}
                      className={classNames("all", sty.left19)}
                    >
                      <div
                        data-plasmic-name={"icon19"}
                        data-plasmic-override={overrides.icon19}
                        className={classNames("all", sty.icon19)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__q13OX)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title20"}
                      data-plasmic-override={overrides.title20}
                      className={classNames("all", "__wab_text", sty.title20)}
                    >
                      {"MyPortfolios"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item20"}
                    data-plasmic-override={overrides.item20}
                    className={classNames("all", sty.item20)}
                  >
                    <div
                      data-plasmic-name={"left20"}
                      data-plasmic-override={overrides.left20}
                      className={classNames("all", sty.left20)}
                    >
                      <div
                        data-plasmic-name={"icon20"}
                        data-plasmic-override={overrides.icon20}
                        className={classNames("all", sty.icon20)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___2FZm1)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title21"}
                      data-plasmic-override={overrides.title21}
                      className={classNames("all", "__wab_text", sty.title21)}
                    >
                      {"Performance Dashboard"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item21"}
                      data-plasmic-override={overrides.item21}
                      className={classNames("all", sty.item21)}
                    >
                      <div
                        data-plasmic-name={"left21"}
                        data-plasmic-override={overrides.left21}
                        className={classNames("all", sty.left21)}
                      >
                        <div
                          data-plasmic-name={"icon21"}
                          data-plasmic-override={overrides.icon21}
                          className={classNames("all", sty.icon21)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__jlrEd)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title22"}
                        data-plasmic-override={overrides.title22}
                        className={classNames("all", "__wab_text", sty.title22)}
                      >
                        {"Custom Reporting"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item22"}
                      data-plasmic-override={overrides.item22}
                      className={classNames("all", sty.item22)}
                    >
                      <div
                        data-plasmic-name={"left22"}
                        data-plasmic-override={overrides.left22}
                        className={classNames("all", sty.left22)}
                      >
                        <div
                          data-plasmic-name={"icon22"}
                          data-plasmic-override={overrides.icon22}
                          className={classNames("all", sty.icon22)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__xWyhy)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title23"}
                        data-plasmic-override={overrides.title23}
                        className={classNames("all", "__wab_text", sty.title23)}
                      >
                        {"Electronic Contracts & Signatures"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item23"}
                      data-plasmic-override={overrides.item23}
                      className={classNames("all", sty.item23)}
                    >
                      <div
                        data-plasmic-name={"left23"}
                        data-plasmic-override={overrides.left23}
                        className={classNames("all", sty.left23)}
                      >
                        <div
                          data-plasmic-name={"icon23"}
                          data-plasmic-override={overrides.icon23}
                          className={classNames("all", sty.icon23)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__uYy8O)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title24"}
                        data-plasmic-override={overrides.title24}
                        className={classNames("all", "__wab_text", sty.title24)}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item24"}
                      data-plasmic-override={overrides.item24}
                      className={classNames("all", sty.item24)}
                    >
                      <div
                        data-plasmic-name={"left24"}
                        data-plasmic-override={overrides.left24}
                        className={classNames("all", sty.left24)}
                      >
                        <div
                          data-plasmic-name={"icon24"}
                          data-plasmic-override={overrides.icon24}
                          className={classNames("all", sty.icon24)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__crYwy)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title25"}
                        data-plasmic-override={overrides.title25}
                        className={classNames("all", "__wab_text", sty.title25)}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                data-plasmic-name={"col2"}
                data-plasmic-override={overrides.col2}
                className={classNames("all", sty.col2)}
              >
                <div
                  data-plasmic-name={"section"}
                  data-plasmic-override={overrides.section}
                  className={classNames("all", sty.section)}
                >
                  <div
                    data-plasmic-name={"header6"}
                    data-plasmic-override={overrides.header6}
                    className={classNames("all", "__wab_text", sty.header6)}
                  >
                    {"GME & Physician Assistant Programs "}
                  </div>
                  <div
                    data-plasmic-name={"list2"}
                    data-plasmic-override={overrides.list2}
                    className={classNames("all", sty.list2)}
                  >
                    <div
                      data-plasmic-name={"item25"}
                      data-plasmic-override={overrides.item25}
                      className={classNames("all", sty.item25)}
                    >
                      <div
                        data-plasmic-name={"left25"}
                        data-plasmic-override={overrides.left25}
                        className={classNames("all", sty.left25)}
                      >
                        <div
                          data-plasmic-name={"icon25"}
                          data-plasmic-override={overrides.icon25}
                          className={classNames("all", sty.icon25)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__zS5EY)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title26"}
                        data-plasmic-override={overrides.title26}
                        className={classNames("all", "__wab_text", sty.title26)}
                      >
                        {"Curriculum Management"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item26"}
                      data-plasmic-override={overrides.item26}
                      className={classNames("all", sty.item26)}
                    >
                      <div
                        data-plasmic-name={"left26"}
                        data-plasmic-override={overrides.left26}
                        className={classNames("all", sty.left26)}
                      >
                        <div
                          data-plasmic-name={"icon26"}
                          data-plasmic-override={overrides.icon26}
                          className={classNames("all", sty.icon26)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__svi3J)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title27"}
                        data-plasmic-override={overrides.title27}
                        className={classNames("all", "__wab_text", sty.title27)}
                      >
                        {"Procedure Logging"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item27"}
                      data-plasmic-override={overrides.item27}
                      className={classNames("all", sty.item27)}
                    >
                      <div
                        data-plasmic-name={"left27"}
                        data-plasmic-override={overrides.left27}
                        className={classNames("all", sty.left27)}
                      >
                        <div
                          data-plasmic-name={"icon27"}
                          data-plasmic-override={overrides.icon27}
                          className={classNames("all", sty.icon27)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___8Yo6)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title28"}
                        data-plasmic-override={overrides.title28}
                        className={classNames("all", "__wab_text", sty.title28)}
                      >
                        {"Patient Logging"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item28"}
                      data-plasmic-override={overrides.item28}
                      className={classNames("all", sty.item28)}
                    >
                      <div
                        data-plasmic-name={"left28"}
                        data-plasmic-override={overrides.left28}
                        className={classNames("all", sty.left28)}
                      >
                        <div
                          data-plasmic-name={"icon28"}
                          data-plasmic-override={overrides.icon28}
                          className={classNames("all", sty.icon28)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__uqzVj)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title29"}
                        data-plasmic-override={overrides.title29}
                        className={classNames("all", "__wab_text", sty.title29)}
                      >
                        {"Centralized Procedure Reporting"}
                      </div>
                    </div>
                    {false ? (
                      <div
                        data-plasmic-name={"item29"}
                        data-plasmic-override={overrides.item29}
                        className={classNames("all", sty.item29)}
                      >
                        <div
                          data-plasmic-name={"left29"}
                          data-plasmic-override={overrides.left29}
                          className={classNames("all", sty.left29)}
                        >
                          <div
                            data-plasmic-name={"icon29"}
                            data-plasmic-override={overrides.icon29}
                            className={classNames("all", sty.icon29)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__ldyZz)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title30"}
                          data-plasmic-override={overrides.title30}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title30
                          )}
                        >
                          {"Clinical Hours (Duty-Hours)"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item30"}
                        data-plasmic-override={overrides.item30}
                        className={classNames("all", sty.item30)}
                      >
                        <div
                          data-plasmic-name={"left30"}
                          data-plasmic-override={overrides.left30}
                          className={classNames("all", sty.left30)}
                        >
                          <div
                            data-plasmic-name={"icon30"}
                            data-plasmic-override={overrides.icon30}
                            className={classNames("all", sty.icon30)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__sh9H)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title31"}
                          data-plasmic-override={overrides.title31}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title31
                          )}
                        >
                          {"MyQuickPass"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item31"}
                        data-plasmic-override={overrides.item31}
                        className={classNames("all", sty.item31)}
                      >
                        <div
                          data-plasmic-name={"left31"}
                          data-plasmic-override={overrides.left31}
                          className={classNames("all", sty.left31)}
                        >
                          <div
                            data-plasmic-name={"icon31"}
                            data-plasmic-override={overrides.icon31}
                            className={classNames("all", sty.icon31)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__el0NQ)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title32"}
                          data-plasmic-override={overrides.title32}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title32
                          )}
                        >
                          {"Conference Tracking"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item32"}
                        data-plasmic-override={overrides.item32}
                        className={classNames("all", sty.item32)}
                      >
                        <div
                          data-plasmic-name={"left32"}
                          data-plasmic-override={overrides.left32}
                          className={classNames("all", sty.left32)}
                        >
                          <div
                            data-plasmic-name={"icon32"}
                            data-plasmic-override={overrides.icon32}
                            className={classNames("all", sty.icon32)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___59Zh6)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title33"}
                          data-plasmic-override={overrides.title33}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title33
                          )}
                        >
                          {"Burnout Monitoring"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item33"}
                        data-plasmic-override={overrides.item33}
                        className={classNames("all", sty.item33)}
                      >
                        <div
                          data-plasmic-name={"left33"}
                          data-plasmic-override={overrides.left33}
                          className={classNames("all", sty.left33)}
                        >
                          <div
                            data-plasmic-name={"icon33"}
                            data-plasmic-override={overrides.icon33}
                            className={classNames("all", sty.icon33)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___3Jute)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title34"}
                          data-plasmic-override={overrides.title34}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title34
                          )}
                        >
                          {"EHR Connectivity"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item34"}
                        data-plasmic-override={overrides.item34}
                        className={classNames("all", sty.item34)}
                      >
                        <div
                          data-plasmic-name={"left34"}
                          data-plasmic-override={overrides.left34}
                          className={classNames("all", sty.left34)}
                        >
                          <div
                            data-plasmic-name={"icon34"}
                            data-plasmic-override={overrides.icon34}
                            className={classNames("all", sty.icon34)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___2Fi)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title35"}
                          data-plasmic-override={overrides.title35}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title35
                          )}
                        >
                          {"Clinical Log (3rd Party) Integration"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item35"}
                        data-plasmic-override={overrides.item35}
                        className={classNames("all", sty.item35)}
                      >
                        <div
                          data-plasmic-name={"left35"}
                          data-plasmic-override={overrides.left35}
                          className={classNames("all", sty.left35)}
                        >
                          <div
                            data-plasmic-name={"icon35"}
                            data-plasmic-override={overrides.icon35}
                            className={classNames("all", sty.icon35)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__hlKmw)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title36"}
                          data-plasmic-override={overrides.title36}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title36
                          )}
                        >
                          {"Learning Assignments"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item36"}
                        data-plasmic-override={overrides.item36}
                        className={classNames("all", sty.item36)}
                      >
                        <div
                          data-plasmic-name={"left36"}
                          data-plasmic-override={overrides.left36}
                          className={classNames("all", sty.left36)}
                        >
                          <div
                            data-plasmic-name={"icon36"}
                            data-plasmic-override={overrides.icon36}
                            className={classNames("all", sty.icon36)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___8CtD)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title37"}
                          data-plasmic-override={overrides.title37}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title37
                          )}
                        >
                          {"MyQuiz (Quizzes/Exams)"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item37"}
                        data-plasmic-override={overrides.item37}
                        className={classNames("all", sty.item37)}
                      >
                        <div
                          data-plasmic-name={"left37"}
                          data-plasmic-override={overrides.left37}
                          className={classNames("all", sty.left37)}
                        >
                          <div
                            data-plasmic-name={"icon37"}
                            data-plasmic-override={overrides.icon37}
                            className={classNames("all", sty.icon37)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__cW6Uf)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title38"}
                          data-plasmic-override={overrides.title38}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title38
                          )}
                        >
                          {"Demographic Management"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item38"}
                        data-plasmic-override={overrides.item38}
                        className={classNames("all", sty.item38)}
                      >
                        <div
                          data-plasmic-name={"left38"}
                          data-plasmic-override={overrides.left38}
                          className={classNames("all", sty.left38)}
                        >
                          <div
                            data-plasmic-name={"icon38"}
                            data-plasmic-override={overrides.icon38}
                            className={classNames("all", sty.icon38)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__lPKw0)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title39"}
                          data-plasmic-override={overrides.title39}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title39
                          )}
                        >
                          {"Onboarding & Credentialing"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item39"}
                        data-plasmic-override={overrides.item39}
                        className={classNames("all", sty.item39)}
                      >
                        <div
                          data-plasmic-name={"left39"}
                          data-plasmic-override={overrides.left39}
                          className={classNames("all", sty.left39)}
                        >
                          <div
                            data-plasmic-name={"icon39"}
                            data-plasmic-override={overrides.icon39}
                            className={classNames("all", sty.icon39)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__kRl0)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title40"}
                          data-plasmic-override={overrides.title40}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title40
                          )}
                        >
                          {"Certificate/Diploma Management"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item40"}
                        data-plasmic-override={overrides.item40}
                        className={classNames("all", sty.item40)}
                      >
                        <div
                          data-plasmic-name={"left40"}
                          data-plasmic-override={overrides.left40}
                          className={classNames("all", sty.left40)}
                        >
                          <div
                            data-plasmic-name={"icon40"}
                            data-plasmic-override={overrides.icon40}
                            className={classNames("all", sty.icon40)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___9Zy4S)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title41"}
                          data-plasmic-override={overrides.title41}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title41
                          )}
                        >
                          {"Schedule Management"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item41"}
                        data-plasmic-override={overrides.item41}
                        className={classNames("all", sty.item41)}
                      >
                        <div
                          data-plasmic-name={"left41"}
                          data-plasmic-override={overrides.left41}
                          className={classNames("all", sty.left41)}
                        >
                          <div
                            data-plasmic-name={"icon41"}
                            data-plasmic-override={overrides.icon41}
                            className={classNames("all", sty.icon41)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___4HoeB)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title42"}
                          data-plasmic-override={overrides.title42}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title42
                          )}
                        >
                          {"Automatic Scheduling & Lottery"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item42"}
                        data-plasmic-override={overrides.item42}
                        className={classNames("all", sty.item42)}
                      >
                        <div
                          data-plasmic-name={"left42"}
                          data-plasmic-override={overrides.left42}
                          className={classNames("all", sty.left42)}
                        >
                          <div
                            data-plasmic-name={"icon42"}
                            data-plasmic-override={overrides.icon42}
                            className={classNames("all", sty.icon42)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__k6Kji)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title43"}
                          data-plasmic-override={overrides.title43}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title43
                          )}
                        >
                          {"Schedule (3rd Party) Integration"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item43"}
                        data-plasmic-override={overrides.item43}
                        className={classNames("all", sty.item43)}
                      >
                        <div
                          data-plasmic-name={"left43"}
                          data-plasmic-override={overrides.left43}
                          className={classNames("all", sty.left43)}
                        >
                          <div
                            data-plasmic-name={"icon43"}
                            data-plasmic-override={overrides.icon43}
                            className={classNames("all", sty.icon43)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___5H3H5)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title44"}
                          data-plasmic-override={overrides.title44}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title44
                          )}
                        >
                          {"MyPortfolios"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item44"}
                        data-plasmic-override={overrides.item44}
                        className={classNames("all", sty.item44)}
                      >
                        <div
                          data-plasmic-name={"left44"}
                          data-plasmic-override={overrides.left44}
                          className={classNames("all", sty.left44)}
                        >
                          <div
                            data-plasmic-name={"icon44"}
                            data-plasmic-override={overrides.icon44}
                            className={classNames("all", sty.icon44)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__njTji)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title45"}
                          data-plasmic-override={overrides.title45}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title45
                          )}
                        >
                          {"Performance Dashboard"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item45"}
                        data-plasmic-override={overrides.item45}
                        className={classNames("all", sty.item45)}
                      >
                        <div
                          data-plasmic-name={"left45"}
                          data-plasmic-override={overrides.left45}
                          className={classNames("all", sty.left45)}
                        >
                          <div
                            data-plasmic-name={"icon45"}
                            data-plasmic-override={overrides.icon45}
                            className={classNames("all", sty.icon45)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___7IpGn)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title46"}
                          data-plasmic-override={overrides.title46}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title46
                          )}
                        >
                          {"Custom Reporting"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item46"}
                        data-plasmic-override={overrides.item46}
                        className={classNames("all", sty.item46)}
                      >
                        <div
                          data-plasmic-name={"left46"}
                          data-plasmic-override={overrides.left46}
                          className={classNames("all", sty.left46)}
                        >
                          <div
                            data-plasmic-name={"icon46"}
                            data-plasmic-override={overrides.icon46}
                            className={classNames("all", sty.icon46)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__dNwVx)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title47"}
                          data-plasmic-override={overrides.title47}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title47
                          )}
                        >
                          {"Electronic Contracts & Signatures"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item47"}
                        data-plasmic-override={overrides.item47}
                        className={classNames("all", sty.item47)}
                      >
                        <div
                          data-plasmic-name={"left47"}
                          data-plasmic-override={overrides.left47}
                          className={classNames("all", sty.left47)}
                        >
                          <div
                            data-plasmic-name={"icon47"}
                            data-plasmic-override={overrides.icon47}
                            className={classNames("all", sty.icon47)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__nAuS7)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title48"}
                          data-plasmic-override={overrides.title48}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title48
                          )}
                        >
                          {"Feature Item"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item48"}
                        data-plasmic-override={overrides.item48}
                        className={classNames("all", sty.item48)}
                      >
                        <div
                          data-plasmic-name={"left48"}
                          data-plasmic-override={overrides.left48}
                          className={classNames("all", sty.left48)}
                        >
                          <div
                            data-plasmic-name={"icon48"}
                            data-plasmic-override={overrides.icon48}
                            className={classNames("all", sty.icon48)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__tmpzs)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title49"}
                          data-plasmic-override={overrides.title49}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title49
                          )}
                        >
                          {"Feature Item"}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"section2"}
                  data-plasmic-override={overrides.section2}
                  className={classNames("all", sty.section2)}
                >
                  <div
                    data-plasmic-name={"header7"}
                    data-plasmic-override={overrides.header7}
                    className={classNames("all", "__wab_text", sty.header7)}
                  >
                    {"GME Programs"}
                  </div>
                  <div
                    data-plasmic-name={"list3"}
                    data-plasmic-override={overrides.list3}
                    className={classNames("all", sty.list3)}
                  >
                    <div
                      data-plasmic-name={"item49"}
                      data-plasmic-override={overrides.item49}
                      className={classNames("all", sty.item49)}
                    >
                      <div
                        data-plasmic-name={"left49"}
                        data-plasmic-override={overrides.left49}
                        className={classNames("all", sty.left49)}
                      >
                        <div
                          data-plasmic-name={"icon49"}
                          data-plasmic-override={overrides.icon49}
                          className={classNames("all", sty.icon49)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__jc0Le)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title50"}
                        data-plasmic-override={overrides.title50}
                        className={classNames("all", "__wab_text", sty.title50)}
                      >
                        {"Annual Program Evaluations"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item50"}
                      data-plasmic-override={overrides.item50}
                      className={classNames("all", sty.item50)}
                    >
                      <div
                        data-plasmic-name={"left50"}
                        data-plasmic-override={overrides.left50}
                        className={classNames("all", sty.left50)}
                      >
                        <div
                          data-plasmic-name={"icon50"}
                          data-plasmic-override={overrides.icon50}
                          className={classNames("all", sty.icon50)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__k1N2B)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title51"}
                        data-plasmic-override={overrides.title51}
                        className={classNames("all", "__wab_text", sty.title51)}
                      >
                        {"Common Program Requirements"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item51"}
                      data-plasmic-override={overrides.item51}
                      className={classNames("all", sty.item51)}
                    >
                      <div
                        data-plasmic-name={"left51"}
                        data-plasmic-override={overrides.left51}
                        className={classNames("all", sty.left51)}
                      >
                        <div
                          data-plasmic-name={"icon51"}
                          data-plasmic-override={overrides.icon51}
                          className={classNames("all", sty.icon51)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__gk8Rq)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title52"}
                        data-plasmic-override={overrides.title52}
                        className={classNames("all", "__wab_text", sty.title52)}
                      >
                        {"Institutional Requirements"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item52"}
                      data-plasmic-override={overrides.item52}
                      className={classNames("all", sty.item52)}
                    >
                      <div
                        data-plasmic-name={"left52"}
                        data-plasmic-override={overrides.left52}
                        className={classNames("all", sty.left52)}
                      >
                        <div
                          data-plasmic-name={"icon52"}
                          data-plasmic-override={overrides.icon52}
                          className={classNames("all", sty.icon52)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___2TOu8)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title53"}
                        data-plasmic-override={overrides.title53}
                        className={classNames("all", "__wab_text", sty.title53)}
                      >
                        {"Take Action Plans & Notifications"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item53"}
                      data-plasmic-override={overrides.item53}
                      className={classNames("all", sty.item53)}
                    >
                      <div
                        data-plasmic-name={"left53"}
                        data-plasmic-override={overrides.left53}
                        className={classNames("all", sty.left53)}
                      >
                        <div
                          data-plasmic-name={"icon53"}
                          data-plasmic-override={overrides.icon53}
                          className={classNames("all", sty.icon53)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__uft4L)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title54"}
                        data-plasmic-override={overrides.title54}
                        className={classNames("all", "__wab_text", sty.title54)}
                      >
                        {"ERAS Data Importing"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item54"}
                      data-plasmic-override={overrides.item54}
                      className={classNames("all", sty.item54)}
                    >
                      <div
                        data-plasmic-name={"left54"}
                        data-plasmic-override={overrides.left54}
                        className={classNames("all", sty.left54)}
                      >
                        <div
                          data-plasmic-name={"icon54"}
                          data-plasmic-override={overrides.icon54}
                          className={classNames("all", sty.icon54)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__hFBtH)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title55"}
                        data-plasmic-override={overrides.title55}
                        className={classNames("all", "__wab_text", sty.title55)}
                      >
                        {"Electronic Contract Management"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item55"}
                      data-plasmic-override={overrides.item55}
                      className={classNames("all", sty.item55)}
                    >
                      <div
                        data-plasmic-name={"left55"}
                        data-plasmic-override={overrides.left55}
                        className={classNames("all", sty.left55)}
                      >
                        <div
                          data-plasmic-name={"icon55"}
                          data-plasmic-override={overrides.icon55}
                          className={classNames("all", sty.icon55)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___5I3Po)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title56"}
                        data-plasmic-override={overrides.title56}
                        className={classNames("all", "__wab_text", sty.title56)}
                      >
                        {"Clinical Log (3rd Party) Integration"}
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"item56"}
                      data-plasmic-override={overrides.item56}
                      className={classNames("all", sty.item56)}
                    >
                      <div
                        data-plasmic-name={"left56"}
                        data-plasmic-override={overrides.left56}
                        className={classNames("all", sty.left56)}
                      >
                        <div
                          data-plasmic-name={"icon56"}
                          data-plasmic-override={overrides.icon56}
                          className={classNames("all", sty.icon56)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__uSa5)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title57"}
                        data-plasmic-override={overrides.title57}
                        className={classNames("all", "__wab_text", sty.title57)}
                      >
                        {"EHR Connectivity"}
                      </div>
                    </div>
                    {false ? (
                      <div
                        data-plasmic-name={"item57"}
                        data-plasmic-override={overrides.item57}
                        className={classNames("all", sty.item57)}
                      >
                        <div
                          data-plasmic-name={"left57"}
                          data-plasmic-override={overrides.left57}
                          className={classNames("all", sty.left57)}
                        >
                          <div
                            data-plasmic-name={"icon57"}
                            data-plasmic-override={overrides.icon57}
                            className={classNames("all", sty.icon57)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__ngnm)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title58"}
                          data-plasmic-override={overrides.title58}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title58
                          )}
                        >
                          {"EHR Connectivity"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item58"}
                        data-plasmic-override={overrides.item58}
                        className={classNames("all", sty.item58)}
                      >
                        <div
                          data-plasmic-name={"left58"}
                          data-plasmic-override={overrides.left58}
                          className={classNames("all", sty.left58)}
                        >
                          <div
                            data-plasmic-name={"icon58"}
                            data-plasmic-override={overrides.icon58}
                            className={classNames("all", sty.icon58)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__jkR4H)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title59"}
                          data-plasmic-override={overrides.title59}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title59
                          )}
                        >
                          {"Clinical Log (3rd Party) Integration"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item59"}
                        data-plasmic-override={overrides.item59}
                        className={classNames("all", sty.item59)}
                      >
                        <div
                          data-plasmic-name={"left59"}
                          data-plasmic-override={overrides.left59}
                          className={classNames("all", sty.left59)}
                        >
                          <div
                            data-plasmic-name={"icon59"}
                            data-plasmic-override={overrides.icon59}
                            className={classNames("all", sty.icon59)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___9OnMz)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title60"}
                          data-plasmic-override={overrides.title60}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title60
                          )}
                        >
                          {"Learning Assignments"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item60"}
                        data-plasmic-override={overrides.item60}
                        className={classNames("all", sty.item60)}
                      >
                        <div
                          data-plasmic-name={"left60"}
                          data-plasmic-override={overrides.left60}
                          className={classNames("all", sty.left60)}
                        >
                          <div
                            data-plasmic-name={"icon60"}
                            data-plasmic-override={overrides.icon60}
                            className={classNames("all", sty.icon60)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__yfrot)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title61"}
                          data-plasmic-override={overrides.title61}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title61
                          )}
                        >
                          {"MyQuiz (Quizzes/Exams)"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item61"}
                        data-plasmic-override={overrides.item61}
                        className={classNames("all", sty.item61)}
                      >
                        <div
                          data-plasmic-name={"left61"}
                          data-plasmic-override={overrides.left61}
                          className={classNames("all", sty.left61)}
                        >
                          <div
                            data-plasmic-name={"icon61"}
                            data-plasmic-override={overrides.icon61}
                            className={classNames("all", sty.icon61)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__bl1R8)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title62"}
                          data-plasmic-override={overrides.title62}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title62
                          )}
                        >
                          {"Demographic Management"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item62"}
                        data-plasmic-override={overrides.item62}
                        className={classNames("all", sty.item62)}
                      >
                        <div
                          data-plasmic-name={"left62"}
                          data-plasmic-override={overrides.left62}
                          className={classNames("all", sty.left62)}
                        >
                          <div
                            data-plasmic-name={"icon62"}
                            data-plasmic-override={overrides.icon62}
                            className={classNames("all", sty.icon62)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___8B97M)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title63"}
                          data-plasmic-override={overrides.title63}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title63
                          )}
                        >
                          {"Onboarding & Credentialing"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item63"}
                        data-plasmic-override={overrides.item63}
                        className={classNames("all", sty.item63)}
                      >
                        <div
                          data-plasmic-name={"left63"}
                          data-plasmic-override={overrides.left63}
                          className={classNames("all", sty.left63)}
                        >
                          <div
                            data-plasmic-name={"icon63"}
                            data-plasmic-override={overrides.icon63}
                            className={classNames("all", sty.icon63)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__rQzNl)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title64"}
                          data-plasmic-override={overrides.title64}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title64
                          )}
                        >
                          {"Certificate/Diploma Management"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item64"}
                        data-plasmic-override={overrides.item64}
                        className={classNames("all", sty.item64)}
                      >
                        <div
                          data-plasmic-name={"left64"}
                          data-plasmic-override={overrides.left64}
                          className={classNames("all", sty.left64)}
                        >
                          <div
                            data-plasmic-name={"icon64"}
                            data-plasmic-override={overrides.icon64}
                            className={classNames("all", sty.icon64)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__o7E1D)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title65"}
                          data-plasmic-override={overrides.title65}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title65
                          )}
                        >
                          {"Schedule Management"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item65"}
                        data-plasmic-override={overrides.item65}
                        className={classNames("all", sty.item65)}
                      >
                        <div
                          data-plasmic-name={"left65"}
                          data-plasmic-override={overrides.left65}
                          className={classNames("all", sty.left65)}
                        >
                          <div
                            data-plasmic-name={"icon65"}
                            data-plasmic-override={overrides.icon65}
                            className={classNames("all", sty.icon65)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__jmIcA)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title66"}
                          data-plasmic-override={overrides.title66}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title66
                          )}
                        >
                          {"Automatic Scheduling & Lottery"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item66"}
                        data-plasmic-override={overrides.item66}
                        className={classNames("all", sty.item66)}
                      >
                        <div
                          data-plasmic-name={"left66"}
                          data-plasmic-override={overrides.left66}
                          className={classNames("all", sty.left66)}
                        >
                          <div
                            data-plasmic-name={"icon66"}
                            data-plasmic-override={overrides.icon66}
                            className={classNames("all", sty.icon66)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg___5YzMl)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title67"}
                          data-plasmic-override={overrides.title67}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title67
                          )}
                        >
                          {"Schedule (3rd Party) Integration"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item67"}
                        data-plasmic-override={overrides.item67}
                        className={classNames("all", sty.item67)}
                      >
                        <div
                          data-plasmic-name={"left67"}
                          data-plasmic-override={overrides.left67}
                          className={classNames("all", sty.left67)}
                        >
                          <div
                            data-plasmic-name={"icon67"}
                            data-plasmic-override={overrides.icon67}
                            className={classNames("all", sty.icon67)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__rPLt)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title68"}
                          data-plasmic-override={overrides.title68}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title68
                          )}
                        >
                          {"MyPortfolios"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item68"}
                        data-plasmic-override={overrides.item68}
                        className={classNames("all", sty.item68)}
                      >
                        <div
                          data-plasmic-name={"left68"}
                          data-plasmic-override={overrides.left68}
                          className={classNames("all", sty.left68)}
                        >
                          <div
                            data-plasmic-name={"icon68"}
                            data-plasmic-override={overrides.icon68}
                            className={classNames("all", sty.icon68)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__a5H0K)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title69"}
                          data-plasmic-override={overrides.title69}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title69
                          )}
                        >
                          {"Performance Dashboard"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item69"}
                        data-plasmic-override={overrides.item69}
                        className={classNames("all", sty.item69)}
                      >
                        <div
                          data-plasmic-name={"left69"}
                          data-plasmic-override={overrides.left69}
                          className={classNames("all", sty.left69)}
                        >
                          <div
                            data-plasmic-name={"icon69"}
                            data-plasmic-override={overrides.icon69}
                            className={classNames("all", sty.icon69)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__iFpTf)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title70"}
                          data-plasmic-override={overrides.title70}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title70
                          )}
                        >
                          {"Custom Reporting"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item70"}
                        data-plasmic-override={overrides.item70}
                        className={classNames("all", sty.item70)}
                      >
                        <div
                          data-plasmic-name={"left70"}
                          data-plasmic-override={overrides.left70}
                          className={classNames("all", sty.left70)}
                        >
                          <div
                            data-plasmic-name={"icon70"}
                            data-plasmic-override={overrides.icon70}
                            className={classNames("all", sty.icon70)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__wYhMm)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title71"}
                          data-plasmic-override={overrides.title71}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title71
                          )}
                        >
                          {"Electronic Contracts & Signatures"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item71"}
                        data-plasmic-override={overrides.item71}
                        className={classNames("all", sty.item71)}
                      >
                        <div
                          data-plasmic-name={"left71"}
                          data-plasmic-override={overrides.left71}
                          className={classNames("all", sty.left71)}
                        >
                          <div
                            data-plasmic-name={"icon71"}
                            data-plasmic-override={overrides.icon71}
                            className={classNames("all", sty.icon71)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__ytUro)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title72"}
                          data-plasmic-override={overrides.title72}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title72
                          )}
                        >
                          {"Feature Item"}
                        </div>
                      </div>
                    ) : null}
                    {false ? (
                      <div
                        data-plasmic-name={"item72"}
                        data-plasmic-override={overrides.item72}
                        className={classNames("all", sty.item72)}
                      >
                        <div
                          data-plasmic-name={"left72"}
                          data-plasmic-override={overrides.left72}
                          className={classNames("all", sty.left72)}
                        >
                          <div
                            data-plasmic-name={"icon72"}
                            data-plasmic-override={overrides.icon72}
                            className={classNames("all", sty.icon72)}
                          >
                            <Icon93Icon
                              className={classNames("all", sty.svg__lh4Ay)}
                              role={"img"}
                            />
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"title73"}
                          data-plasmic-override={overrides.title73}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.title73
                          )}
                        >
                          {"Feature Item"}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"col3"}
                data-plasmic-override={overrides.col3}
                className={classNames("all", sty.col3)}
              >
                <div
                  data-plasmic-name={"header8"}
                  data-plasmic-override={overrides.header8}
                  className={classNames("all", "__wab_text", sty.header8)}
                >
                  {"Nursing Programs"}
                </div>
                <div
                  data-plasmic-name={"list4"}
                  data-plasmic-override={overrides.list4}
                  className={classNames("all", sty.list4)}
                >
                  <div
                    data-plasmic-name={"item73"}
                    data-plasmic-override={overrides.item73}
                    className={classNames("all", sty.item73)}
                  >
                    <div
                      data-plasmic-name={"left73"}
                      data-plasmic-override={overrides.left73}
                      className={classNames("all", sty.left73)}
                    >
                      <div
                        data-plasmic-name={"icon73"}
                        data-plasmic-override={overrides.icon73}
                        className={classNames("all", sty.icon73)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__dOcOv)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title74"}
                      data-plasmic-override={overrides.title74}
                      className={classNames("all", "__wab_text", sty.title74)}
                    >
                      {"Clinical Activity Logger"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item74"}
                    data-plasmic-override={overrides.item74}
                    className={classNames("all", sty.item74)}
                  >
                    <div
                      data-plasmic-name={"left74"}
                      data-plasmic-override={overrides.left74}
                      className={classNames("all", sty.left74)}
                    >
                      <div
                        data-plasmic-name={"icon74"}
                        data-plasmic-override={overrides.icon74}
                        className={classNames("all", sty.icon74)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__iHiof)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title75"}
                      data-plasmic-override={overrides.title75}
                      className={classNames("all", "__wab_text", sty.title75)}
                    >
                      {"Return Demonstration Management"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item75"}
                    data-plasmic-override={overrides.item75}
                    className={classNames("all", sty.item75)}
                  >
                    <div
                      data-plasmic-name={"left75"}
                      data-plasmic-override={overrides.left75}
                      className={classNames("all", sty.left75)}
                    >
                      <div
                        data-plasmic-name={"icon75"}
                        data-plasmic-override={overrides.icon75}
                        className={classNames("all", sty.icon75)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__n5Mvl)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title76"}
                      data-plasmic-override={overrides.title76}
                      className={classNames("all", "__wab_text", sty.title76)}
                    >
                      {"Return Demonstration Testing"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item76"}
                    data-plasmic-override={overrides.item76}
                    className={classNames("all", sty.item76)}
                  >
                    <div
                      data-plasmic-name={"left76"}
                      data-plasmic-override={overrides.left76}
                      className={classNames("all", sty.left76)}
                    >
                      <div
                        data-plasmic-name={"icon76"}
                        data-plasmic-override={overrides.icon76}
                        className={classNames("all", sty.icon76)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__ot10)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title77"}
                      data-plasmic-override={overrides.title77}
                      className={classNames("all", "__wab_text", sty.title77)}
                    >
                      {"Clinical Learning Contracts"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item77"}
                      data-plasmic-override={overrides.item77}
                      className={classNames("all", sty.item77)}
                    >
                      <div
                        data-plasmic-name={"left77"}
                        data-plasmic-override={overrides.left77}
                        className={classNames("all", sty.left77)}
                      >
                        <div
                          data-plasmic-name={"icon77"}
                          data-plasmic-override={overrides.icon77}
                          className={classNames("all", sty.icon77)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__jyXrH)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title78"}
                        data-plasmic-override={overrides.title78}
                        className={classNames("all", "__wab_text", sty.title78)}
                      >
                        {"Clinical Hours (Duty-Hours)"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item78"}
                      data-plasmic-override={overrides.item78}
                      className={classNames("all", sty.item78)}
                    >
                      <div
                        data-plasmic-name={"left78"}
                        data-plasmic-override={overrides.left78}
                        className={classNames("all", sty.left78)}
                      >
                        <div
                          data-plasmic-name={"icon78"}
                          data-plasmic-override={overrides.icon78}
                          className={classNames("all", sty.icon78)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__ykw9)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title79"}
                        data-plasmic-override={overrides.title79}
                        className={classNames("all", "__wab_text", sty.title79)}
                      >
                        {"MyQuickPass"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item79"}
                      data-plasmic-override={overrides.item79}
                      className={classNames("all", sty.item79)}
                    >
                      <div
                        data-plasmic-name={"left79"}
                        data-plasmic-override={overrides.left79}
                        className={classNames("all", sty.left79)}
                      >
                        <div
                          data-plasmic-name={"icon79"}
                          data-plasmic-override={overrides.icon79}
                          className={classNames("all", sty.icon79)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__aLggf)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title80"}
                        data-plasmic-override={overrides.title80}
                        className={classNames("all", "__wab_text", sty.title80)}
                      >
                        {"Conference Tracking"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item80"}
                      data-plasmic-override={overrides.item80}
                      className={classNames("all", sty.item80)}
                    >
                      <div
                        data-plasmic-name={"left80"}
                        data-plasmic-override={overrides.left80}
                        className={classNames("all", sty.left80)}
                      >
                        <div
                          data-plasmic-name={"icon80"}
                          data-plasmic-override={overrides.icon80}
                          className={classNames("all", sty.icon80)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__pjUc4)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title81"}
                        data-plasmic-override={overrides.title81}
                        className={classNames("all", "__wab_text", sty.title81)}
                      >
                        {"Burnout Monitoring"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item81"}
                      data-plasmic-override={overrides.item81}
                      className={classNames("all", sty.item81)}
                    >
                      <div
                        data-plasmic-name={"left81"}
                        data-plasmic-override={overrides.left81}
                        className={classNames("all", sty.left81)}
                      >
                        <div
                          data-plasmic-name={"icon81"}
                          data-plasmic-override={overrides.icon81}
                          className={classNames("all", sty.icon81)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__ubiFc)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title82"}
                        data-plasmic-override={overrides.title82}
                        className={classNames("all", "__wab_text", sty.title82)}
                      >
                        {"EHR Connectivity"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item82"}
                      data-plasmic-override={overrides.item82}
                      className={classNames("all", sty.item82)}
                    >
                      <div
                        data-plasmic-name={"left82"}
                        data-plasmic-override={overrides.left82}
                        className={classNames("all", sty.left82)}
                      >
                        <div
                          data-plasmic-name={"icon82"}
                          data-plasmic-override={overrides.icon82}
                          className={classNames("all", sty.icon82)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__sbIr3)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title83"}
                        data-plasmic-override={overrides.title83}
                        className={classNames("all", "__wab_text", sty.title83)}
                      >
                        {"Clinical Log (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item83"}
                      data-plasmic-override={overrides.item83}
                      className={classNames("all", sty.item83)}
                    >
                      <div
                        data-plasmic-name={"left83"}
                        data-plasmic-override={overrides.left83}
                        className={classNames("all", sty.left83)}
                      >
                        <div
                          data-plasmic-name={"icon83"}
                          data-plasmic-override={overrides.icon83}
                          className={classNames("all", sty.icon83)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__ltSnG)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title84"}
                        data-plasmic-override={overrides.title84}
                        className={classNames("all", "__wab_text", sty.title84)}
                      >
                        {"Learning Assignments"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item84"}
                      data-plasmic-override={overrides.item84}
                      className={classNames("all", sty.item84)}
                    >
                      <div
                        data-plasmic-name={"left84"}
                        data-plasmic-override={overrides.left84}
                        className={classNames("all", sty.left84)}
                      >
                        <div
                          data-plasmic-name={"icon84"}
                          data-plasmic-override={overrides.icon84}
                          className={classNames("all", sty.icon84)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__fjIz6)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title85"}
                        data-plasmic-override={overrides.title85}
                        className={classNames("all", "__wab_text", sty.title85)}
                      >
                        {"MyQuiz (Quizzes/Exams)"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item85"}
                      data-plasmic-override={overrides.item85}
                      className={classNames("all", sty.item85)}
                    >
                      <div
                        data-plasmic-name={"left85"}
                        data-plasmic-override={overrides.left85}
                        className={classNames("all", sty.left85)}
                      >
                        <div
                          data-plasmic-name={"icon85"}
                          data-plasmic-override={overrides.icon85}
                          className={classNames("all", sty.icon85)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___8Kk5T)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title86"}
                        data-plasmic-override={overrides.title86}
                        className={classNames("all", "__wab_text", sty.title86)}
                      >
                        {"Demographic Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item86"}
                      data-plasmic-override={overrides.item86}
                      className={classNames("all", sty.item86)}
                    >
                      <div
                        data-plasmic-name={"left86"}
                        data-plasmic-override={overrides.left86}
                        className={classNames("all", sty.left86)}
                      >
                        <div
                          data-plasmic-name={"icon86"}
                          data-plasmic-override={overrides.icon86}
                          className={classNames("all", sty.icon86)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___0Ns93)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title87"}
                        data-plasmic-override={overrides.title87}
                        className={classNames("all", "__wab_text", sty.title87)}
                      >
                        {"Onboarding & Credentialing"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item87"}
                      data-plasmic-override={overrides.item87}
                      className={classNames("all", sty.item87)}
                    >
                      <div
                        data-plasmic-name={"left87"}
                        data-plasmic-override={overrides.left87}
                        className={classNames("all", sty.left87)}
                      >
                        <div
                          data-plasmic-name={"icon87"}
                          data-plasmic-override={overrides.icon87}
                          className={classNames("all", sty.icon87)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__e1B4D)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title88"}
                        data-plasmic-override={overrides.title88}
                        className={classNames("all", "__wab_text", sty.title88)}
                      >
                        {"Certificate/Diploma Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item88"}
                      data-plasmic-override={overrides.item88}
                      className={classNames("all", sty.item88)}
                    >
                      <div
                        data-plasmic-name={"left88"}
                        data-plasmic-override={overrides.left88}
                        className={classNames("all", sty.left88)}
                      >
                        <div
                          data-plasmic-name={"icon88"}
                          data-plasmic-override={overrides.icon88}
                          className={classNames("all", sty.icon88)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__qhsKv)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title89"}
                        data-plasmic-override={overrides.title89}
                        className={classNames("all", "__wab_text", sty.title89)}
                      >
                        {"Schedule Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item89"}
                      data-plasmic-override={overrides.item89}
                      className={classNames("all", sty.item89)}
                    >
                      <div
                        data-plasmic-name={"left89"}
                        data-plasmic-override={overrides.left89}
                        className={classNames("all", sty.left89)}
                      >
                        <div
                          data-plasmic-name={"icon89"}
                          data-plasmic-override={overrides.icon89}
                          className={classNames("all", sty.icon89)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__valb)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title90"}
                        data-plasmic-override={overrides.title90}
                        className={classNames("all", "__wab_text", sty.title90)}
                      >
                        {"Automatic Scheduling & Lottery"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item90"}
                      data-plasmic-override={overrides.item90}
                      className={classNames("all", sty.item90)}
                    >
                      <div
                        data-plasmic-name={"left90"}
                        data-plasmic-override={overrides.left90}
                        className={classNames("all", sty.left90)}
                      >
                        <div
                          data-plasmic-name={"icon90"}
                          data-plasmic-override={overrides.icon90}
                          className={classNames("all", sty.icon90)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__ggfpJ)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title91"}
                        data-plasmic-override={overrides.title91}
                        className={classNames("all", "__wab_text", sty.title91)}
                      >
                        {"Schedule (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item91"}
                      data-plasmic-override={overrides.item91}
                      className={classNames("all", sty.item91)}
                    >
                      <div
                        data-plasmic-name={"left91"}
                        data-plasmic-override={overrides.left91}
                        className={classNames("all", sty.left91)}
                      >
                        <div
                          data-plasmic-name={"icon91"}
                          data-plasmic-override={overrides.icon91}
                          className={classNames("all", sty.icon91)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__vAPx)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title92"}
                        data-plasmic-override={overrides.title92}
                        className={classNames("all", "__wab_text", sty.title92)}
                      >
                        {"MyPortfolios"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item92"}
                      data-plasmic-override={overrides.item92}
                      className={classNames("all", sty.item92)}
                    >
                      <div
                        data-plasmic-name={"left92"}
                        data-plasmic-override={overrides.left92}
                        className={classNames("all", sty.left92)}
                      >
                        <div
                          data-plasmic-name={"icon92"}
                          data-plasmic-override={overrides.icon92}
                          className={classNames("all", sty.icon92)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__o8Miv)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title93"}
                        data-plasmic-override={overrides.title93}
                        className={classNames("all", "__wab_text", sty.title93)}
                      >
                        {"Performance Dashboard"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item93"}
                      data-plasmic-override={overrides.item93}
                      className={classNames("all", sty.item93)}
                    >
                      <div
                        data-plasmic-name={"left93"}
                        data-plasmic-override={overrides.left93}
                        className={classNames("all", sty.left93)}
                      >
                        <div
                          data-plasmic-name={"icon93"}
                          data-plasmic-override={overrides.icon93}
                          className={classNames("all", sty.icon93)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__w3Olg)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title94"}
                        data-plasmic-override={overrides.title94}
                        className={classNames("all", "__wab_text", sty.title94)}
                      >
                        {"Custom Reporting"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item94"}
                      data-plasmic-override={overrides.item94}
                      className={classNames("all", sty.item94)}
                    >
                      <div
                        data-plasmic-name={"left94"}
                        data-plasmic-override={overrides.left94}
                        className={classNames("all", sty.left94)}
                      >
                        <div
                          data-plasmic-name={"icon94"}
                          data-plasmic-override={overrides.icon94}
                          className={classNames("all", sty.icon94)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__goKm)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title95"}
                        data-plasmic-override={overrides.title95}
                        className={classNames("all", "__wab_text", sty.title95)}
                      >
                        {"Electronic Contracts & Signatures"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item95"}
                      data-plasmic-override={overrides.item95}
                      className={classNames("all", sty.item95)}
                    >
                      <div
                        data-plasmic-name={"left95"}
                        data-plasmic-override={overrides.left95}
                        className={classNames("all", sty.left95)}
                      >
                        <div
                          data-plasmic-name={"icon95"}
                          data-plasmic-override={overrides.icon95}
                          className={classNames("all", sty.icon95)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__aMb0)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title96"}
                        data-plasmic-override={overrides.title96}
                        className={classNames("all", "__wab_text", sty.title96)}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item96"}
                      data-plasmic-override={overrides.item96}
                      className={classNames("all", sty.item96)}
                    >
                      <div
                        data-plasmic-name={"left96"}
                        data-plasmic-override={overrides.left96}
                        className={classNames("all", sty.left96)}
                      >
                        <div
                          data-plasmic-name={"icon96"}
                          data-plasmic-override={overrides.icon96}
                          className={classNames("all", sty.icon96)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__oQ2E0)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title97"}
                        data-plasmic-override={overrides.title97}
                        className={classNames("all", "__wab_text", sty.title97)}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? false
          : hasVariant(globalVariants, "mobile", "mobile")
            ? false
            : hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? true
              : false
      ) ? (
        <div
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          className={classNames("all", sty.tablet)}
        >
          <div
            data-plasmic-name={"row6"}
            data-plasmic-override={overrides.row6}
            className={classNames("all", sty.row6)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__iwmYt
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            />
          </div>
          <div
            data-plasmic-name={"key4"}
            data-plasmic-override={overrides.key4}
            className={classNames("all", sty.key4)}
          >
            <header
              data-plasmic-name={"header4"}
              data-plasmic-override={overrides.header4}
              className={classNames("all", sty.header4)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2__ce5Z
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list11"}
              data-plasmic-override={overrides.list11}
              className={classNames("all", sty.list11)}
            >
              <div
                data-plasmic-name={"row7"}
                data-plasmic-override={overrides.row7}
                className={classNames("all", sty.row7)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__fC8Vq
                  )}
                  desciption={
                    "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                  }
                  title={"Evaluations, Milestones & EPAs"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__jI6DX)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/b63c4ec01b7f0b5eb8b9273a00144d1a.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__zVqmg
                  )}
                  desciption={
                    "Create guided PIPs to proactively identify weaknesses and systematically improve your program. Utilize Clinical Learning Contracts, set for nursing students, to align expectations and facilitate feedback for focused growth."
                  }
                  title={
                    "Performance Improvement Plans & Clinical Learning Contracts"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__c37A5)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e7ed370b68c67f76e2ca004000c2ffc7.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row8"}
                data-plasmic-override={overrides.row8}
                className={classNames("all", sty.row8)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__uCaG0
                  )}
                  desciption={
                    "Create custom curriculum for each rotation consisting of EPAs, evaluations, procedures, learning materials, quizzes, and more. Experience efficient planning, flexibility, and structured pathways for comprehensive and innovative education."
                  }
                  title={"Curriculum Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__nKmWd)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/cb0239402e2936b1bf7362398e69386b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__sGPsZ
                  )}
                  desciption={
                    "Stay on top of tasks, messages, and schedules. Ensure staff and students stay compliant effortlessly. Analyze individual academic performance, identify achievements and areas for improvement. Compare to benchmarks, and set improvement plans."
                  }
                  title={"Educational Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__fefGs)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/1f79a4c37de0c595115ccbeec901b877.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row9"}
                data-plasmic-override={overrides.row9}
                className={classNames("all", sty.row9)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__bLCm
                  )}
                  desciption={
                    "Fulfill ACGME requirements using Annual Program Evaluations. Streamline monitoring to ensure your program consistently meets high standards. Gain insights and strategic oversight to elevate program reputation. "
                  }
                  title={"ACGME Compliance Tracking"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__z8Ch9)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e0f7df98d28ee45e44aa7bee3fa42fa0.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__vaM1N
                  )}
                  desciption={
                    "Simplify onboarding and credentialing for new trainees. Print certificates and diplomas effortlessly. Manage ERAS data with accuracy. Streamline contract management with electronic signatures."
                  }
                  title={"Administrative Tools"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__a0Q6U)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a46f0a440808da7c0237c86d05dd281c.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row10"}
                data-plasmic-override={overrides.row10}
                className={classNames("all", sty.row10)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__gmAGe
                  )}
                  desciption={
                    "Enhance training with accurate logs of procedural skills and patient encounters. Turn every clinical activity into a learning opportunity, ensuring a comprehensive educational experience."
                  }
                  title={"Procedure & Patient Logging"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__uc4M)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/f84f25cdb0e594e6d5e5dd86882a0815.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__oUyx7
                  )}
                  desciption={
                    "Effortlessly manage GME schedules with built-in MySchedule module. Sync with AMION, QGenda, Momentum. Simplify clinical hour tracking with MyQuickPass. Streamline workflow, stay informed with instant updates."
                  }
                  title={"Scheduling & Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___4HgYp)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/8debbf898d018ca00021c1aa8e2fa91b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row11"}
                data-plasmic-override={overrides.row11}
                className={classNames("all", sty.row11)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__sjuMb
                  )}
                  desciption={
                    "Tailor tasks, diverse materials for student engagement. Assess with interactive quizzes, focusing on meaningful learning, knowledge retention, and efficient exam creation. Get valuable performance feedback."
                  }
                  title={"MyQuiz & Learning Assignments"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__cSkFn)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a3ca4aac0456c9eddccb298b95e5d36b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__vAnz3
                  )}
                  desciption={
                    "Make every nurse student demonstration a milestone. Standardize validation, ensure objective evaluation, and refine training processes. Get clear criteria and opportunities for feedback."
                  }
                  title={"Return Demonstrations"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__lnPh)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a86286f943431a01b8c593770fd02a05.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"all3"}
            data-plasmic-override={overrides.all3}
            className={classNames("all", sty.all3)}
          >
            <h2
              data-plasmic-name={"title3"}
              data-plasmic-override={overrides.title3}
              className={classNames(
                "all",
                "h2",
                "h2__bvRZj",
                "__wab_text",
                sty.title3
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections3"}
              data-plasmic-override={overrides.sections3}
              className={classNames("all", sty.sections3)}
            >
              <div
                data-plasmic-name={"col8"}
                data-plasmic-override={overrides.col8}
                className={classNames("all", sty.col8)}
              >
                <h3
                  className={classNames(
                    "all",
                    "h3",
                    "h3__bvRZj",
                    "__wab_text",
                    sty.h3___8LOD
                  )}
                >
                  {"All Use Cases"}
                </h3>
                <div
                  data-plasmic-name={"list12"}
                  data-plasmic-override={overrides.list12}
                  className={classNames("all", sty.list12)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Evaluations/Assessments"
                          },
                          {
                            text: "MyInsight"
                          },
                          {
                            text: "Milestones & EPAs"
                          },
                          {
                            text: "Narrative Predictive Value (NPV)"
                          },
                          {
                            text: "Performance Improvement Plans"
                          },
                          {
                            text: "Clinical Hours (Duty-Hours)"
                          },
                          {
                            text: "MyQuickPass"
                          },
                          {
                            text: "Conference Tracking"
                          },
                          {
                            text: "Burnout Monitoring"
                          },
                          {
                            text: "EHR Connectivity"
                          },
                          {
                            text: "Clinical Log (3rd Party) Integration"
                          },
                          {
                            text: "Learning Assignments"
                          },
                          {
                            text: "MyQuiz (Quizzes/Exams)"
                          },
                          {
                            text: "Demographic Management"
                          },
                          {
                            text: "Onboarding & Credentialing"
                          },
                          {
                            text: "Certificate/Diploma Management"
                          },
                          {
                            text: "Schedule Management"
                          },
                          {
                            text: "Automatic Scheduling & Lottery"
                          },
                          {
                            text: "Schedule (3rd Party) Integration"
                          },
                          {
                            text: "MyPortfolios"
                          },
                          {
                            text: "Performance Dashboard"
                          },
                          {
                            text: "Custom Reporting"
                          },
                          {
                            text: "Electronic Contracts & Signatures"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__kOb7B
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames("all", sty.svg__eh4F0)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
              <div
                data-plasmic-name={"col9"}
                data-plasmic-override={overrides.col9}
                className={classNames("all", sty.col9)}
              >
                <div
                  data-plasmic-name={"section5"}
                  data-plasmic-override={overrides.section5}
                  className={classNames("all", sty.section5)}
                >
                  <h3
                    className={classNames(
                      "all",
                      "h3",
                      "h3__bvRZj",
                      "__wab_text",
                      sty.h3__fFril
                    )}
                  >
                    {"GME & Physician Assistant Programs "}
                  </h3>
                  <div
                    data-plasmic-name={"list13"}
                    data-plasmic-override={overrides.list13}
                    className={classNames("all", sty.list13)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Curriculum Management"
                            },
                            {
                              text: "Procedure Logging"
                            },
                            {
                              text: "Patient Logging"
                            },
                            {
                              text: "Centralized Procedure Reporting"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__ubL2C
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__uVLlA)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"section6"}
                  data-plasmic-override={overrides.section6}
                  className={classNames("all", sty.section6)}
                >
                  <h3
                    className={classNames(
                      "all",
                      "h3",
                      "h3__bvRZj",
                      "__wab_text",
                      sty.h3___25Gvl
                    )}
                  >
                    {"GME Programs "}
                  </h3>
                  <div
                    data-plasmic-name={"list14"}
                    data-plasmic-override={overrides.list14}
                    className={classNames("all", sty.list14)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Annual Program Evaluations"
                            },
                            {
                              text: "Common Program Requirements"
                            },
                            {
                              text: "Institutional Requirements"
                            },
                            {
                              text: "Take Action Plans & Notifications"
                            },
                            {
                              text: "ERAS Data Importing"
                            },
                            {
                              text: "Electronic Contract Management"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__omYwO
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__huE4)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"col10"}
                  data-plasmic-override={overrides.col10}
                  className={classNames("all", sty.col10)}
                >
                  <h3
                    className={classNames(
                      "all",
                      "h3",
                      "h3__bvRZj",
                      "__wab_text",
                      sty.h3__dZhp7
                    )}
                  >
                    {"Nursing Programs"}
                  </h3>
                  <div
                    data-plasmic-name={"list15"}
                    data-plasmic-override={overrides.list15}
                    className={classNames("all", sty.list15)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Clinical Activity Logger"
                            },
                            {
                              text: "Return Demonstration Management"
                            },
                            {
                              text: "Return Demonstration Testing"
                            },
                            {
                              text: "Clinical Learning Contracts"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem___9B74C
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__lx5GI)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? true
          : hasVariant(globalVariants, "mobile", "mobile")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          className={classNames("all", sty.mobile)}
        >
          <div
            data-plasmic-name={"header3"}
            data-plasmic-override={overrides.header3}
            className={classNames("all", sty.header3)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__kawt
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : undefined
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : undefined
              }
            />
          </div>
          <div
            data-plasmic-name={"key3"}
            data-plasmic-override={overrides.key3}
            className={classNames("all", sty.key3)}
          >
            <header
              data-plasmic-name={"header2"}
              data-plasmic-override={overrides.header2}
              className={classNames("all", sty.header2)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2__jIpFt
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list6"}
              data-plasmic-override={overrides.list6}
              className={classNames("all", sty.list6)}
            >
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__p2CsD
                )}
                desciption={
                  "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                }
                title={"Evaluations, Milestones & EPAs"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__r3Jti)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/69de85f9b9c68c24c8ca5311dc63a8f4.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard___98J5D
                )}
                desciption={
                  "Create guided PIPs to proactively identify weaknesses and systematically improve your program. Utilize Clinical Learning Contracts, set for nursing students, to align expectations and facilitate feedback for focused growth."
                }
                title={
                  "Performance Improvement Plans & Clinical Learning Contracts"
                }
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__gqdH)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/ccf489cc6e4dd6d7891ca26ab1aa9d64.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__mtlYt
                )}
                desciption={
                  "Create custom curriculum for each rotation consisting of EPAs, evaluations, procedures, learning materials, quizzes, and more. Experience efficient planning, flexibility, and structured pathways for comprehensive and innovative education."
                }
                title={"Curriculum Management"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__cxHCj)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/57568576c4f865353621f436e40045c0.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__zhf6R
                )}
                desciption={
                  "Stay on top of tasks, messages, and schedules. Ensure staff and students stay compliant effortlessly. Analyze individual academic performance, identify achievements and areas for improvement. Compare to benchmarks, and set improvement plans."
                }
                title={"Educational Compliance"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__gXyHj)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/0fdfef14aa9342c9451f04c9e0d2b0f0.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames("__wab_instance", sty.featuresCard__byR6)}
                desciption={
                  "Fulfill ACGME requirements using Annual Program Evaluations. Streamline monitoring to ensure your program consistently meets high standards. Gain insights and strategic oversight to elevate program reputation. "
                }
                title={"ACGME Compliance Tracking"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__rg98L)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/7fb7d351803b5f40669e1b01fbd0693b.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__ou1Ui
                )}
                desciption={
                  "Simplify onboarding and credentialing for new trainees. Print certificates and diplomas effortlessly. Manage ERAS data with accuracy. Streamline contract management with electronic signatures."
                }
                title={"Administrative Tools"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__ejyy8)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/0e42d0298ff99dc0a5c2e5541534e537.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__byolC
                )}
                desciption={
                  "Enhance training with accurate logs of procedural skills and patient encounters. Turn every clinical activity into a learning opportunity, ensuring a comprehensive educational experience."
                }
                title={"Procedure & Patient Logging"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__xfFl6)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/35855286a3c25fe56cbcd38d6817476d.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__x8VU7
                )}
                desciption={
                  "Effortlessly manage GME schedules with built-in MySchedule module. Sync with AMION, QGenda, Momentum. Simplify clinical hour tracking with MyQuickPass. Streamline workflow, stay informed with instant updates."
                }
                title={"Scheduling & Compliance"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__ocSml)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/7bf18a5993f775a256528457d410d589.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__o6DZh
                )}
                desciption={
                  "Tailor tasks, diverse materials for student engagement. Assess with interactive quizzes, focusing on meaningful learning, knowledge retention, and efficient exam creation. Get valuable performance feedback."
                }
                title={"MyQuiz & Learning Assignments"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__ce31A)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/1ff4688848589b8f499d76d1b3aeac64.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__i5H57
                )}
                desciption={
                  "Make every nurse student demonstration a milestone. Standardize validation, ensure objective evaluation, and refine training processes. Get clear criteria and opportunities for feedback."
                }
                title={"Return Demonstrations"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__elAeA)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/a86286f943431a01b8c593770fd02a05.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
            </div>
          </div>
          <div
            data-plasmic-name={"all2"}
            data-plasmic-override={overrides.all2}
            className={classNames("all", sty.all2)}
          >
            <div
              data-plasmic-name={"title100"}
              data-plasmic-override={overrides.title100}
              className={classNames("all", "__wab_text", sty.title100)}
            >
              {"Full Feature List"}
            </div>
            <div
              data-plasmic-name={"sections2"}
              data-plasmic-override={overrides.sections2}
              className={classNames("all", sty.sections2)}
            >
              <div
                data-plasmic-name={"section7"}
                data-plasmic-override={overrides.section7}
                className={classNames("all", sty.section7)}
              >
                <div
                  data-plasmic-name={"header9"}
                  data-plasmic-override={overrides.header9}
                  className={classNames("all", "__wab_text", sty.header9)}
                >
                  {"All Use Cases"}
                </div>
                <div
                  data-plasmic-name={"list7"}
                  data-plasmic-override={overrides.list7}
                  className={classNames("all", sty.list7)}
                >
                  <div
                    data-plasmic-name={"item97"}
                    data-plasmic-override={overrides.item97}
                    className={classNames("all", sty.item97)}
                  >
                    <div
                      data-plasmic-name={"left97"}
                      data-plasmic-override={overrides.left97}
                      className={classNames("all", sty.left97)}
                    >
                      <div
                        data-plasmic-name={"icon97"}
                        data-plasmic-override={overrides.icon97}
                        className={classNames("all", sty.icon97)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__auuBr)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title2"}
                      data-plasmic-override={overrides.title2}
                      className={classNames("all", "__wab_text", sty.title2)}
                    >
                      {"Evaluations/Assessments"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item98"}
                    data-plasmic-override={overrides.item98}
                    className={classNames("all", sty.item98)}
                  >
                    <div
                      data-plasmic-name={"left98"}
                      data-plasmic-override={overrides.left98}
                      className={classNames("all", sty.left98)}
                    >
                      <div
                        data-plasmic-name={"icon98"}
                        data-plasmic-override={overrides.icon98}
                        className={classNames("all", sty.icon98)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__nrL5D)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title101"}
                      data-plasmic-override={overrides.title101}
                      className={classNames("all", "__wab_text", sty.title101)}
                    >
                      {"MyInsight"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item99"}
                    data-plasmic-override={overrides.item99}
                    className={classNames("all", sty.item99)}
                  >
                    <div
                      data-plasmic-name={"left99"}
                      data-plasmic-override={overrides.left99}
                      className={classNames("all", sty.left99)}
                    >
                      <div
                        data-plasmic-name={"icon99"}
                        data-plasmic-override={overrides.icon99}
                        className={classNames("all", sty.icon99)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___0B2B6)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title102"}
                      data-plasmic-override={overrides.title102}
                      className={classNames("all", "__wab_text", sty.title102)}
                    >
                      {"Milestones & EPAs"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item100"}
                    data-plasmic-override={overrides.item100}
                    className={classNames("all", sty.item100)}
                  >
                    <div
                      data-plasmic-name={"left100"}
                      data-plasmic-override={overrides.left100}
                      className={classNames("all", sty.left100)}
                    >
                      <div
                        data-plasmic-name={"icon100"}
                        data-plasmic-override={overrides.icon100}
                        className={classNames("all", sty.icon100)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__b9Fzi)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title103"}
                      data-plasmic-override={overrides.title103}
                      className={classNames("all", "__wab_text", sty.title103)}
                    >
                      {"Performance Improvement Plans"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item101"}
                    data-plasmic-override={overrides.item101}
                    className={classNames("all", sty.item101)}
                  >
                    <div
                      data-plasmic-name={"left101"}
                      data-plasmic-override={overrides.left101}
                      className={classNames("all", sty.left101)}
                    >
                      <div
                        data-plasmic-name={"icon101"}
                        data-plasmic-override={overrides.icon101}
                        className={classNames("all", sty.icon101)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__v3F1F)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title104"}
                      data-plasmic-override={overrides.title104}
                      className={classNames("all", "__wab_text", sty.title104)}
                    >
                      {"Clinical Hours and MyQuickPass"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item102"}
                      data-plasmic-override={overrides.item102}
                      className={classNames("all", sty.item102)}
                    >
                      <div
                        data-plasmic-name={"left102"}
                        data-plasmic-override={overrides.left102}
                        className={classNames("all", sty.left102)}
                      >
                        <div
                          data-plasmic-name={"icon102"}
                          data-plasmic-override={overrides.icon102}
                          className={classNames("all", sty.icon102)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__kzhBk)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title105"}
                        data-plasmic-override={overrides.title105}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title105
                        )}
                      >
                        {"MyQuickPass"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"item103"}
                    data-plasmic-override={overrides.item103}
                    className={classNames("all", sty.item103)}
                  >
                    <div
                      data-plasmic-name={"left103"}
                      data-plasmic-override={overrides.left103}
                      className={classNames("all", sty.left103)}
                    >
                      <div
                        data-plasmic-name={"icon103"}
                        data-plasmic-override={overrides.icon103}
                        className={classNames("all", sty.icon103)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__qD4OF)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title106"}
                      data-plasmic-override={overrides.title106}
                      className={classNames("all", "__wab_text", sty.title106)}
                    >
                      {"Conference Tracking"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item104"}
                    data-plasmic-override={overrides.item104}
                    className={classNames("all", sty.item104)}
                  >
                    <div
                      data-plasmic-name={"left104"}
                      data-plasmic-override={overrides.left104}
                      className={classNames("all", sty.left104)}
                    >
                      <div
                        data-plasmic-name={"icon104"}
                        data-plasmic-override={overrides.icon104}
                        className={classNames("all", sty.icon104)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___4ISmZ)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title107"}
                      data-plasmic-override={overrides.title107}
                      className={classNames("all", "__wab_text", sty.title107)}
                    >
                      {"Burnout Monitoring"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item105"}
                      data-plasmic-override={overrides.item105}
                      className={classNames("all", sty.item105)}
                    >
                      <div
                        data-plasmic-name={"left105"}
                        data-plasmic-override={overrides.left105}
                        className={classNames("all", sty.left105)}
                      >
                        <div
                          data-plasmic-name={"icon105"}
                          data-plasmic-override={overrides.icon105}
                          className={classNames("all", sty.icon105)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__pcbWg)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title108"}
                        data-plasmic-override={overrides.title108}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title108
                        )}
                      >
                        {"EHR Connectivity"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item106"}
                      data-plasmic-override={overrides.item106}
                      className={classNames("all", sty.item106)}
                    >
                      <div
                        data-plasmic-name={"left106"}
                        data-plasmic-override={overrides.left106}
                        className={classNames("all", sty.left106)}
                      >
                        <div
                          data-plasmic-name={"icon106"}
                          data-plasmic-override={overrides.icon106}
                          className={classNames("all", sty.icon106)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___3SW9J)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title109"}
                        data-plasmic-override={overrides.title109}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title109
                        )}
                      >
                        {"Clinical Log (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"item107"}
                    data-plasmic-override={overrides.item107}
                    className={classNames("all", sty.item107)}
                  >
                    <div
                      data-plasmic-name={"left107"}
                      data-plasmic-override={overrides.left107}
                      className={classNames("all", sty.left107)}
                    >
                      <div
                        data-plasmic-name={"icon107"}
                        data-plasmic-override={overrides.icon107}
                        className={classNames("all", sty.icon107)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__mdAU)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title110"}
                      data-plasmic-override={overrides.title110}
                      className={classNames("all", "__wab_text", sty.title110)}
                    >
                      {"Learning Assignments"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item108"}
                    data-plasmic-override={overrides.item108}
                    className={classNames("all", sty.item108)}
                  >
                    <div
                      data-plasmic-name={"left108"}
                      data-plasmic-override={overrides.left108}
                      className={classNames("all", sty.left108)}
                    >
                      <div
                        data-plasmic-name={"icon108"}
                        data-plasmic-override={overrides.icon108}
                        className={classNames("all", sty.icon108)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__wvIx1)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title111"}
                      data-plasmic-override={overrides.title111}
                      className={classNames("all", "__wab_text", sty.title111)}
                    >
                      {"MyQuiz (Quizzes/Exams)"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item109"}
                    data-plasmic-override={overrides.item109}
                    className={classNames("all", sty.item109)}
                  >
                    <div
                      data-plasmic-name={"left109"}
                      data-plasmic-override={overrides.left109}
                      className={classNames("all", sty.left109)}
                    >
                      <div
                        data-plasmic-name={"icon109"}
                        data-plasmic-override={overrides.icon109}
                        className={classNames("all", sty.icon109)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__egVlt)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title112"}
                      data-plasmic-override={overrides.title112}
                      className={classNames("all", "__wab_text", sty.title112)}
                    >
                      {"Demographic Management"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item110"}
                    data-plasmic-override={overrides.item110}
                    className={classNames("all", sty.item110)}
                  >
                    <div
                      data-plasmic-name={"left110"}
                      data-plasmic-override={overrides.left110}
                      className={classNames("all", sty.left110)}
                    >
                      <div
                        data-plasmic-name={"icon110"}
                        data-plasmic-override={overrides.icon110}
                        className={classNames("all", sty.icon110)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___75Zri)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title113"}
                      data-plasmic-override={overrides.title113}
                      className={classNames("all", "__wab_text", sty.title113)}
                    >
                      {"Onboarding & Credentialing"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item111"}
                    data-plasmic-override={overrides.item111}
                    className={classNames("all", sty.item111)}
                  >
                    <div
                      data-plasmic-name={"left111"}
                      data-plasmic-override={overrides.left111}
                      className={classNames("all", sty.left111)}
                    >
                      <div
                        data-plasmic-name={"icon111"}
                        data-plasmic-override={overrides.icon111}
                        className={classNames("all", sty.icon111)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__vjyTx)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title114"}
                      data-plasmic-override={overrides.title114}
                      className={classNames("all", "__wab_text", sty.title114)}
                    >
                      {"Certificate/Diploma Management"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item112"}
                      data-plasmic-override={overrides.item112}
                      className={classNames("all", sty.item112)}
                    >
                      <div
                        data-plasmic-name={"left112"}
                        data-plasmic-override={overrides.left112}
                        className={classNames("all", sty.left112)}
                      >
                        <div
                          data-plasmic-name={"icon112"}
                          data-plasmic-override={overrides.icon112}
                          className={classNames("all", sty.icon112)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__eehhk)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title115"}
                        data-plasmic-override={overrides.title115}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title115
                        )}
                      >
                        {"Schedule Management"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"item113"}
                    data-plasmic-override={overrides.item113}
                    className={classNames("all", sty.item113)}
                  >
                    <div
                      data-plasmic-name={"left113"}
                      data-plasmic-override={overrides.left113}
                      className={classNames("all", sty.left113)}
                    >
                      <div
                        data-plasmic-name={"icon113"}
                        data-plasmic-override={overrides.icon113}
                        className={classNames("all", sty.icon113)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__li8Zy)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title116"}
                      data-plasmic-override={overrides.title116}
                      className={classNames("all", "__wab_text", sty.title116)}
                    >
                      {"Automatic Scheduling & Lottery"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item114"}
                    data-plasmic-override={overrides.item114}
                    className={classNames("all", sty.item114)}
                  >
                    <div
                      data-plasmic-name={"left114"}
                      data-plasmic-override={overrides.left114}
                      className={classNames("all", sty.left114)}
                    >
                      <div
                        data-plasmic-name={"icon114"}
                        data-plasmic-override={overrides.icon114}
                        className={classNames("all", sty.icon114)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__tBrti)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title117"}
                      data-plasmic-override={overrides.title117}
                      className={classNames("all", "__wab_text", sty.title117)}
                    >
                      {"Schedule (3rd Party) Integration"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item115"}
                    data-plasmic-override={overrides.item115}
                    className={classNames("all", sty.item115)}
                  >
                    <div
                      data-plasmic-name={"left115"}
                      data-plasmic-override={overrides.left115}
                      className={classNames("all", sty.left115)}
                    >
                      <div
                        data-plasmic-name={"icon115"}
                        data-plasmic-override={overrides.icon115}
                        className={classNames("all", sty.icon115)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__qy6X1)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title118"}
                      data-plasmic-override={overrides.title118}
                      className={classNames("all", "__wab_text", sty.title118)}
                    >
                      {"MyPortfolios"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item116"}
                    data-plasmic-override={overrides.item116}
                    className={classNames("all", sty.item116)}
                  >
                    <div
                      data-plasmic-name={"left116"}
                      data-plasmic-override={overrides.left116}
                      className={classNames("all", sty.left116)}
                    >
                      <div
                        data-plasmic-name={"icon116"}
                        data-plasmic-override={overrides.icon116}
                        className={classNames("all", sty.icon116)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__q2Y3)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title119"}
                      data-plasmic-override={overrides.title119}
                      className={classNames("all", "__wab_text", sty.title119)}
                    >
                      {"Performance Dashboard"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item117"}
                      data-plasmic-override={overrides.item117}
                      className={classNames("all", sty.item117)}
                    >
                      <div
                        data-plasmic-name={"left117"}
                        data-plasmic-override={overrides.left117}
                        className={classNames("all", sty.left117)}
                      >
                        <div
                          data-plasmic-name={"icon117"}
                          data-plasmic-override={overrides.icon117}
                          className={classNames("all", sty.icon117)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___0HxA)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title120"}
                        data-plasmic-override={overrides.title120}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title120
                        )}
                      >
                        {"Custom Reporting"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item118"}
                      data-plasmic-override={overrides.item118}
                      className={classNames("all", sty.item118)}
                    >
                      <div
                        data-plasmic-name={"left118"}
                        data-plasmic-override={overrides.left118}
                        className={classNames("all", sty.left118)}
                      >
                        <div
                          data-plasmic-name={"icon118"}
                          data-plasmic-override={overrides.icon118}
                          className={classNames("all", sty.icon118)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___8Uoz3)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title121"}
                        data-plasmic-override={overrides.title121}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title121
                        )}
                      >
                        {"Electronic Contracts & Signatures"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item119"}
                      data-plasmic-override={overrides.item119}
                      className={classNames("all", sty.item119)}
                    >
                      <div
                        data-plasmic-name={"left119"}
                        data-plasmic-override={overrides.left119}
                        className={classNames("all", sty.left119)}
                      >
                        <div
                          data-plasmic-name={"icon119"}
                          data-plasmic-override={overrides.icon119}
                          className={classNames("all", sty.icon119)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__b2ZCq)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title122"}
                        data-plasmic-override={overrides.title122}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title122
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item120"}
                      data-plasmic-override={overrides.item120}
                      className={classNames("all", sty.item120)}
                    >
                      <div
                        data-plasmic-name={"left120"}
                        data-plasmic-override={overrides.left120}
                        className={classNames("all", sty.left120)}
                      >
                        <div
                          data-plasmic-name={"icon120"}
                          data-plasmic-override={overrides.icon120}
                          className={classNames("all", sty.icon120)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__m65O7)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title123"}
                        data-plasmic-override={overrides.title123}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title123
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                data-plasmic-name={"section8"}
                data-plasmic-override={overrides.section8}
                className={classNames("all", sty.section8)}
              >
                <div
                  data-plasmic-name={"header10"}
                  data-plasmic-override={overrides.header10}
                  className={classNames("all", "__wab_text", sty.header10)}
                >
                  {"GME & Physician Assistant Programs "}
                </div>
                <div
                  data-plasmic-name={"list8"}
                  data-plasmic-override={overrides.list8}
                  className={classNames("all", sty.list8)}
                >
                  <div
                    data-plasmic-name={"item121"}
                    data-plasmic-override={overrides.item121}
                    className={classNames("all", sty.item121)}
                  >
                    <div
                      data-plasmic-name={"left121"}
                      data-plasmic-override={overrides.left121}
                      className={classNames("all", sty.left121)}
                    >
                      <div
                        data-plasmic-name={"icon121"}
                        data-plasmic-override={overrides.icon121}
                        className={classNames("all", sty.icon121)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__cyNUp)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title124"}
                      data-plasmic-override={overrides.title124}
                      className={classNames("all", "__wab_text", sty.title124)}
                    >
                      {"Curriculum Management"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item122"}
                    data-plasmic-override={overrides.item122}
                    className={classNames("all", sty.item122)}
                  >
                    <div
                      data-plasmic-name={"left122"}
                      data-plasmic-override={overrides.left122}
                      className={classNames("all", sty.left122)}
                    >
                      <div
                        data-plasmic-name={"icon122"}
                        data-plasmic-override={overrides.icon122}
                        className={classNames("all", sty.icon122)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__ijbcA)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title125"}
                      data-plasmic-override={overrides.title125}
                      className={classNames("all", "__wab_text", sty.title125)}
                    >
                      {"Procedure Logging"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item123"}
                    data-plasmic-override={overrides.item123}
                    className={classNames("all", sty.item123)}
                  >
                    <div
                      data-plasmic-name={"left123"}
                      data-plasmic-override={overrides.left123}
                      className={classNames("all", sty.left123)}
                    >
                      <div
                        data-plasmic-name={"icon123"}
                        data-plasmic-override={overrides.icon123}
                        className={classNames("all", sty.icon123)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___7RbaC)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title126"}
                      data-plasmic-override={overrides.title126}
                      className={classNames("all", "__wab_text", sty.title126)}
                    >
                      {"Patient Logging"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item124"}
                    data-plasmic-override={overrides.item124}
                    className={classNames("all", sty.item124)}
                  >
                    <div
                      data-plasmic-name={"left124"}
                      data-plasmic-override={overrides.left124}
                      className={classNames("all", sty.left124)}
                    >
                      <div
                        data-plasmic-name={"icon124"}
                        data-plasmic-override={overrides.icon124}
                        className={classNames("all", sty.icon124)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__myoJd)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title127"}
                      data-plasmic-override={overrides.title127}
                      className={classNames("all", "__wab_text", sty.title127)}
                    >
                      {"Centralized Procedure Reporting"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item125"}
                      data-plasmic-override={overrides.item125}
                      className={classNames("all", sty.item125)}
                    >
                      <div
                        data-plasmic-name={"left125"}
                        data-plasmic-override={overrides.left125}
                        className={classNames("all", sty.left125)}
                      >
                        <div
                          data-plasmic-name={"icon125"}
                          data-plasmic-override={overrides.icon125}
                          className={classNames("all", sty.icon125)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__h8Q6)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title128"}
                        data-plasmic-override={overrides.title128}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title128
                        )}
                      >
                        {"Clinical Hours (Duty-Hours)"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item126"}
                      data-plasmic-override={overrides.item126}
                      className={classNames("all", sty.item126)}
                    >
                      <div
                        data-plasmic-name={"left126"}
                        data-plasmic-override={overrides.left126}
                        className={classNames("all", sty.left126)}
                      >
                        <div
                          data-plasmic-name={"icon126"}
                          data-plasmic-override={overrides.icon126}
                          className={classNames("all", sty.icon126)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__f3SIv)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title129"}
                        data-plasmic-override={overrides.title129}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title129
                        )}
                      >
                        {"MyQuickPass"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item127"}
                      data-plasmic-override={overrides.item127}
                      className={classNames("all", sty.item127)}
                    >
                      <div
                        data-plasmic-name={"left127"}
                        data-plasmic-override={overrides.left127}
                        className={classNames("all", sty.left127)}
                      >
                        <div
                          data-plasmic-name={"icon127"}
                          data-plasmic-override={overrides.icon127}
                          className={classNames("all", sty.icon127)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__fyf)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title130"}
                        data-plasmic-override={overrides.title130}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title130
                        )}
                      >
                        {"Conference Tracking"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item128"}
                      data-plasmic-override={overrides.item128}
                      className={classNames("all", sty.item128)}
                    >
                      <div
                        data-plasmic-name={"left128"}
                        data-plasmic-override={overrides.left128}
                        className={classNames("all", sty.left128)}
                      >
                        <div
                          data-plasmic-name={"icon128"}
                          data-plasmic-override={overrides.icon128}
                          className={classNames("all", sty.icon128)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__i2JZb)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title131"}
                        data-plasmic-override={overrides.title131}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title131
                        )}
                      >
                        {"Burnout Monitoring"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item129"}
                      data-plasmic-override={overrides.item129}
                      className={classNames("all", sty.item129)}
                    >
                      <div
                        data-plasmic-name={"left129"}
                        data-plasmic-override={overrides.left129}
                        className={classNames("all", sty.left129)}
                      >
                        <div
                          data-plasmic-name={"icon129"}
                          data-plasmic-override={overrides.icon129}
                          className={classNames("all", sty.icon129)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__rjrkR)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title132"}
                        data-plasmic-override={overrides.title132}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title132
                        )}
                      >
                        {"EHR Connectivity"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item130"}
                      data-plasmic-override={overrides.item130}
                      className={classNames("all", sty.item130)}
                    >
                      <div
                        data-plasmic-name={"left130"}
                        data-plasmic-override={overrides.left130}
                        className={classNames("all", sty.left130)}
                      >
                        <div
                          data-plasmic-name={"icon130"}
                          data-plasmic-override={overrides.icon130}
                          className={classNames("all", sty.icon130)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__kofk3)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title133"}
                        data-plasmic-override={overrides.title133}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title133
                        )}
                      >
                        {"Clinical Log (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item131"}
                      data-plasmic-override={overrides.item131}
                      className={classNames("all", sty.item131)}
                    >
                      <div
                        data-plasmic-name={"left131"}
                        data-plasmic-override={overrides.left131}
                        className={classNames("all", sty.left131)}
                      >
                        <div
                          data-plasmic-name={"icon131"}
                          data-plasmic-override={overrides.icon131}
                          className={classNames("all", sty.icon131)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__pRuge)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title134"}
                        data-plasmic-override={overrides.title134}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title134
                        )}
                      >
                        {"Learning Assignments"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item132"}
                      data-plasmic-override={overrides.item132}
                      className={classNames("all", sty.item132)}
                    >
                      <div
                        data-plasmic-name={"left132"}
                        data-plasmic-override={overrides.left132}
                        className={classNames("all", sty.left132)}
                      >
                        <div
                          data-plasmic-name={"icon132"}
                          data-plasmic-override={overrides.icon132}
                          className={classNames("all", sty.icon132)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__yu7Lz)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title135"}
                        data-plasmic-override={overrides.title135}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title135
                        )}
                      >
                        {"MyQuiz (Quizzes/Exams)"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item133"}
                      data-plasmic-override={overrides.item133}
                      className={classNames("all", sty.item133)}
                    >
                      <div
                        data-plasmic-name={"left133"}
                        data-plasmic-override={overrides.left133}
                        className={classNames("all", sty.left133)}
                      >
                        <div
                          data-plasmic-name={"icon133"}
                          data-plasmic-override={overrides.icon133}
                          className={classNames("all", sty.icon133)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__mOe7)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title136"}
                        data-plasmic-override={overrides.title136}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title136
                        )}
                      >
                        {"Demographic Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item134"}
                      data-plasmic-override={overrides.item134}
                      className={classNames("all", sty.item134)}
                    >
                      <div
                        data-plasmic-name={"left134"}
                        data-plasmic-override={overrides.left134}
                        className={classNames("all", sty.left134)}
                      >
                        <div
                          data-plasmic-name={"icon134"}
                          data-plasmic-override={overrides.icon134}
                          className={classNames("all", sty.icon134)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__eczuX)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title137"}
                        data-plasmic-override={overrides.title137}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title137
                        )}
                      >
                        {"Onboarding & Credentialing"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item135"}
                      data-plasmic-override={overrides.item135}
                      className={classNames("all", sty.item135)}
                    >
                      <div
                        data-plasmic-name={"left135"}
                        data-plasmic-override={overrides.left135}
                        className={classNames("all", sty.left135)}
                      >
                        <div
                          data-plasmic-name={"icon135"}
                          data-plasmic-override={overrides.icon135}
                          className={classNames("all", sty.icon135)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__inT0)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title138"}
                        data-plasmic-override={overrides.title138}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title138
                        )}
                      >
                        {"Certificate/Diploma Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item136"}
                      data-plasmic-override={overrides.item136}
                      className={classNames("all", sty.item136)}
                    >
                      <div
                        data-plasmic-name={"left136"}
                        data-plasmic-override={overrides.left136}
                        className={classNames("all", sty.left136)}
                      >
                        <div
                          data-plasmic-name={"icon136"}
                          data-plasmic-override={overrides.icon136}
                          className={classNames("all", sty.icon136)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__qX6Iw)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title139"}
                        data-plasmic-override={overrides.title139}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title139
                        )}
                      >
                        {"Schedule Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item137"}
                      data-plasmic-override={overrides.item137}
                      className={classNames("all", sty.item137)}
                    >
                      <div
                        data-plasmic-name={"left137"}
                        data-plasmic-override={overrides.left137}
                        className={classNames("all", sty.left137)}
                      >
                        <div
                          data-plasmic-name={"icon137"}
                          data-plasmic-override={overrides.icon137}
                          className={classNames("all", sty.icon137)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__sxBe)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title140"}
                        data-plasmic-override={overrides.title140}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title140
                        )}
                      >
                        {"Automatic Scheduling & Lottery"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item138"}
                      data-plasmic-override={overrides.item138}
                      className={classNames("all", sty.item138)}
                    >
                      <div
                        data-plasmic-name={"left138"}
                        data-plasmic-override={overrides.left138}
                        className={classNames("all", sty.left138)}
                      >
                        <div
                          data-plasmic-name={"icon138"}
                          data-plasmic-override={overrides.icon138}
                          className={classNames("all", sty.icon138)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__jsgg8)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title141"}
                        data-plasmic-override={overrides.title141}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title141
                        )}
                      >
                        {"Schedule (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item139"}
                      data-plasmic-override={overrides.item139}
                      className={classNames("all", sty.item139)}
                    >
                      <div
                        data-plasmic-name={"left139"}
                        data-plasmic-override={overrides.left139}
                        className={classNames("all", sty.left139)}
                      >
                        <div
                          data-plasmic-name={"icon139"}
                          data-plasmic-override={overrides.icon139}
                          className={classNames("all", sty.icon139)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__u5IX)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title142"}
                        data-plasmic-override={overrides.title142}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title142
                        )}
                      >
                        {"MyPortfolios"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item140"}
                      data-plasmic-override={overrides.item140}
                      className={classNames("all", sty.item140)}
                    >
                      <div
                        data-plasmic-name={"left140"}
                        data-plasmic-override={overrides.left140}
                        className={classNames("all", sty.left140)}
                      >
                        <div
                          data-plasmic-name={"icon140"}
                          data-plasmic-override={overrides.icon140}
                          className={classNames("all", sty.icon140)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__ns4Qu)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title143"}
                        data-plasmic-override={overrides.title143}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title143
                        )}
                      >
                        {"Performance Dashboard"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item141"}
                      data-plasmic-override={overrides.item141}
                      className={classNames("all", sty.item141)}
                    >
                      <div
                        data-plasmic-name={"left141"}
                        data-plasmic-override={overrides.left141}
                        className={classNames("all", sty.left141)}
                      >
                        <div
                          data-plasmic-name={"icon141"}
                          data-plasmic-override={overrides.icon141}
                          className={classNames("all", sty.icon141)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__hHIjn)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title144"}
                        data-plasmic-override={overrides.title144}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title144
                        )}
                      >
                        {"Custom Reporting"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item142"}
                      data-plasmic-override={overrides.item142}
                      className={classNames("all", sty.item142)}
                    >
                      <div
                        data-plasmic-name={"left142"}
                        data-plasmic-override={overrides.left142}
                        className={classNames("all", sty.left142)}
                      >
                        <div
                          data-plasmic-name={"icon142"}
                          data-plasmic-override={overrides.icon142}
                          className={classNames("all", sty.icon142)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__qm6E)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title145"}
                        data-plasmic-override={overrides.title145}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title145
                        )}
                      >
                        {"Electronic Contracts & Signatures"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item143"}
                      data-plasmic-override={overrides.item143}
                      className={classNames("all", sty.item143)}
                    >
                      <div
                        data-plasmic-name={"left143"}
                        data-plasmic-override={overrides.left143}
                        className={classNames("all", sty.left143)}
                      >
                        <div
                          data-plasmic-name={"icon143"}
                          data-plasmic-override={overrides.icon143}
                          className={classNames("all", sty.icon143)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__mjiy0)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title146"}
                        data-plasmic-override={overrides.title146}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title146
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item144"}
                      data-plasmic-override={overrides.item144}
                      className={classNames("all", sty.item144)}
                    >
                      <div
                        data-plasmic-name={"left144"}
                        data-plasmic-override={overrides.left144}
                        className={classNames("all", sty.left144)}
                      >
                        <div
                          data-plasmic-name={"icon144"}
                          data-plasmic-override={overrides.icon144}
                          className={classNames("all", sty.icon144)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___8OBhe)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title147"}
                        data-plasmic-override={overrides.title147}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title147
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                data-plasmic-name={"section3"}
                data-plasmic-override={overrides.section3}
                className={classNames("all", sty.section3)}
              >
                <div
                  data-plasmic-name={"header11"}
                  data-plasmic-override={overrides.header11}
                  className={classNames("all", "__wab_text", sty.header11)}
                >
                  {"GME Programs"}
                </div>
                <div
                  data-plasmic-name={"list9"}
                  data-plasmic-override={overrides.list9}
                  className={classNames("all", sty.list9)}
                >
                  <div
                    data-plasmic-name={"item145"}
                    data-plasmic-override={overrides.item145}
                    className={classNames("all", sty.item145)}
                  >
                    <div
                      data-plasmic-name={"left145"}
                      data-plasmic-override={overrides.left145}
                      className={classNames("all", sty.left145)}
                    >
                      <div
                        data-plasmic-name={"icon145"}
                        data-plasmic-override={overrides.icon145}
                        className={classNames("all", sty.icon145)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__wnWaf)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title148"}
                      data-plasmic-override={overrides.title148}
                      className={classNames("all", "__wab_text", sty.title148)}
                    >
                      {"Annual Program Evaluations"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item146"}
                    data-plasmic-override={overrides.item146}
                    className={classNames("all", sty.item146)}
                  >
                    <div
                      data-plasmic-name={"left146"}
                      data-plasmic-override={overrides.left146}
                      className={classNames("all", sty.left146)}
                    >
                      <div
                        data-plasmic-name={"icon146"}
                        data-plasmic-override={overrides.icon146}
                        className={classNames("all", sty.icon146)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__q4ROi)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title149"}
                      data-plasmic-override={overrides.title149}
                      className={classNames("all", "__wab_text", sty.title149)}
                    >
                      {"Common Program Requirements"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item147"}
                    data-plasmic-override={overrides.item147}
                    className={classNames("all", sty.item147)}
                  >
                    <div
                      data-plasmic-name={"left147"}
                      data-plasmic-override={overrides.left147}
                      className={classNames("all", sty.left147)}
                    >
                      <div
                        data-plasmic-name={"icon147"}
                        data-plasmic-override={overrides.icon147}
                        className={classNames("all", sty.icon147)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__lRZm)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title150"}
                      data-plasmic-override={overrides.title150}
                      className={classNames("all", "__wab_text", sty.title150)}
                    >
                      {"Institutional Requirements"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item148"}
                    data-plasmic-override={overrides.item148}
                    className={classNames("all", sty.item148)}
                  >
                    <div
                      data-plasmic-name={"left148"}
                      data-plasmic-override={overrides.left148}
                      className={classNames("all", sty.left148)}
                    >
                      <div
                        data-plasmic-name={"icon148"}
                        data-plasmic-override={overrides.icon148}
                        className={classNames("all", sty.icon148)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___65L53)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title151"}
                      data-plasmic-override={overrides.title151}
                      className={classNames("all", "__wab_text", sty.title151)}
                    >
                      {"Take Action Plans & Notifications"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item149"}
                    data-plasmic-override={overrides.item149}
                    className={classNames("all", sty.item149)}
                  >
                    <div
                      data-plasmic-name={"left149"}
                      data-plasmic-override={overrides.left149}
                      className={classNames("all", sty.left149)}
                    >
                      <div
                        data-plasmic-name={"icon149"}
                        data-plasmic-override={overrides.icon149}
                        className={classNames("all", sty.icon149)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__yfTjW)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title152"}
                      data-plasmic-override={overrides.title152}
                      className={classNames("all", "__wab_text", sty.title152)}
                    >
                      {"ERAS Data Importing"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item150"}
                    data-plasmic-override={overrides.item150}
                    className={classNames("all", sty.item150)}
                  >
                    <div
                      data-plasmic-name={"left150"}
                      data-plasmic-override={overrides.left150}
                      className={classNames("all", sty.left150)}
                    >
                      <div
                        data-plasmic-name={"icon150"}
                        data-plasmic-override={overrides.icon150}
                        className={classNames("all", sty.icon150)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___0Ma6R)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title153"}
                      data-plasmic-override={overrides.title153}
                      className={classNames("all", "__wab_text", sty.title153)}
                    >
                      {"Electronic Contract Management"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item151"}
                      data-plasmic-override={overrides.item151}
                      className={classNames("all", sty.item151)}
                    >
                      <div
                        data-plasmic-name={"left151"}
                        data-plasmic-override={overrides.left151}
                        className={classNames("all", sty.left151)}
                      >
                        <div
                          data-plasmic-name={"icon151"}
                          data-plasmic-override={overrides.icon151}
                          className={classNames("all", sty.icon151)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__lN8V0)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title154"}
                        data-plasmic-override={overrides.title154}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title154
                        )}
                      >
                        {"Conference Tracking"}
                      </div>
                    </div>
                  ) : null}
                  <div
                    data-plasmic-name={"item152"}
                    data-plasmic-override={overrides.item152}
                    className={classNames("all", sty.item152)}
                  >
                    <div
                      data-plasmic-name={"left152"}
                      data-plasmic-override={overrides.left152}
                      className={classNames("all", sty.left152)}
                    >
                      <div
                        data-plasmic-name={"icon152"}
                        data-plasmic-override={overrides.icon152}
                        className={classNames("all", sty.icon152)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__cDZei)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title155"}
                      data-plasmic-override={overrides.title155}
                      className={classNames("all", "__wab_text", sty.title155)}
                    >
                      {"Clinical Log (3rd Party) Integration"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item153"}
                    data-plasmic-override={overrides.item153}
                    className={classNames("all", sty.item153)}
                  >
                    <div
                      data-plasmic-name={"left153"}
                      data-plasmic-override={overrides.left153}
                      className={classNames("all", sty.left153)}
                    >
                      <div
                        data-plasmic-name={"icon153"}
                        data-plasmic-override={overrides.icon153}
                        className={classNames("all", sty.icon153)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___9G1C8)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title156"}
                      data-plasmic-override={overrides.title156}
                      className={classNames("all", "__wab_text", sty.title156)}
                    >
                      {"EHR Connectivity"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item154"}
                      data-plasmic-override={overrides.item154}
                      className={classNames("all", sty.item154)}
                    >
                      <div
                        data-plasmic-name={"left154"}
                        data-plasmic-override={overrides.left154}
                        className={classNames("all", sty.left154)}
                      >
                        <div
                          data-plasmic-name={"icon154"}
                          data-plasmic-override={overrides.icon154}
                          className={classNames("all", sty.icon154)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__ip1M)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title157"}
                        data-plasmic-override={overrides.title157}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title157
                        )}
                      >
                        {"Clinical Log (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item155"}
                      data-plasmic-override={overrides.item155}
                      className={classNames("all", sty.item155)}
                    >
                      <div
                        data-plasmic-name={"left155"}
                        data-plasmic-override={overrides.left155}
                        className={classNames("all", sty.left155)}
                      >
                        <div
                          data-plasmic-name={"icon155"}
                          data-plasmic-override={overrides.icon155}
                          className={classNames("all", sty.icon155)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__gwgjM)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title158"}
                        data-plasmic-override={overrides.title158}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title158
                        )}
                      >
                        {"Learning Assignments"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item156"}
                      data-plasmic-override={overrides.item156}
                      className={classNames("all", sty.item156)}
                    >
                      <div
                        data-plasmic-name={"left156"}
                        data-plasmic-override={overrides.left156}
                        className={classNames("all", sty.left156)}
                      >
                        <div
                          data-plasmic-name={"icon156"}
                          data-plasmic-override={overrides.icon156}
                          className={classNames("all", sty.icon156)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__y4OQd)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title159"}
                        data-plasmic-override={overrides.title159}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title159
                        )}
                      >
                        {"MyQuiz (Quizzes/Exams)"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item157"}
                      data-plasmic-override={overrides.item157}
                      className={classNames("all", sty.item157)}
                    >
                      <div
                        data-plasmic-name={"left157"}
                        data-plasmic-override={overrides.left157}
                        className={classNames("all", sty.left157)}
                      >
                        <div
                          data-plasmic-name={"icon157"}
                          data-plasmic-override={overrides.icon157}
                          className={classNames("all", sty.icon157)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__qwa6K)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title160"}
                        data-plasmic-override={overrides.title160}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title160
                        )}
                      >
                        {"Demographic Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item158"}
                      data-plasmic-override={overrides.item158}
                      className={classNames("all", sty.item158)}
                    >
                      <div
                        data-plasmic-name={"left158"}
                        data-plasmic-override={overrides.left158}
                        className={classNames("all", sty.left158)}
                      >
                        <div
                          data-plasmic-name={"icon158"}
                          data-plasmic-override={overrides.icon158}
                          className={classNames("all", sty.icon158)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__mQkLe)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title161"}
                        data-plasmic-override={overrides.title161}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title161
                        )}
                      >
                        {"Onboarding & Credentialing"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item159"}
                      data-plasmic-override={overrides.item159}
                      className={classNames("all", sty.item159)}
                    >
                      <div
                        data-plasmic-name={"left159"}
                        data-plasmic-override={overrides.left159}
                        className={classNames("all", sty.left159)}
                      >
                        <div
                          data-plasmic-name={"icon159"}
                          data-plasmic-override={overrides.icon159}
                          className={classNames("all", sty.icon159)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__gMpip)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title162"}
                        data-plasmic-override={overrides.title162}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title162
                        )}
                      >
                        {"Certificate/Diploma Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item160"}
                      data-plasmic-override={overrides.item160}
                      className={classNames("all", sty.item160)}
                    >
                      <div
                        data-plasmic-name={"left160"}
                        data-plasmic-override={overrides.left160}
                        className={classNames("all", sty.left160)}
                      >
                        <div
                          data-plasmic-name={"icon160"}
                          data-plasmic-override={overrides.icon160}
                          className={classNames("all", sty.icon160)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___7KtnC)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title163"}
                        data-plasmic-override={overrides.title163}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title163
                        )}
                      >
                        {"Schedule Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item161"}
                      data-plasmic-override={overrides.item161}
                      className={classNames("all", sty.item161)}
                    >
                      <div
                        data-plasmic-name={"left161"}
                        data-plasmic-override={overrides.left161}
                        className={classNames("all", sty.left161)}
                      >
                        <div
                          data-plasmic-name={"icon161"}
                          data-plasmic-override={overrides.icon161}
                          className={classNames("all", sty.icon161)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__xMrdW)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title164"}
                        data-plasmic-override={overrides.title164}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title164
                        )}
                      >
                        {"Automatic Scheduling & Lottery"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item162"}
                      data-plasmic-override={overrides.item162}
                      className={classNames("all", sty.item162)}
                    >
                      <div
                        data-plasmic-name={"left162"}
                        data-plasmic-override={overrides.left162}
                        className={classNames("all", sty.left162)}
                      >
                        <div
                          data-plasmic-name={"icon162"}
                          data-plasmic-override={overrides.icon162}
                          className={classNames("all", sty.icon162)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___3OO8A)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title165"}
                        data-plasmic-override={overrides.title165}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title165
                        )}
                      >
                        {"Schedule (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item163"}
                      data-plasmic-override={overrides.item163}
                      className={classNames("all", sty.item163)}
                    >
                      <div
                        data-plasmic-name={"left163"}
                        data-plasmic-override={overrides.left163}
                        className={classNames("all", sty.left163)}
                      >
                        <div
                          data-plasmic-name={"icon163"}
                          data-plasmic-override={overrides.icon163}
                          className={classNames("all", sty.icon163)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__bKqpG)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title166"}
                        data-plasmic-override={overrides.title166}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title166
                        )}
                      >
                        {"MyPortfolios"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item164"}
                      data-plasmic-override={overrides.item164}
                      className={classNames("all", sty.item164)}
                    >
                      <div
                        data-plasmic-name={"left164"}
                        data-plasmic-override={overrides.left164}
                        className={classNames("all", sty.left164)}
                      >
                        <div
                          data-plasmic-name={"icon164"}
                          data-plasmic-override={overrides.icon164}
                          className={classNames("all", sty.icon164)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___192Tl)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title167"}
                        data-plasmic-override={overrides.title167}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title167
                        )}
                      >
                        {"Performance Dashboard"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item165"}
                      data-plasmic-override={overrides.item165}
                      className={classNames("all", sty.item165)}
                    >
                      <div
                        data-plasmic-name={"left165"}
                        data-plasmic-override={overrides.left165}
                        className={classNames("all", sty.left165)}
                      >
                        <div
                          data-plasmic-name={"icon165"}
                          data-plasmic-override={overrides.icon165}
                          className={classNames("all", sty.icon165)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__hdi46)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title168"}
                        data-plasmic-override={overrides.title168}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title168
                        )}
                      >
                        {"Custom Reporting"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item166"}
                      data-plasmic-override={overrides.item166}
                      className={classNames("all", sty.item166)}
                    >
                      <div
                        data-plasmic-name={"left166"}
                        data-plasmic-override={overrides.left166}
                        className={classNames("all", sty.left166)}
                      >
                        <div
                          data-plasmic-name={"icon166"}
                          data-plasmic-override={overrides.icon166}
                          className={classNames("all", sty.icon166)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__vdc6G)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title169"}
                        data-plasmic-override={overrides.title169}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title169
                        )}
                      >
                        {"Electronic Contracts & Signatures"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item167"}
                      data-plasmic-override={overrides.item167}
                      className={classNames("all", sty.item167)}
                    >
                      <div
                        data-plasmic-name={"left167"}
                        data-plasmic-override={overrides.left167}
                        className={classNames("all", sty.left167)}
                      >
                        <div
                          data-plasmic-name={"icon167"}
                          data-plasmic-override={overrides.icon167}
                          className={classNames("all", sty.icon167)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__jxqVi)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title170"}
                        data-plasmic-override={overrides.title170}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title170
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item168"}
                      data-plasmic-override={overrides.item168}
                      className={classNames("all", sty.item168)}
                    >
                      <div
                        data-plasmic-name={"left168"}
                        data-plasmic-override={overrides.left168}
                        className={classNames("all", sty.left168)}
                      >
                        <div
                          data-plasmic-name={"icon168"}
                          data-plasmic-override={overrides.icon168}
                          className={classNames("all", sty.icon168)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__nx8AU)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title171"}
                        data-plasmic-override={overrides.title171}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title171
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                data-plasmic-name={"section4"}
                data-plasmic-override={overrides.section4}
                className={classNames("all", sty.section4)}
              >
                <div
                  data-plasmic-name={"header12"}
                  data-plasmic-override={overrides.header12}
                  className={classNames("all", "__wab_text", sty.header12)}
                >
                  {"Nursing Programs"}
                </div>
                <div
                  data-plasmic-name={"list10"}
                  data-plasmic-override={overrides.list10}
                  className={classNames("all", sty.list10)}
                >
                  <div
                    data-plasmic-name={"item169"}
                    data-plasmic-override={overrides.item169}
                    className={classNames("all", sty.item169)}
                  >
                    <div
                      data-plasmic-name={"left169"}
                      data-plasmic-override={overrides.left169}
                      className={classNames("all", sty.left169)}
                    >
                      <div
                        data-plasmic-name={"icon169"}
                        data-plasmic-override={overrides.icon169}
                        className={classNames("all", sty.icon169)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__vpbBg)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title172"}
                      data-plasmic-override={overrides.title172}
                      className={classNames("all", "__wab_text", sty.title172)}
                    >
                      {"Clinical Activity Logger"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item170"}
                    data-plasmic-override={overrides.item170}
                    className={classNames("all", sty.item170)}
                  >
                    <div
                      data-plasmic-name={"left170"}
                      data-plasmic-override={overrides.left170}
                      className={classNames("all", sty.left170)}
                    >
                      <div
                        data-plasmic-name={"icon170"}
                        data-plasmic-override={overrides.icon170}
                        className={classNames("all", sty.icon170)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg___8HxLw)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title173"}
                      data-plasmic-override={overrides.title173}
                      className={classNames("all", "__wab_text", sty.title173)}
                    >
                      {"Return Demonstration Management"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item171"}
                    data-plasmic-override={overrides.item171}
                    className={classNames("all", sty.item171)}
                  >
                    <div
                      data-plasmic-name={"left171"}
                      data-plasmic-override={overrides.left171}
                      className={classNames("all", sty.left171)}
                    >
                      <div
                        data-plasmic-name={"icon171"}
                        data-plasmic-override={overrides.icon171}
                        className={classNames("all", sty.icon171)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__x73E)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title174"}
                      data-plasmic-override={overrides.title174}
                      className={classNames("all", "__wab_text", sty.title174)}
                    >
                      {"Return Demonstration Testing"}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"item172"}
                    data-plasmic-override={overrides.item172}
                    className={classNames("all", sty.item172)}
                  >
                    <div
                      data-plasmic-name={"left172"}
                      data-plasmic-override={overrides.left172}
                      className={classNames("all", sty.left172)}
                    >
                      <div
                        data-plasmic-name={"icon172"}
                        data-plasmic-override={overrides.icon172}
                        className={classNames("all", sty.icon172)}
                      >
                        <Icon93Icon
                          className={classNames("all", sty.svg__kwzvn)}
                          role={"img"}
                        />
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"title175"}
                      data-plasmic-override={overrides.title175}
                      className={classNames("all", "__wab_text", sty.title175)}
                    >
                      {"Clinical Learning Contracts"}
                    </div>
                  </div>
                  {false ? (
                    <div
                      data-plasmic-name={"item173"}
                      data-plasmic-override={overrides.item173}
                      className={classNames("all", sty.item173)}
                    >
                      <div
                        data-plasmic-name={"left173"}
                        data-plasmic-override={overrides.left173}
                        className={classNames("all", sty.left173)}
                      >
                        <div
                          data-plasmic-name={"icon173"}
                          data-plasmic-override={overrides.icon173}
                          className={classNames("all", sty.icon173)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__bQNln)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title176"}
                        data-plasmic-override={overrides.title176}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title176
                        )}
                      >
                        {"Clinical Hours (Duty-Hours)"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item174"}
                      data-plasmic-override={overrides.item174}
                      className={classNames("all", sty.item174)}
                    >
                      <div
                        data-plasmic-name={"left174"}
                        data-plasmic-override={overrides.left174}
                        className={classNames("all", sty.left174)}
                      >
                        <div
                          data-plasmic-name={"icon174"}
                          data-plasmic-override={overrides.icon174}
                          className={classNames("all", sty.icon174)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__zdisi)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title177"}
                        data-plasmic-override={overrides.title177}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title177
                        )}
                      >
                        {"MyQuickPass"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item175"}
                      data-plasmic-override={overrides.item175}
                      className={classNames("all", sty.item175)}
                    >
                      <div
                        data-plasmic-name={"left175"}
                        data-plasmic-override={overrides.left175}
                        className={classNames("all", sty.left175)}
                      >
                        <div
                          data-plasmic-name={"icon175"}
                          data-plasmic-override={overrides.icon175}
                          className={classNames("all", sty.icon175)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__eaAvN)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title178"}
                        data-plasmic-override={overrides.title178}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title178
                        )}
                      >
                        {"Conference Tracking"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item176"}
                      data-plasmic-override={overrides.item176}
                      className={classNames("all", sty.item176)}
                    >
                      <div
                        data-plasmic-name={"left176"}
                        data-plasmic-override={overrides.left176}
                        className={classNames("all", sty.left176)}
                      >
                        <div
                          data-plasmic-name={"icon176"}
                          data-plasmic-override={overrides.icon176}
                          className={classNames("all", sty.icon176)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__vy74M)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title179"}
                        data-plasmic-override={overrides.title179}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title179
                        )}
                      >
                        {"Burnout Monitoring"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item177"}
                      data-plasmic-override={overrides.item177}
                      className={classNames("all", sty.item177)}
                    >
                      <div
                        data-plasmic-name={"left177"}
                        data-plasmic-override={overrides.left177}
                        className={classNames("all", sty.left177)}
                      >
                        <div
                          data-plasmic-name={"icon177"}
                          data-plasmic-override={overrides.icon177}
                          className={classNames("all", sty.icon177)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___7U5Uk)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title180"}
                        data-plasmic-override={overrides.title180}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title180
                        )}
                      >
                        {"EHR Connectivity"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item178"}
                      data-plasmic-override={overrides.item178}
                      className={classNames("all", sty.item178)}
                    >
                      <div
                        data-plasmic-name={"left178"}
                        data-plasmic-override={overrides.left178}
                        className={classNames("all", sty.left178)}
                      >
                        <div
                          data-plasmic-name={"icon178"}
                          data-plasmic-override={overrides.icon178}
                          className={classNames("all", sty.icon178)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__g34Mu)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title181"}
                        data-plasmic-override={overrides.title181}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title181
                        )}
                      >
                        {"Clinical Log (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item179"}
                      data-plasmic-override={overrides.item179}
                      className={classNames("all", sty.item179)}
                    >
                      <div
                        data-plasmic-name={"left179"}
                        data-plasmic-override={overrides.left179}
                        className={classNames("all", sty.left179)}
                      >
                        <div
                          data-plasmic-name={"icon179"}
                          data-plasmic-override={overrides.icon179}
                          className={classNames("all", sty.icon179)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__bgnKm)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title182"}
                        data-plasmic-override={overrides.title182}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title182
                        )}
                      >
                        {"Learning Assignments"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item180"}
                      data-plasmic-override={overrides.item180}
                      className={classNames("all", sty.item180)}
                    >
                      <div
                        data-plasmic-name={"left180"}
                        data-plasmic-override={overrides.left180}
                        className={classNames("all", sty.left180)}
                      >
                        <div
                          data-plasmic-name={"icon180"}
                          data-plasmic-override={overrides.icon180}
                          className={classNames("all", sty.icon180)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__otqTn)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title183"}
                        data-plasmic-override={overrides.title183}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title183
                        )}
                      >
                        {"MyQuiz (Quizzes/Exams)"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item181"}
                      data-plasmic-override={overrides.item181}
                      className={classNames("all", sty.item181)}
                    >
                      <div
                        data-plasmic-name={"left181"}
                        data-plasmic-override={overrides.left181}
                        className={classNames("all", sty.left181)}
                      >
                        <div
                          data-plasmic-name={"icon181"}
                          data-plasmic-override={overrides.icon181}
                          className={classNames("all", sty.icon181)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__oX26B)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title184"}
                        data-plasmic-override={overrides.title184}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title184
                        )}
                      >
                        {"Demographic Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item182"}
                      data-plasmic-override={overrides.item182}
                      className={classNames("all", sty.item182)}
                    >
                      <div
                        data-plasmic-name={"left182"}
                        data-plasmic-override={overrides.left182}
                        className={classNames("all", sty.left182)}
                      >
                        <div
                          data-plasmic-name={"icon182"}
                          data-plasmic-override={overrides.icon182}
                          className={classNames("all", sty.icon182)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__kNwIz)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title185"}
                        data-plasmic-override={overrides.title185}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title185
                        )}
                      >
                        {"Onboarding & Credentialing"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item183"}
                      data-plasmic-override={overrides.item183}
                      className={classNames("all", sty.item183)}
                    >
                      <div
                        data-plasmic-name={"left183"}
                        data-plasmic-override={overrides.left183}
                        className={classNames("all", sty.left183)}
                      >
                        <div
                          data-plasmic-name={"icon183"}
                          data-plasmic-override={overrides.icon183}
                          className={classNames("all", sty.icon183)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___97S2)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title186"}
                        data-plasmic-override={overrides.title186}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title186
                        )}
                      >
                        {"Certificate/Diploma Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item184"}
                      data-plasmic-override={overrides.item184}
                      className={classNames("all", sty.item184)}
                    >
                      <div
                        data-plasmic-name={"left184"}
                        data-plasmic-override={overrides.left184}
                        className={classNames("all", sty.left184)}
                      >
                        <div
                          data-plasmic-name={"icon184"}
                          data-plasmic-override={overrides.icon184}
                          className={classNames("all", sty.icon184)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__wIjbc)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title187"}
                        data-plasmic-override={overrides.title187}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title187
                        )}
                      >
                        {"Schedule Management"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item185"}
                      data-plasmic-override={overrides.item185}
                      className={classNames("all", sty.item185)}
                    >
                      <div
                        data-plasmic-name={"left185"}
                        data-plasmic-override={overrides.left185}
                        className={classNames("all", sty.left185)}
                      >
                        <div
                          data-plasmic-name={"icon185"}
                          data-plasmic-override={overrides.icon185}
                          className={classNames("all", sty.icon185)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___7YqR7)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title188"}
                        data-plasmic-override={overrides.title188}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title188
                        )}
                      >
                        {"Automatic Scheduling & Lottery"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item186"}
                      data-plasmic-override={overrides.item186}
                      className={classNames("all", sty.item186)}
                    >
                      <div
                        data-plasmic-name={"left186"}
                        data-plasmic-override={overrides.left186}
                        className={classNames("all", sty.left186)}
                      >
                        <div
                          data-plasmic-name={"icon186"}
                          data-plasmic-override={overrides.icon186}
                          className={classNames("all", sty.icon186)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg___6180W)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title189"}
                        data-plasmic-override={overrides.title189}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title189
                        )}
                      >
                        {"Schedule (3rd Party) Integration"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item187"}
                      data-plasmic-override={overrides.item187}
                      className={classNames("all", sty.item187)}
                    >
                      <div
                        data-plasmic-name={"left187"}
                        data-plasmic-override={overrides.left187}
                        className={classNames("all", sty.left187)}
                      >
                        <div
                          data-plasmic-name={"icon187"}
                          data-plasmic-override={overrides.icon187}
                          className={classNames("all", sty.icon187)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__nuTvV)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title190"}
                        data-plasmic-override={overrides.title190}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title190
                        )}
                      >
                        {"MyPortfolios"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item188"}
                      data-plasmic-override={overrides.item188}
                      className={classNames("all", sty.item188)}
                    >
                      <div
                        data-plasmic-name={"left188"}
                        data-plasmic-override={overrides.left188}
                        className={classNames("all", sty.left188)}
                      >
                        <div
                          data-plasmic-name={"icon188"}
                          data-plasmic-override={overrides.icon188}
                          className={classNames("all", sty.icon188)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__enlQa)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title191"}
                        data-plasmic-override={overrides.title191}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title191
                        )}
                      >
                        {"Performance Dashboard"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item189"}
                      data-plasmic-override={overrides.item189}
                      className={classNames("all", sty.item189)}
                    >
                      <div
                        data-plasmic-name={"left189"}
                        data-plasmic-override={overrides.left189}
                        className={classNames("all", sty.left189)}
                      >
                        <div
                          data-plasmic-name={"icon189"}
                          data-plasmic-override={overrides.icon189}
                          className={classNames("all", sty.icon189)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__xiKS)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title192"}
                        data-plasmic-override={overrides.title192}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title192
                        )}
                      >
                        {"Custom Reporting"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item190"}
                      data-plasmic-override={overrides.item190}
                      className={classNames("all", sty.item190)}
                    >
                      <div
                        data-plasmic-name={"left190"}
                        data-plasmic-override={overrides.left190}
                        className={classNames("all", sty.left190)}
                      >
                        <div
                          data-plasmic-name={"icon190"}
                          data-plasmic-override={overrides.icon190}
                          className={classNames("all", sty.icon190)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__ldbgl)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title193"}
                        data-plasmic-override={overrides.title193}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title193
                        )}
                      >
                        {"Electronic Contracts & Signatures"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item191"}
                      data-plasmic-override={overrides.item191}
                      className={classNames("all", sty.item191)}
                    >
                      <div
                        data-plasmic-name={"left191"}
                        data-plasmic-override={overrides.left191}
                        className={classNames("all", sty.left191)}
                      >
                        <div
                          data-plasmic-name={"icon191"}
                          data-plasmic-override={overrides.icon191}
                          className={classNames("all", sty.icon191)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__kvs5Z)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title194"}
                        data-plasmic-override={overrides.title194}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title194
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                  {false ? (
                    <div
                      data-plasmic-name={"item192"}
                      data-plasmic-override={overrides.item192}
                      className={classNames("all", sty.item192)}
                    >
                      <div
                        data-plasmic-name={"left192"}
                        data-plasmic-override={overrides.left192}
                        className={classNames("all", sty.left192)}
                      >
                        <div
                          data-plasmic-name={"icon192"}
                          data-plasmic-override={overrides.icon192}
                          className={classNames("all", sty.icon192)}
                        >
                          <Icon93Icon
                            className={classNames("all", sty.svg__joLd2)}
                            role={"img"}
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"title195"}
                        data-plasmic-override={overrides.title195}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title195
                        )}
                      >
                        {"Feature Item"}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  myEvaluations: [
    "myEvaluations",
    "desktop",
    "row",
    "logo",
    "key2",
    "header",
    "list",
    "row2",
    "row3",
    "row4",
    "all",
    "title",
    "sections",
    "col",
    "header5",
    "list5",
    "item",
    "left",
    "icon",
    "title98",
    "item2",
    "left2",
    "icon2",
    "title99",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "col2",
    "section",
    "header6",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title26",
    "item26",
    "left26",
    "icon26",
    "title27",
    "item27",
    "left27",
    "icon27",
    "title28",
    "item28",
    "left28",
    "icon28",
    "title29",
    "item29",
    "left29",
    "icon29",
    "title30",
    "item30",
    "left30",
    "icon30",
    "title31",
    "item31",
    "left31",
    "icon31",
    "title32",
    "item32",
    "left32",
    "icon32",
    "title33",
    "item33",
    "left33",
    "icon33",
    "title34",
    "item34",
    "left34",
    "icon34",
    "title35",
    "item35",
    "left35",
    "icon35",
    "title36",
    "item36",
    "left36",
    "icon36",
    "title37",
    "item37",
    "left37",
    "icon37",
    "title38",
    "item38",
    "left38",
    "icon38",
    "title39",
    "item39",
    "left39",
    "icon39",
    "title40",
    "item40",
    "left40",
    "icon40",
    "title41",
    "item41",
    "left41",
    "icon41",
    "title42",
    "item42",
    "left42",
    "icon42",
    "title43",
    "item43",
    "left43",
    "icon43",
    "title44",
    "item44",
    "left44",
    "icon44",
    "title45",
    "item45",
    "left45",
    "icon45",
    "title46",
    "item46",
    "left46",
    "icon46",
    "title47",
    "item47",
    "left47",
    "icon47",
    "title48",
    "item48",
    "left48",
    "icon48",
    "title49",
    "section2",
    "header7",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title50",
    "item50",
    "left50",
    "icon50",
    "title51",
    "item51",
    "left51",
    "icon51",
    "title52",
    "item52",
    "left52",
    "icon52",
    "title53",
    "item53",
    "left53",
    "icon53",
    "title54",
    "item54",
    "left54",
    "icon54",
    "title55",
    "item55",
    "left55",
    "icon55",
    "title56",
    "item56",
    "left56",
    "icon56",
    "title57",
    "item57",
    "left57",
    "icon57",
    "title58",
    "item58",
    "left58",
    "icon58",
    "title59",
    "item59",
    "left59",
    "icon59",
    "title60",
    "item60",
    "left60",
    "icon60",
    "title61",
    "item61",
    "left61",
    "icon61",
    "title62",
    "item62",
    "left62",
    "icon62",
    "title63",
    "item63",
    "left63",
    "icon63",
    "title64",
    "item64",
    "left64",
    "icon64",
    "title65",
    "item65",
    "left65",
    "icon65",
    "title66",
    "item66",
    "left66",
    "icon66",
    "title67",
    "item67",
    "left67",
    "icon67",
    "title68",
    "item68",
    "left68",
    "icon68",
    "title69",
    "item69",
    "left69",
    "icon69",
    "title70",
    "item70",
    "left70",
    "icon70",
    "title71",
    "item71",
    "left71",
    "icon71",
    "title72",
    "item72",
    "left72",
    "icon72",
    "title73",
    "col3",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title74",
    "item74",
    "left74",
    "icon74",
    "title75",
    "item75",
    "left75",
    "icon75",
    "title76",
    "item76",
    "left76",
    "icon76",
    "title77",
    "item77",
    "left77",
    "icon77",
    "title78",
    "item78",
    "left78",
    "icon78",
    "title79",
    "item79",
    "left79",
    "icon79",
    "title80",
    "item80",
    "left80",
    "icon80",
    "title81",
    "item81",
    "left81",
    "icon81",
    "title82",
    "item82",
    "left82",
    "icon82",
    "title83",
    "item83",
    "left83",
    "icon83",
    "title84",
    "item84",
    "left84",
    "icon84",
    "title85",
    "item85",
    "left85",
    "icon85",
    "title86",
    "item86",
    "left86",
    "icon86",
    "title87",
    "item87",
    "left87",
    "icon87",
    "title88",
    "item88",
    "left88",
    "icon88",
    "title89",
    "item89",
    "left89",
    "icon89",
    "title90",
    "item90",
    "left90",
    "icon90",
    "title91",
    "item91",
    "left91",
    "icon91",
    "title92",
    "item92",
    "left92",
    "icon92",
    "title93",
    "item93",
    "left93",
    "icon93",
    "title94",
    "item94",
    "left94",
    "icon94",
    "title95",
    "item95",
    "left95",
    "icon95",
    "title96",
    "item96",
    "left96",
    "icon96",
    "title97",
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "row9",
    "row10",
    "row11",
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15",
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title100",
    "sections2",
    "section7",
    "header9",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "section8",
    "header10",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title124",
    "item122",
    "left122",
    "icon122",
    "title125",
    "item123",
    "left123",
    "icon123",
    "title126",
    "item124",
    "left124",
    "icon124",
    "title127",
    "item125",
    "left125",
    "icon125",
    "title128",
    "item126",
    "left126",
    "icon126",
    "title129",
    "item127",
    "left127",
    "icon127",
    "title130",
    "item128",
    "left128",
    "icon128",
    "title131",
    "item129",
    "left129",
    "icon129",
    "title132",
    "item130",
    "left130",
    "icon130",
    "title133",
    "item131",
    "left131",
    "icon131",
    "title134",
    "item132",
    "left132",
    "icon132",
    "title135",
    "item133",
    "left133",
    "icon133",
    "title136",
    "item134",
    "left134",
    "icon134",
    "title137",
    "item135",
    "left135",
    "icon135",
    "title138",
    "item136",
    "left136",
    "icon136",
    "title139",
    "item137",
    "left137",
    "icon137",
    "title140",
    "item138",
    "left138",
    "icon138",
    "title141",
    "item139",
    "left139",
    "icon139",
    "title142",
    "item140",
    "left140",
    "icon140",
    "title143",
    "item141",
    "left141",
    "icon141",
    "title144",
    "item142",
    "left142",
    "icon142",
    "title145",
    "item143",
    "left143",
    "icon143",
    "title146",
    "item144",
    "left144",
    "icon144",
    "title147",
    "section3",
    "header11",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title148",
    "item146",
    "left146",
    "icon146",
    "title149",
    "item147",
    "left147",
    "icon147",
    "title150",
    "item148",
    "left148",
    "icon148",
    "title151",
    "item149",
    "left149",
    "icon149",
    "title152",
    "item150",
    "left150",
    "icon150",
    "title153",
    "item151",
    "left151",
    "icon151",
    "title154",
    "item152",
    "left152",
    "icon152",
    "title155",
    "item153",
    "left153",
    "icon153",
    "title156",
    "item154",
    "left154",
    "icon154",
    "title157",
    "item155",
    "left155",
    "icon155",
    "title158",
    "item156",
    "left156",
    "icon156",
    "title159",
    "item157",
    "left157",
    "icon157",
    "title160",
    "item158",
    "left158",
    "icon158",
    "title161",
    "item159",
    "left159",
    "icon159",
    "title162",
    "item160",
    "left160",
    "icon160",
    "title163",
    "item161",
    "left161",
    "icon161",
    "title164",
    "item162",
    "left162",
    "icon162",
    "title165",
    "item163",
    "left163",
    "icon163",
    "title166",
    "item164",
    "left164",
    "icon164",
    "title167",
    "item165",
    "left165",
    "icon165",
    "title168",
    "item166",
    "left166",
    "icon166",
    "title169",
    "item167",
    "left167",
    "icon167",
    "title170",
    "item168",
    "left168",
    "icon168",
    "title171",
    "section4",
    "header12",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title172",
    "item170",
    "left170",
    "icon170",
    "title173",
    "item171",
    "left171",
    "icon171",
    "title174",
    "item172",
    "left172",
    "icon172",
    "title175",
    "item173",
    "left173",
    "icon173",
    "title176",
    "item174",
    "left174",
    "icon174",
    "title177",
    "item175",
    "left175",
    "icon175",
    "title178",
    "item176",
    "left176",
    "icon176",
    "title179",
    "item177",
    "left177",
    "icon177",
    "title180",
    "item178",
    "left178",
    "icon178",
    "title181",
    "item179",
    "left179",
    "icon179",
    "title182",
    "item180",
    "left180",
    "icon180",
    "title183",
    "item181",
    "left181",
    "icon181",
    "title184",
    "item182",
    "left182",
    "icon182",
    "title185",
    "item183",
    "left183",
    "icon183",
    "title186",
    "item184",
    "left184",
    "icon184",
    "title187",
    "item185",
    "left185",
    "icon185",
    "title188",
    "item186",
    "left186",
    "icon186",
    "title189",
    "item187",
    "left187",
    "icon187",
    "title190",
    "item188",
    "left188",
    "icon188",
    "title191",
    "item189",
    "left189",
    "icon189",
    "title192",
    "item190",
    "left190",
    "icon190",
    "title193",
    "item191",
    "left191",
    "icon191",
    "title194",
    "item192",
    "left192",
    "icon192",
    "title195"
  ],
  desktop: [
    "desktop",
    "row",
    "logo",
    "key2",
    "header",
    "list",
    "row2",
    "row3",
    "row4",
    "all",
    "title",
    "sections",
    "col",
    "header5",
    "list5",
    "item",
    "left",
    "icon",
    "title98",
    "item2",
    "left2",
    "icon2",
    "title99",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "col2",
    "section",
    "header6",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title26",
    "item26",
    "left26",
    "icon26",
    "title27",
    "item27",
    "left27",
    "icon27",
    "title28",
    "item28",
    "left28",
    "icon28",
    "title29",
    "item29",
    "left29",
    "icon29",
    "title30",
    "item30",
    "left30",
    "icon30",
    "title31",
    "item31",
    "left31",
    "icon31",
    "title32",
    "item32",
    "left32",
    "icon32",
    "title33",
    "item33",
    "left33",
    "icon33",
    "title34",
    "item34",
    "left34",
    "icon34",
    "title35",
    "item35",
    "left35",
    "icon35",
    "title36",
    "item36",
    "left36",
    "icon36",
    "title37",
    "item37",
    "left37",
    "icon37",
    "title38",
    "item38",
    "left38",
    "icon38",
    "title39",
    "item39",
    "left39",
    "icon39",
    "title40",
    "item40",
    "left40",
    "icon40",
    "title41",
    "item41",
    "left41",
    "icon41",
    "title42",
    "item42",
    "left42",
    "icon42",
    "title43",
    "item43",
    "left43",
    "icon43",
    "title44",
    "item44",
    "left44",
    "icon44",
    "title45",
    "item45",
    "left45",
    "icon45",
    "title46",
    "item46",
    "left46",
    "icon46",
    "title47",
    "item47",
    "left47",
    "icon47",
    "title48",
    "item48",
    "left48",
    "icon48",
    "title49",
    "section2",
    "header7",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title50",
    "item50",
    "left50",
    "icon50",
    "title51",
    "item51",
    "left51",
    "icon51",
    "title52",
    "item52",
    "left52",
    "icon52",
    "title53",
    "item53",
    "left53",
    "icon53",
    "title54",
    "item54",
    "left54",
    "icon54",
    "title55",
    "item55",
    "left55",
    "icon55",
    "title56",
    "item56",
    "left56",
    "icon56",
    "title57",
    "item57",
    "left57",
    "icon57",
    "title58",
    "item58",
    "left58",
    "icon58",
    "title59",
    "item59",
    "left59",
    "icon59",
    "title60",
    "item60",
    "left60",
    "icon60",
    "title61",
    "item61",
    "left61",
    "icon61",
    "title62",
    "item62",
    "left62",
    "icon62",
    "title63",
    "item63",
    "left63",
    "icon63",
    "title64",
    "item64",
    "left64",
    "icon64",
    "title65",
    "item65",
    "left65",
    "icon65",
    "title66",
    "item66",
    "left66",
    "icon66",
    "title67",
    "item67",
    "left67",
    "icon67",
    "title68",
    "item68",
    "left68",
    "icon68",
    "title69",
    "item69",
    "left69",
    "icon69",
    "title70",
    "item70",
    "left70",
    "icon70",
    "title71",
    "item71",
    "left71",
    "icon71",
    "title72",
    "item72",
    "left72",
    "icon72",
    "title73",
    "col3",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title74",
    "item74",
    "left74",
    "icon74",
    "title75",
    "item75",
    "left75",
    "icon75",
    "title76",
    "item76",
    "left76",
    "icon76",
    "title77",
    "item77",
    "left77",
    "icon77",
    "title78",
    "item78",
    "left78",
    "icon78",
    "title79",
    "item79",
    "left79",
    "icon79",
    "title80",
    "item80",
    "left80",
    "icon80",
    "title81",
    "item81",
    "left81",
    "icon81",
    "title82",
    "item82",
    "left82",
    "icon82",
    "title83",
    "item83",
    "left83",
    "icon83",
    "title84",
    "item84",
    "left84",
    "icon84",
    "title85",
    "item85",
    "left85",
    "icon85",
    "title86",
    "item86",
    "left86",
    "icon86",
    "title87",
    "item87",
    "left87",
    "icon87",
    "title88",
    "item88",
    "left88",
    "icon88",
    "title89",
    "item89",
    "left89",
    "icon89",
    "title90",
    "item90",
    "left90",
    "icon90",
    "title91",
    "item91",
    "left91",
    "icon91",
    "title92",
    "item92",
    "left92",
    "icon92",
    "title93",
    "item93",
    "left93",
    "icon93",
    "title94",
    "item94",
    "left94",
    "icon94",
    "title95",
    "item95",
    "left95",
    "icon95",
    "title96",
    "item96",
    "left96",
    "icon96",
    "title97"
  ],
  row: ["row", "logo"],
  logo: ["logo"],
  key2: ["key2", "header", "list", "row2", "row3", "row4"],
  header: ["header"],
  list: ["list", "row2", "row3", "row4"],
  row2: ["row2"],
  row3: ["row3"],
  row4: ["row4"],
  all: [
    "all",
    "title",
    "sections",
    "col",
    "header5",
    "list5",
    "item",
    "left",
    "icon",
    "title98",
    "item2",
    "left2",
    "icon2",
    "title99",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "col2",
    "section",
    "header6",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title26",
    "item26",
    "left26",
    "icon26",
    "title27",
    "item27",
    "left27",
    "icon27",
    "title28",
    "item28",
    "left28",
    "icon28",
    "title29",
    "item29",
    "left29",
    "icon29",
    "title30",
    "item30",
    "left30",
    "icon30",
    "title31",
    "item31",
    "left31",
    "icon31",
    "title32",
    "item32",
    "left32",
    "icon32",
    "title33",
    "item33",
    "left33",
    "icon33",
    "title34",
    "item34",
    "left34",
    "icon34",
    "title35",
    "item35",
    "left35",
    "icon35",
    "title36",
    "item36",
    "left36",
    "icon36",
    "title37",
    "item37",
    "left37",
    "icon37",
    "title38",
    "item38",
    "left38",
    "icon38",
    "title39",
    "item39",
    "left39",
    "icon39",
    "title40",
    "item40",
    "left40",
    "icon40",
    "title41",
    "item41",
    "left41",
    "icon41",
    "title42",
    "item42",
    "left42",
    "icon42",
    "title43",
    "item43",
    "left43",
    "icon43",
    "title44",
    "item44",
    "left44",
    "icon44",
    "title45",
    "item45",
    "left45",
    "icon45",
    "title46",
    "item46",
    "left46",
    "icon46",
    "title47",
    "item47",
    "left47",
    "icon47",
    "title48",
    "item48",
    "left48",
    "icon48",
    "title49",
    "section2",
    "header7",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title50",
    "item50",
    "left50",
    "icon50",
    "title51",
    "item51",
    "left51",
    "icon51",
    "title52",
    "item52",
    "left52",
    "icon52",
    "title53",
    "item53",
    "left53",
    "icon53",
    "title54",
    "item54",
    "left54",
    "icon54",
    "title55",
    "item55",
    "left55",
    "icon55",
    "title56",
    "item56",
    "left56",
    "icon56",
    "title57",
    "item57",
    "left57",
    "icon57",
    "title58",
    "item58",
    "left58",
    "icon58",
    "title59",
    "item59",
    "left59",
    "icon59",
    "title60",
    "item60",
    "left60",
    "icon60",
    "title61",
    "item61",
    "left61",
    "icon61",
    "title62",
    "item62",
    "left62",
    "icon62",
    "title63",
    "item63",
    "left63",
    "icon63",
    "title64",
    "item64",
    "left64",
    "icon64",
    "title65",
    "item65",
    "left65",
    "icon65",
    "title66",
    "item66",
    "left66",
    "icon66",
    "title67",
    "item67",
    "left67",
    "icon67",
    "title68",
    "item68",
    "left68",
    "icon68",
    "title69",
    "item69",
    "left69",
    "icon69",
    "title70",
    "item70",
    "left70",
    "icon70",
    "title71",
    "item71",
    "left71",
    "icon71",
    "title72",
    "item72",
    "left72",
    "icon72",
    "title73",
    "col3",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title74",
    "item74",
    "left74",
    "icon74",
    "title75",
    "item75",
    "left75",
    "icon75",
    "title76",
    "item76",
    "left76",
    "icon76",
    "title77",
    "item77",
    "left77",
    "icon77",
    "title78",
    "item78",
    "left78",
    "icon78",
    "title79",
    "item79",
    "left79",
    "icon79",
    "title80",
    "item80",
    "left80",
    "icon80",
    "title81",
    "item81",
    "left81",
    "icon81",
    "title82",
    "item82",
    "left82",
    "icon82",
    "title83",
    "item83",
    "left83",
    "icon83",
    "title84",
    "item84",
    "left84",
    "icon84",
    "title85",
    "item85",
    "left85",
    "icon85",
    "title86",
    "item86",
    "left86",
    "icon86",
    "title87",
    "item87",
    "left87",
    "icon87",
    "title88",
    "item88",
    "left88",
    "icon88",
    "title89",
    "item89",
    "left89",
    "icon89",
    "title90",
    "item90",
    "left90",
    "icon90",
    "title91",
    "item91",
    "left91",
    "icon91",
    "title92",
    "item92",
    "left92",
    "icon92",
    "title93",
    "item93",
    "left93",
    "icon93",
    "title94",
    "item94",
    "left94",
    "icon94",
    "title95",
    "item95",
    "left95",
    "icon95",
    "title96",
    "item96",
    "left96",
    "icon96",
    "title97"
  ],
  title: ["title"],
  sections: [
    "sections",
    "col",
    "header5",
    "list5",
    "item",
    "left",
    "icon",
    "title98",
    "item2",
    "left2",
    "icon2",
    "title99",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "col2",
    "section",
    "header6",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title26",
    "item26",
    "left26",
    "icon26",
    "title27",
    "item27",
    "left27",
    "icon27",
    "title28",
    "item28",
    "left28",
    "icon28",
    "title29",
    "item29",
    "left29",
    "icon29",
    "title30",
    "item30",
    "left30",
    "icon30",
    "title31",
    "item31",
    "left31",
    "icon31",
    "title32",
    "item32",
    "left32",
    "icon32",
    "title33",
    "item33",
    "left33",
    "icon33",
    "title34",
    "item34",
    "left34",
    "icon34",
    "title35",
    "item35",
    "left35",
    "icon35",
    "title36",
    "item36",
    "left36",
    "icon36",
    "title37",
    "item37",
    "left37",
    "icon37",
    "title38",
    "item38",
    "left38",
    "icon38",
    "title39",
    "item39",
    "left39",
    "icon39",
    "title40",
    "item40",
    "left40",
    "icon40",
    "title41",
    "item41",
    "left41",
    "icon41",
    "title42",
    "item42",
    "left42",
    "icon42",
    "title43",
    "item43",
    "left43",
    "icon43",
    "title44",
    "item44",
    "left44",
    "icon44",
    "title45",
    "item45",
    "left45",
    "icon45",
    "title46",
    "item46",
    "left46",
    "icon46",
    "title47",
    "item47",
    "left47",
    "icon47",
    "title48",
    "item48",
    "left48",
    "icon48",
    "title49",
    "section2",
    "header7",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title50",
    "item50",
    "left50",
    "icon50",
    "title51",
    "item51",
    "left51",
    "icon51",
    "title52",
    "item52",
    "left52",
    "icon52",
    "title53",
    "item53",
    "left53",
    "icon53",
    "title54",
    "item54",
    "left54",
    "icon54",
    "title55",
    "item55",
    "left55",
    "icon55",
    "title56",
    "item56",
    "left56",
    "icon56",
    "title57",
    "item57",
    "left57",
    "icon57",
    "title58",
    "item58",
    "left58",
    "icon58",
    "title59",
    "item59",
    "left59",
    "icon59",
    "title60",
    "item60",
    "left60",
    "icon60",
    "title61",
    "item61",
    "left61",
    "icon61",
    "title62",
    "item62",
    "left62",
    "icon62",
    "title63",
    "item63",
    "left63",
    "icon63",
    "title64",
    "item64",
    "left64",
    "icon64",
    "title65",
    "item65",
    "left65",
    "icon65",
    "title66",
    "item66",
    "left66",
    "icon66",
    "title67",
    "item67",
    "left67",
    "icon67",
    "title68",
    "item68",
    "left68",
    "icon68",
    "title69",
    "item69",
    "left69",
    "icon69",
    "title70",
    "item70",
    "left70",
    "icon70",
    "title71",
    "item71",
    "left71",
    "icon71",
    "title72",
    "item72",
    "left72",
    "icon72",
    "title73",
    "col3",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title74",
    "item74",
    "left74",
    "icon74",
    "title75",
    "item75",
    "left75",
    "icon75",
    "title76",
    "item76",
    "left76",
    "icon76",
    "title77",
    "item77",
    "left77",
    "icon77",
    "title78",
    "item78",
    "left78",
    "icon78",
    "title79",
    "item79",
    "left79",
    "icon79",
    "title80",
    "item80",
    "left80",
    "icon80",
    "title81",
    "item81",
    "left81",
    "icon81",
    "title82",
    "item82",
    "left82",
    "icon82",
    "title83",
    "item83",
    "left83",
    "icon83",
    "title84",
    "item84",
    "left84",
    "icon84",
    "title85",
    "item85",
    "left85",
    "icon85",
    "title86",
    "item86",
    "left86",
    "icon86",
    "title87",
    "item87",
    "left87",
    "icon87",
    "title88",
    "item88",
    "left88",
    "icon88",
    "title89",
    "item89",
    "left89",
    "icon89",
    "title90",
    "item90",
    "left90",
    "icon90",
    "title91",
    "item91",
    "left91",
    "icon91",
    "title92",
    "item92",
    "left92",
    "icon92",
    "title93",
    "item93",
    "left93",
    "icon93",
    "title94",
    "item94",
    "left94",
    "icon94",
    "title95",
    "item95",
    "left95",
    "icon95",
    "title96",
    "item96",
    "left96",
    "icon96",
    "title97"
  ],
  col: [
    "col",
    "header5",
    "list5",
    "item",
    "left",
    "icon",
    "title98",
    "item2",
    "left2",
    "icon2",
    "title99",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25"
  ],
  header5: ["header5"],
  list5: [
    "list5",
    "item",
    "left",
    "icon",
    "title98",
    "item2",
    "left2",
    "icon2",
    "title99",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25"
  ],
  item: ["item", "left", "icon", "title98"],
  left: ["left", "icon"],
  icon: ["icon"],
  title98: ["title98"],
  item2: ["item2", "left2", "icon2", "title99"],
  left2: ["left2", "icon2"],
  icon2: ["icon2"],
  title99: ["title99"],
  item3: ["item3", "left3", "icon3", "title4"],
  left3: ["left3", "icon3"],
  icon3: ["icon3"],
  title4: ["title4"],
  item4: ["item4", "left4", "icon4", "title5"],
  left4: ["left4", "icon4"],
  icon4: ["icon4"],
  title5: ["title5"],
  item5: ["item5", "left5", "icon5", "title6"],
  left5: ["left5", "icon5"],
  icon5: ["icon5"],
  title6: ["title6"],
  item6: ["item6", "left6", "icon6", "title7"],
  left6: ["left6", "icon6"],
  icon6: ["icon6"],
  title7: ["title7"],
  item7: ["item7", "left7", "icon7", "title8"],
  left7: ["left7", "icon7"],
  icon7: ["icon7"],
  title8: ["title8"],
  item8: ["item8", "left8", "icon8", "title9"],
  left8: ["left8", "icon8"],
  icon8: ["icon8"],
  title9: ["title9"],
  item9: ["item9", "left9", "icon9", "title10"],
  left9: ["left9", "icon9"],
  icon9: ["icon9"],
  title10: ["title10"],
  item10: ["item10", "left10", "icon10", "title11"],
  left10: ["left10", "icon10"],
  icon10: ["icon10"],
  title11: ["title11"],
  item11: ["item11", "left11", "icon11", "title12"],
  left11: ["left11", "icon11"],
  icon11: ["icon11"],
  title12: ["title12"],
  item12: ["item12", "left12", "icon12", "title13"],
  left12: ["left12", "icon12"],
  icon12: ["icon12"],
  title13: ["title13"],
  item13: ["item13", "left13", "icon13", "title14"],
  left13: ["left13", "icon13"],
  icon13: ["icon13"],
  title14: ["title14"],
  item14: ["item14", "left14", "icon14", "title15"],
  left14: ["left14", "icon14"],
  icon14: ["icon14"],
  title15: ["title15"],
  item15: ["item15", "left15", "icon15", "title16"],
  left15: ["left15", "icon15"],
  icon15: ["icon15"],
  title16: ["title16"],
  item16: ["item16", "left16", "icon16", "title17"],
  left16: ["left16", "icon16"],
  icon16: ["icon16"],
  title17: ["title17"],
  item17: ["item17", "left17", "icon17", "title18"],
  left17: ["left17", "icon17"],
  icon17: ["icon17"],
  title18: ["title18"],
  item18: ["item18", "left18", "icon18", "title19"],
  left18: ["left18", "icon18"],
  icon18: ["icon18"],
  title19: ["title19"],
  item19: ["item19", "left19", "icon19", "title20"],
  left19: ["left19", "icon19"],
  icon19: ["icon19"],
  title20: ["title20"],
  item20: ["item20", "left20", "icon20", "title21"],
  left20: ["left20", "icon20"],
  icon20: ["icon20"],
  title21: ["title21"],
  item21: ["item21", "left21", "icon21", "title22"],
  left21: ["left21", "icon21"],
  icon21: ["icon21"],
  title22: ["title22"],
  item22: ["item22", "left22", "icon22", "title23"],
  left22: ["left22", "icon22"],
  icon22: ["icon22"],
  title23: ["title23"],
  item23: ["item23", "left23", "icon23", "title24"],
  left23: ["left23", "icon23"],
  icon23: ["icon23"],
  title24: ["title24"],
  item24: ["item24", "left24", "icon24", "title25"],
  left24: ["left24", "icon24"],
  icon24: ["icon24"],
  title25: ["title25"],
  col2: [
    "col2",
    "section",
    "header6",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title26",
    "item26",
    "left26",
    "icon26",
    "title27",
    "item27",
    "left27",
    "icon27",
    "title28",
    "item28",
    "left28",
    "icon28",
    "title29",
    "item29",
    "left29",
    "icon29",
    "title30",
    "item30",
    "left30",
    "icon30",
    "title31",
    "item31",
    "left31",
    "icon31",
    "title32",
    "item32",
    "left32",
    "icon32",
    "title33",
    "item33",
    "left33",
    "icon33",
    "title34",
    "item34",
    "left34",
    "icon34",
    "title35",
    "item35",
    "left35",
    "icon35",
    "title36",
    "item36",
    "left36",
    "icon36",
    "title37",
    "item37",
    "left37",
    "icon37",
    "title38",
    "item38",
    "left38",
    "icon38",
    "title39",
    "item39",
    "left39",
    "icon39",
    "title40",
    "item40",
    "left40",
    "icon40",
    "title41",
    "item41",
    "left41",
    "icon41",
    "title42",
    "item42",
    "left42",
    "icon42",
    "title43",
    "item43",
    "left43",
    "icon43",
    "title44",
    "item44",
    "left44",
    "icon44",
    "title45",
    "item45",
    "left45",
    "icon45",
    "title46",
    "item46",
    "left46",
    "icon46",
    "title47",
    "item47",
    "left47",
    "icon47",
    "title48",
    "item48",
    "left48",
    "icon48",
    "title49",
    "section2",
    "header7",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title50",
    "item50",
    "left50",
    "icon50",
    "title51",
    "item51",
    "left51",
    "icon51",
    "title52",
    "item52",
    "left52",
    "icon52",
    "title53",
    "item53",
    "left53",
    "icon53",
    "title54",
    "item54",
    "left54",
    "icon54",
    "title55",
    "item55",
    "left55",
    "icon55",
    "title56",
    "item56",
    "left56",
    "icon56",
    "title57",
    "item57",
    "left57",
    "icon57",
    "title58",
    "item58",
    "left58",
    "icon58",
    "title59",
    "item59",
    "left59",
    "icon59",
    "title60",
    "item60",
    "left60",
    "icon60",
    "title61",
    "item61",
    "left61",
    "icon61",
    "title62",
    "item62",
    "left62",
    "icon62",
    "title63",
    "item63",
    "left63",
    "icon63",
    "title64",
    "item64",
    "left64",
    "icon64",
    "title65",
    "item65",
    "left65",
    "icon65",
    "title66",
    "item66",
    "left66",
    "icon66",
    "title67",
    "item67",
    "left67",
    "icon67",
    "title68",
    "item68",
    "left68",
    "icon68",
    "title69",
    "item69",
    "left69",
    "icon69",
    "title70",
    "item70",
    "left70",
    "icon70",
    "title71",
    "item71",
    "left71",
    "icon71",
    "title72",
    "item72",
    "left72",
    "icon72",
    "title73"
  ],
  section: [
    "section",
    "header6",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title26",
    "item26",
    "left26",
    "icon26",
    "title27",
    "item27",
    "left27",
    "icon27",
    "title28",
    "item28",
    "left28",
    "icon28",
    "title29",
    "item29",
    "left29",
    "icon29",
    "title30",
    "item30",
    "left30",
    "icon30",
    "title31",
    "item31",
    "left31",
    "icon31",
    "title32",
    "item32",
    "left32",
    "icon32",
    "title33",
    "item33",
    "left33",
    "icon33",
    "title34",
    "item34",
    "left34",
    "icon34",
    "title35",
    "item35",
    "left35",
    "icon35",
    "title36",
    "item36",
    "left36",
    "icon36",
    "title37",
    "item37",
    "left37",
    "icon37",
    "title38",
    "item38",
    "left38",
    "icon38",
    "title39",
    "item39",
    "left39",
    "icon39",
    "title40",
    "item40",
    "left40",
    "icon40",
    "title41",
    "item41",
    "left41",
    "icon41",
    "title42",
    "item42",
    "left42",
    "icon42",
    "title43",
    "item43",
    "left43",
    "icon43",
    "title44",
    "item44",
    "left44",
    "icon44",
    "title45",
    "item45",
    "left45",
    "icon45",
    "title46",
    "item46",
    "left46",
    "icon46",
    "title47",
    "item47",
    "left47",
    "icon47",
    "title48",
    "item48",
    "left48",
    "icon48",
    "title49"
  ],
  header6: ["header6"],
  list2: [
    "list2",
    "item25",
    "left25",
    "icon25",
    "title26",
    "item26",
    "left26",
    "icon26",
    "title27",
    "item27",
    "left27",
    "icon27",
    "title28",
    "item28",
    "left28",
    "icon28",
    "title29",
    "item29",
    "left29",
    "icon29",
    "title30",
    "item30",
    "left30",
    "icon30",
    "title31",
    "item31",
    "left31",
    "icon31",
    "title32",
    "item32",
    "left32",
    "icon32",
    "title33",
    "item33",
    "left33",
    "icon33",
    "title34",
    "item34",
    "left34",
    "icon34",
    "title35",
    "item35",
    "left35",
    "icon35",
    "title36",
    "item36",
    "left36",
    "icon36",
    "title37",
    "item37",
    "left37",
    "icon37",
    "title38",
    "item38",
    "left38",
    "icon38",
    "title39",
    "item39",
    "left39",
    "icon39",
    "title40",
    "item40",
    "left40",
    "icon40",
    "title41",
    "item41",
    "left41",
    "icon41",
    "title42",
    "item42",
    "left42",
    "icon42",
    "title43",
    "item43",
    "left43",
    "icon43",
    "title44",
    "item44",
    "left44",
    "icon44",
    "title45",
    "item45",
    "left45",
    "icon45",
    "title46",
    "item46",
    "left46",
    "icon46",
    "title47",
    "item47",
    "left47",
    "icon47",
    "title48",
    "item48",
    "left48",
    "icon48",
    "title49"
  ],
  item25: ["item25", "left25", "icon25", "title26"],
  left25: ["left25", "icon25"],
  icon25: ["icon25"],
  title26: ["title26"],
  item26: ["item26", "left26", "icon26", "title27"],
  left26: ["left26", "icon26"],
  icon26: ["icon26"],
  title27: ["title27"],
  item27: ["item27", "left27", "icon27", "title28"],
  left27: ["left27", "icon27"],
  icon27: ["icon27"],
  title28: ["title28"],
  item28: ["item28", "left28", "icon28", "title29"],
  left28: ["left28", "icon28"],
  icon28: ["icon28"],
  title29: ["title29"],
  item29: ["item29", "left29", "icon29", "title30"],
  left29: ["left29", "icon29"],
  icon29: ["icon29"],
  title30: ["title30"],
  item30: ["item30", "left30", "icon30", "title31"],
  left30: ["left30", "icon30"],
  icon30: ["icon30"],
  title31: ["title31"],
  item31: ["item31", "left31", "icon31", "title32"],
  left31: ["left31", "icon31"],
  icon31: ["icon31"],
  title32: ["title32"],
  item32: ["item32", "left32", "icon32", "title33"],
  left32: ["left32", "icon32"],
  icon32: ["icon32"],
  title33: ["title33"],
  item33: ["item33", "left33", "icon33", "title34"],
  left33: ["left33", "icon33"],
  icon33: ["icon33"],
  title34: ["title34"],
  item34: ["item34", "left34", "icon34", "title35"],
  left34: ["left34", "icon34"],
  icon34: ["icon34"],
  title35: ["title35"],
  item35: ["item35", "left35", "icon35", "title36"],
  left35: ["left35", "icon35"],
  icon35: ["icon35"],
  title36: ["title36"],
  item36: ["item36", "left36", "icon36", "title37"],
  left36: ["left36", "icon36"],
  icon36: ["icon36"],
  title37: ["title37"],
  item37: ["item37", "left37", "icon37", "title38"],
  left37: ["left37", "icon37"],
  icon37: ["icon37"],
  title38: ["title38"],
  item38: ["item38", "left38", "icon38", "title39"],
  left38: ["left38", "icon38"],
  icon38: ["icon38"],
  title39: ["title39"],
  item39: ["item39", "left39", "icon39", "title40"],
  left39: ["left39", "icon39"],
  icon39: ["icon39"],
  title40: ["title40"],
  item40: ["item40", "left40", "icon40", "title41"],
  left40: ["left40", "icon40"],
  icon40: ["icon40"],
  title41: ["title41"],
  item41: ["item41", "left41", "icon41", "title42"],
  left41: ["left41", "icon41"],
  icon41: ["icon41"],
  title42: ["title42"],
  item42: ["item42", "left42", "icon42", "title43"],
  left42: ["left42", "icon42"],
  icon42: ["icon42"],
  title43: ["title43"],
  item43: ["item43", "left43", "icon43", "title44"],
  left43: ["left43", "icon43"],
  icon43: ["icon43"],
  title44: ["title44"],
  item44: ["item44", "left44", "icon44", "title45"],
  left44: ["left44", "icon44"],
  icon44: ["icon44"],
  title45: ["title45"],
  item45: ["item45", "left45", "icon45", "title46"],
  left45: ["left45", "icon45"],
  icon45: ["icon45"],
  title46: ["title46"],
  item46: ["item46", "left46", "icon46", "title47"],
  left46: ["left46", "icon46"],
  icon46: ["icon46"],
  title47: ["title47"],
  item47: ["item47", "left47", "icon47", "title48"],
  left47: ["left47", "icon47"],
  icon47: ["icon47"],
  title48: ["title48"],
  item48: ["item48", "left48", "icon48", "title49"],
  left48: ["left48", "icon48"],
  icon48: ["icon48"],
  title49: ["title49"],
  section2: [
    "section2",
    "header7",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title50",
    "item50",
    "left50",
    "icon50",
    "title51",
    "item51",
    "left51",
    "icon51",
    "title52",
    "item52",
    "left52",
    "icon52",
    "title53",
    "item53",
    "left53",
    "icon53",
    "title54",
    "item54",
    "left54",
    "icon54",
    "title55",
    "item55",
    "left55",
    "icon55",
    "title56",
    "item56",
    "left56",
    "icon56",
    "title57",
    "item57",
    "left57",
    "icon57",
    "title58",
    "item58",
    "left58",
    "icon58",
    "title59",
    "item59",
    "left59",
    "icon59",
    "title60",
    "item60",
    "left60",
    "icon60",
    "title61",
    "item61",
    "left61",
    "icon61",
    "title62",
    "item62",
    "left62",
    "icon62",
    "title63",
    "item63",
    "left63",
    "icon63",
    "title64",
    "item64",
    "left64",
    "icon64",
    "title65",
    "item65",
    "left65",
    "icon65",
    "title66",
    "item66",
    "left66",
    "icon66",
    "title67",
    "item67",
    "left67",
    "icon67",
    "title68",
    "item68",
    "left68",
    "icon68",
    "title69",
    "item69",
    "left69",
    "icon69",
    "title70",
    "item70",
    "left70",
    "icon70",
    "title71",
    "item71",
    "left71",
    "icon71",
    "title72",
    "item72",
    "left72",
    "icon72",
    "title73"
  ],
  header7: ["header7"],
  list3: [
    "list3",
    "item49",
    "left49",
    "icon49",
    "title50",
    "item50",
    "left50",
    "icon50",
    "title51",
    "item51",
    "left51",
    "icon51",
    "title52",
    "item52",
    "left52",
    "icon52",
    "title53",
    "item53",
    "left53",
    "icon53",
    "title54",
    "item54",
    "left54",
    "icon54",
    "title55",
    "item55",
    "left55",
    "icon55",
    "title56",
    "item56",
    "left56",
    "icon56",
    "title57",
    "item57",
    "left57",
    "icon57",
    "title58",
    "item58",
    "left58",
    "icon58",
    "title59",
    "item59",
    "left59",
    "icon59",
    "title60",
    "item60",
    "left60",
    "icon60",
    "title61",
    "item61",
    "left61",
    "icon61",
    "title62",
    "item62",
    "left62",
    "icon62",
    "title63",
    "item63",
    "left63",
    "icon63",
    "title64",
    "item64",
    "left64",
    "icon64",
    "title65",
    "item65",
    "left65",
    "icon65",
    "title66",
    "item66",
    "left66",
    "icon66",
    "title67",
    "item67",
    "left67",
    "icon67",
    "title68",
    "item68",
    "left68",
    "icon68",
    "title69",
    "item69",
    "left69",
    "icon69",
    "title70",
    "item70",
    "left70",
    "icon70",
    "title71",
    "item71",
    "left71",
    "icon71",
    "title72",
    "item72",
    "left72",
    "icon72",
    "title73"
  ],
  item49: ["item49", "left49", "icon49", "title50"],
  left49: ["left49", "icon49"],
  icon49: ["icon49"],
  title50: ["title50"],
  item50: ["item50", "left50", "icon50", "title51"],
  left50: ["left50", "icon50"],
  icon50: ["icon50"],
  title51: ["title51"],
  item51: ["item51", "left51", "icon51", "title52"],
  left51: ["left51", "icon51"],
  icon51: ["icon51"],
  title52: ["title52"],
  item52: ["item52", "left52", "icon52", "title53"],
  left52: ["left52", "icon52"],
  icon52: ["icon52"],
  title53: ["title53"],
  item53: ["item53", "left53", "icon53", "title54"],
  left53: ["left53", "icon53"],
  icon53: ["icon53"],
  title54: ["title54"],
  item54: ["item54", "left54", "icon54", "title55"],
  left54: ["left54", "icon54"],
  icon54: ["icon54"],
  title55: ["title55"],
  item55: ["item55", "left55", "icon55", "title56"],
  left55: ["left55", "icon55"],
  icon55: ["icon55"],
  title56: ["title56"],
  item56: ["item56", "left56", "icon56", "title57"],
  left56: ["left56", "icon56"],
  icon56: ["icon56"],
  title57: ["title57"],
  item57: ["item57", "left57", "icon57", "title58"],
  left57: ["left57", "icon57"],
  icon57: ["icon57"],
  title58: ["title58"],
  item58: ["item58", "left58", "icon58", "title59"],
  left58: ["left58", "icon58"],
  icon58: ["icon58"],
  title59: ["title59"],
  item59: ["item59", "left59", "icon59", "title60"],
  left59: ["left59", "icon59"],
  icon59: ["icon59"],
  title60: ["title60"],
  item60: ["item60", "left60", "icon60", "title61"],
  left60: ["left60", "icon60"],
  icon60: ["icon60"],
  title61: ["title61"],
  item61: ["item61", "left61", "icon61", "title62"],
  left61: ["left61", "icon61"],
  icon61: ["icon61"],
  title62: ["title62"],
  item62: ["item62", "left62", "icon62", "title63"],
  left62: ["left62", "icon62"],
  icon62: ["icon62"],
  title63: ["title63"],
  item63: ["item63", "left63", "icon63", "title64"],
  left63: ["left63", "icon63"],
  icon63: ["icon63"],
  title64: ["title64"],
  item64: ["item64", "left64", "icon64", "title65"],
  left64: ["left64", "icon64"],
  icon64: ["icon64"],
  title65: ["title65"],
  item65: ["item65", "left65", "icon65", "title66"],
  left65: ["left65", "icon65"],
  icon65: ["icon65"],
  title66: ["title66"],
  item66: ["item66", "left66", "icon66", "title67"],
  left66: ["left66", "icon66"],
  icon66: ["icon66"],
  title67: ["title67"],
  item67: ["item67", "left67", "icon67", "title68"],
  left67: ["left67", "icon67"],
  icon67: ["icon67"],
  title68: ["title68"],
  item68: ["item68", "left68", "icon68", "title69"],
  left68: ["left68", "icon68"],
  icon68: ["icon68"],
  title69: ["title69"],
  item69: ["item69", "left69", "icon69", "title70"],
  left69: ["left69", "icon69"],
  icon69: ["icon69"],
  title70: ["title70"],
  item70: ["item70", "left70", "icon70", "title71"],
  left70: ["left70", "icon70"],
  icon70: ["icon70"],
  title71: ["title71"],
  item71: ["item71", "left71", "icon71", "title72"],
  left71: ["left71", "icon71"],
  icon71: ["icon71"],
  title72: ["title72"],
  item72: ["item72", "left72", "icon72", "title73"],
  left72: ["left72", "icon72"],
  icon72: ["icon72"],
  title73: ["title73"],
  col3: [
    "col3",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title74",
    "item74",
    "left74",
    "icon74",
    "title75",
    "item75",
    "left75",
    "icon75",
    "title76",
    "item76",
    "left76",
    "icon76",
    "title77",
    "item77",
    "left77",
    "icon77",
    "title78",
    "item78",
    "left78",
    "icon78",
    "title79",
    "item79",
    "left79",
    "icon79",
    "title80",
    "item80",
    "left80",
    "icon80",
    "title81",
    "item81",
    "left81",
    "icon81",
    "title82",
    "item82",
    "left82",
    "icon82",
    "title83",
    "item83",
    "left83",
    "icon83",
    "title84",
    "item84",
    "left84",
    "icon84",
    "title85",
    "item85",
    "left85",
    "icon85",
    "title86",
    "item86",
    "left86",
    "icon86",
    "title87",
    "item87",
    "left87",
    "icon87",
    "title88",
    "item88",
    "left88",
    "icon88",
    "title89",
    "item89",
    "left89",
    "icon89",
    "title90",
    "item90",
    "left90",
    "icon90",
    "title91",
    "item91",
    "left91",
    "icon91",
    "title92",
    "item92",
    "left92",
    "icon92",
    "title93",
    "item93",
    "left93",
    "icon93",
    "title94",
    "item94",
    "left94",
    "icon94",
    "title95",
    "item95",
    "left95",
    "icon95",
    "title96",
    "item96",
    "left96",
    "icon96",
    "title97"
  ],
  header8: ["header8"],
  list4: [
    "list4",
    "item73",
    "left73",
    "icon73",
    "title74",
    "item74",
    "left74",
    "icon74",
    "title75",
    "item75",
    "left75",
    "icon75",
    "title76",
    "item76",
    "left76",
    "icon76",
    "title77",
    "item77",
    "left77",
    "icon77",
    "title78",
    "item78",
    "left78",
    "icon78",
    "title79",
    "item79",
    "left79",
    "icon79",
    "title80",
    "item80",
    "left80",
    "icon80",
    "title81",
    "item81",
    "left81",
    "icon81",
    "title82",
    "item82",
    "left82",
    "icon82",
    "title83",
    "item83",
    "left83",
    "icon83",
    "title84",
    "item84",
    "left84",
    "icon84",
    "title85",
    "item85",
    "left85",
    "icon85",
    "title86",
    "item86",
    "left86",
    "icon86",
    "title87",
    "item87",
    "left87",
    "icon87",
    "title88",
    "item88",
    "left88",
    "icon88",
    "title89",
    "item89",
    "left89",
    "icon89",
    "title90",
    "item90",
    "left90",
    "icon90",
    "title91",
    "item91",
    "left91",
    "icon91",
    "title92",
    "item92",
    "left92",
    "icon92",
    "title93",
    "item93",
    "left93",
    "icon93",
    "title94",
    "item94",
    "left94",
    "icon94",
    "title95",
    "item95",
    "left95",
    "icon95",
    "title96",
    "item96",
    "left96",
    "icon96",
    "title97"
  ],
  item73: ["item73", "left73", "icon73", "title74"],
  left73: ["left73", "icon73"],
  icon73: ["icon73"],
  title74: ["title74"],
  item74: ["item74", "left74", "icon74", "title75"],
  left74: ["left74", "icon74"],
  icon74: ["icon74"],
  title75: ["title75"],
  item75: ["item75", "left75", "icon75", "title76"],
  left75: ["left75", "icon75"],
  icon75: ["icon75"],
  title76: ["title76"],
  item76: ["item76", "left76", "icon76", "title77"],
  left76: ["left76", "icon76"],
  icon76: ["icon76"],
  title77: ["title77"],
  item77: ["item77", "left77", "icon77", "title78"],
  left77: ["left77", "icon77"],
  icon77: ["icon77"],
  title78: ["title78"],
  item78: ["item78", "left78", "icon78", "title79"],
  left78: ["left78", "icon78"],
  icon78: ["icon78"],
  title79: ["title79"],
  item79: ["item79", "left79", "icon79", "title80"],
  left79: ["left79", "icon79"],
  icon79: ["icon79"],
  title80: ["title80"],
  item80: ["item80", "left80", "icon80", "title81"],
  left80: ["left80", "icon80"],
  icon80: ["icon80"],
  title81: ["title81"],
  item81: ["item81", "left81", "icon81", "title82"],
  left81: ["left81", "icon81"],
  icon81: ["icon81"],
  title82: ["title82"],
  item82: ["item82", "left82", "icon82", "title83"],
  left82: ["left82", "icon82"],
  icon82: ["icon82"],
  title83: ["title83"],
  item83: ["item83", "left83", "icon83", "title84"],
  left83: ["left83", "icon83"],
  icon83: ["icon83"],
  title84: ["title84"],
  item84: ["item84", "left84", "icon84", "title85"],
  left84: ["left84", "icon84"],
  icon84: ["icon84"],
  title85: ["title85"],
  item85: ["item85", "left85", "icon85", "title86"],
  left85: ["left85", "icon85"],
  icon85: ["icon85"],
  title86: ["title86"],
  item86: ["item86", "left86", "icon86", "title87"],
  left86: ["left86", "icon86"],
  icon86: ["icon86"],
  title87: ["title87"],
  item87: ["item87", "left87", "icon87", "title88"],
  left87: ["left87", "icon87"],
  icon87: ["icon87"],
  title88: ["title88"],
  item88: ["item88", "left88", "icon88", "title89"],
  left88: ["left88", "icon88"],
  icon88: ["icon88"],
  title89: ["title89"],
  item89: ["item89", "left89", "icon89", "title90"],
  left89: ["left89", "icon89"],
  icon89: ["icon89"],
  title90: ["title90"],
  item90: ["item90", "left90", "icon90", "title91"],
  left90: ["left90", "icon90"],
  icon90: ["icon90"],
  title91: ["title91"],
  item91: ["item91", "left91", "icon91", "title92"],
  left91: ["left91", "icon91"],
  icon91: ["icon91"],
  title92: ["title92"],
  item92: ["item92", "left92", "icon92", "title93"],
  left92: ["left92", "icon92"],
  icon92: ["icon92"],
  title93: ["title93"],
  item93: ["item93", "left93", "icon93", "title94"],
  left93: ["left93", "icon93"],
  icon93: ["icon93"],
  title94: ["title94"],
  item94: ["item94", "left94", "icon94", "title95"],
  left94: ["left94", "icon94"],
  icon94: ["icon94"],
  title95: ["title95"],
  item95: ["item95", "left95", "icon95", "title96"],
  left95: ["left95", "icon95"],
  icon95: ["icon95"],
  title96: ["title96"],
  item96: ["item96", "left96", "icon96", "title97"],
  left96: ["left96", "icon96"],
  icon96: ["icon96"],
  title97: ["title97"],
  tablet: [
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "row9",
    "row10",
    "row11",
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  row6: ["row6"],
  key4: ["key4", "header4", "list11", "row7", "row8", "row9", "row10", "row11"],
  header4: ["header4"],
  list11: ["list11", "row7", "row8", "row9", "row10", "row11"],
  row7: ["row7"],
  row8: ["row8"],
  row9: ["row9"],
  row10: ["row10"],
  row11: ["row11"],
  all3: [
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  title3: ["title3"],
  sections3: [
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  col8: ["col8", "list12"],
  list12: ["list12"],
  col9: ["col9", "section5", "list13", "section6", "list14", "col10", "list15"],
  section5: ["section5", "list13"],
  list13: ["list13"],
  section6: ["section6", "list14"],
  list14: ["list14"],
  col10: ["col10", "list15"],
  list15: ["list15"],
  mobile: [
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title100",
    "sections2",
    "section7",
    "header9",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "section8",
    "header10",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title124",
    "item122",
    "left122",
    "icon122",
    "title125",
    "item123",
    "left123",
    "icon123",
    "title126",
    "item124",
    "left124",
    "icon124",
    "title127",
    "item125",
    "left125",
    "icon125",
    "title128",
    "item126",
    "left126",
    "icon126",
    "title129",
    "item127",
    "left127",
    "icon127",
    "title130",
    "item128",
    "left128",
    "icon128",
    "title131",
    "item129",
    "left129",
    "icon129",
    "title132",
    "item130",
    "left130",
    "icon130",
    "title133",
    "item131",
    "left131",
    "icon131",
    "title134",
    "item132",
    "left132",
    "icon132",
    "title135",
    "item133",
    "left133",
    "icon133",
    "title136",
    "item134",
    "left134",
    "icon134",
    "title137",
    "item135",
    "left135",
    "icon135",
    "title138",
    "item136",
    "left136",
    "icon136",
    "title139",
    "item137",
    "left137",
    "icon137",
    "title140",
    "item138",
    "left138",
    "icon138",
    "title141",
    "item139",
    "left139",
    "icon139",
    "title142",
    "item140",
    "left140",
    "icon140",
    "title143",
    "item141",
    "left141",
    "icon141",
    "title144",
    "item142",
    "left142",
    "icon142",
    "title145",
    "item143",
    "left143",
    "icon143",
    "title146",
    "item144",
    "left144",
    "icon144",
    "title147",
    "section3",
    "header11",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title148",
    "item146",
    "left146",
    "icon146",
    "title149",
    "item147",
    "left147",
    "icon147",
    "title150",
    "item148",
    "left148",
    "icon148",
    "title151",
    "item149",
    "left149",
    "icon149",
    "title152",
    "item150",
    "left150",
    "icon150",
    "title153",
    "item151",
    "left151",
    "icon151",
    "title154",
    "item152",
    "left152",
    "icon152",
    "title155",
    "item153",
    "left153",
    "icon153",
    "title156",
    "item154",
    "left154",
    "icon154",
    "title157",
    "item155",
    "left155",
    "icon155",
    "title158",
    "item156",
    "left156",
    "icon156",
    "title159",
    "item157",
    "left157",
    "icon157",
    "title160",
    "item158",
    "left158",
    "icon158",
    "title161",
    "item159",
    "left159",
    "icon159",
    "title162",
    "item160",
    "left160",
    "icon160",
    "title163",
    "item161",
    "left161",
    "icon161",
    "title164",
    "item162",
    "left162",
    "icon162",
    "title165",
    "item163",
    "left163",
    "icon163",
    "title166",
    "item164",
    "left164",
    "icon164",
    "title167",
    "item165",
    "left165",
    "icon165",
    "title168",
    "item166",
    "left166",
    "icon166",
    "title169",
    "item167",
    "left167",
    "icon167",
    "title170",
    "item168",
    "left168",
    "icon168",
    "title171",
    "section4",
    "header12",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title172",
    "item170",
    "left170",
    "icon170",
    "title173",
    "item171",
    "left171",
    "icon171",
    "title174",
    "item172",
    "left172",
    "icon172",
    "title175",
    "item173",
    "left173",
    "icon173",
    "title176",
    "item174",
    "left174",
    "icon174",
    "title177",
    "item175",
    "left175",
    "icon175",
    "title178",
    "item176",
    "left176",
    "icon176",
    "title179",
    "item177",
    "left177",
    "icon177",
    "title180",
    "item178",
    "left178",
    "icon178",
    "title181",
    "item179",
    "left179",
    "icon179",
    "title182",
    "item180",
    "left180",
    "icon180",
    "title183",
    "item181",
    "left181",
    "icon181",
    "title184",
    "item182",
    "left182",
    "icon182",
    "title185",
    "item183",
    "left183",
    "icon183",
    "title186",
    "item184",
    "left184",
    "icon184",
    "title187",
    "item185",
    "left185",
    "icon185",
    "title188",
    "item186",
    "left186",
    "icon186",
    "title189",
    "item187",
    "left187",
    "icon187",
    "title190",
    "item188",
    "left188",
    "icon188",
    "title191",
    "item189",
    "left189",
    "icon189",
    "title192",
    "item190",
    "left190",
    "icon190",
    "title193",
    "item191",
    "left191",
    "icon191",
    "title194",
    "item192",
    "left192",
    "icon192",
    "title195"
  ],
  header3: ["header3"],
  key3: ["key3", "header2", "list6"],
  header2: ["header2"],
  list6: ["list6"],
  all2: [
    "all2",
    "title100",
    "sections2",
    "section7",
    "header9",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "section8",
    "header10",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title124",
    "item122",
    "left122",
    "icon122",
    "title125",
    "item123",
    "left123",
    "icon123",
    "title126",
    "item124",
    "left124",
    "icon124",
    "title127",
    "item125",
    "left125",
    "icon125",
    "title128",
    "item126",
    "left126",
    "icon126",
    "title129",
    "item127",
    "left127",
    "icon127",
    "title130",
    "item128",
    "left128",
    "icon128",
    "title131",
    "item129",
    "left129",
    "icon129",
    "title132",
    "item130",
    "left130",
    "icon130",
    "title133",
    "item131",
    "left131",
    "icon131",
    "title134",
    "item132",
    "left132",
    "icon132",
    "title135",
    "item133",
    "left133",
    "icon133",
    "title136",
    "item134",
    "left134",
    "icon134",
    "title137",
    "item135",
    "left135",
    "icon135",
    "title138",
    "item136",
    "left136",
    "icon136",
    "title139",
    "item137",
    "left137",
    "icon137",
    "title140",
    "item138",
    "left138",
    "icon138",
    "title141",
    "item139",
    "left139",
    "icon139",
    "title142",
    "item140",
    "left140",
    "icon140",
    "title143",
    "item141",
    "left141",
    "icon141",
    "title144",
    "item142",
    "left142",
    "icon142",
    "title145",
    "item143",
    "left143",
    "icon143",
    "title146",
    "item144",
    "left144",
    "icon144",
    "title147",
    "section3",
    "header11",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title148",
    "item146",
    "left146",
    "icon146",
    "title149",
    "item147",
    "left147",
    "icon147",
    "title150",
    "item148",
    "left148",
    "icon148",
    "title151",
    "item149",
    "left149",
    "icon149",
    "title152",
    "item150",
    "left150",
    "icon150",
    "title153",
    "item151",
    "left151",
    "icon151",
    "title154",
    "item152",
    "left152",
    "icon152",
    "title155",
    "item153",
    "left153",
    "icon153",
    "title156",
    "item154",
    "left154",
    "icon154",
    "title157",
    "item155",
    "left155",
    "icon155",
    "title158",
    "item156",
    "left156",
    "icon156",
    "title159",
    "item157",
    "left157",
    "icon157",
    "title160",
    "item158",
    "left158",
    "icon158",
    "title161",
    "item159",
    "left159",
    "icon159",
    "title162",
    "item160",
    "left160",
    "icon160",
    "title163",
    "item161",
    "left161",
    "icon161",
    "title164",
    "item162",
    "left162",
    "icon162",
    "title165",
    "item163",
    "left163",
    "icon163",
    "title166",
    "item164",
    "left164",
    "icon164",
    "title167",
    "item165",
    "left165",
    "icon165",
    "title168",
    "item166",
    "left166",
    "icon166",
    "title169",
    "item167",
    "left167",
    "icon167",
    "title170",
    "item168",
    "left168",
    "icon168",
    "title171",
    "section4",
    "header12",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title172",
    "item170",
    "left170",
    "icon170",
    "title173",
    "item171",
    "left171",
    "icon171",
    "title174",
    "item172",
    "left172",
    "icon172",
    "title175",
    "item173",
    "left173",
    "icon173",
    "title176",
    "item174",
    "left174",
    "icon174",
    "title177",
    "item175",
    "left175",
    "icon175",
    "title178",
    "item176",
    "left176",
    "icon176",
    "title179",
    "item177",
    "left177",
    "icon177",
    "title180",
    "item178",
    "left178",
    "icon178",
    "title181",
    "item179",
    "left179",
    "icon179",
    "title182",
    "item180",
    "left180",
    "icon180",
    "title183",
    "item181",
    "left181",
    "icon181",
    "title184",
    "item182",
    "left182",
    "icon182",
    "title185",
    "item183",
    "left183",
    "icon183",
    "title186",
    "item184",
    "left184",
    "icon184",
    "title187",
    "item185",
    "left185",
    "icon185",
    "title188",
    "item186",
    "left186",
    "icon186",
    "title189",
    "item187",
    "left187",
    "icon187",
    "title190",
    "item188",
    "left188",
    "icon188",
    "title191",
    "item189",
    "left189",
    "icon189",
    "title192",
    "item190",
    "left190",
    "icon190",
    "title193",
    "item191",
    "left191",
    "icon191",
    "title194",
    "item192",
    "left192",
    "icon192",
    "title195"
  ],
  title100: ["title100"],
  sections2: [
    "sections2",
    "section7",
    "header9",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "section8",
    "header10",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title124",
    "item122",
    "left122",
    "icon122",
    "title125",
    "item123",
    "left123",
    "icon123",
    "title126",
    "item124",
    "left124",
    "icon124",
    "title127",
    "item125",
    "left125",
    "icon125",
    "title128",
    "item126",
    "left126",
    "icon126",
    "title129",
    "item127",
    "left127",
    "icon127",
    "title130",
    "item128",
    "left128",
    "icon128",
    "title131",
    "item129",
    "left129",
    "icon129",
    "title132",
    "item130",
    "left130",
    "icon130",
    "title133",
    "item131",
    "left131",
    "icon131",
    "title134",
    "item132",
    "left132",
    "icon132",
    "title135",
    "item133",
    "left133",
    "icon133",
    "title136",
    "item134",
    "left134",
    "icon134",
    "title137",
    "item135",
    "left135",
    "icon135",
    "title138",
    "item136",
    "left136",
    "icon136",
    "title139",
    "item137",
    "left137",
    "icon137",
    "title140",
    "item138",
    "left138",
    "icon138",
    "title141",
    "item139",
    "left139",
    "icon139",
    "title142",
    "item140",
    "left140",
    "icon140",
    "title143",
    "item141",
    "left141",
    "icon141",
    "title144",
    "item142",
    "left142",
    "icon142",
    "title145",
    "item143",
    "left143",
    "icon143",
    "title146",
    "item144",
    "left144",
    "icon144",
    "title147",
    "section3",
    "header11",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title148",
    "item146",
    "left146",
    "icon146",
    "title149",
    "item147",
    "left147",
    "icon147",
    "title150",
    "item148",
    "left148",
    "icon148",
    "title151",
    "item149",
    "left149",
    "icon149",
    "title152",
    "item150",
    "left150",
    "icon150",
    "title153",
    "item151",
    "left151",
    "icon151",
    "title154",
    "item152",
    "left152",
    "icon152",
    "title155",
    "item153",
    "left153",
    "icon153",
    "title156",
    "item154",
    "left154",
    "icon154",
    "title157",
    "item155",
    "left155",
    "icon155",
    "title158",
    "item156",
    "left156",
    "icon156",
    "title159",
    "item157",
    "left157",
    "icon157",
    "title160",
    "item158",
    "left158",
    "icon158",
    "title161",
    "item159",
    "left159",
    "icon159",
    "title162",
    "item160",
    "left160",
    "icon160",
    "title163",
    "item161",
    "left161",
    "icon161",
    "title164",
    "item162",
    "left162",
    "icon162",
    "title165",
    "item163",
    "left163",
    "icon163",
    "title166",
    "item164",
    "left164",
    "icon164",
    "title167",
    "item165",
    "left165",
    "icon165",
    "title168",
    "item166",
    "left166",
    "icon166",
    "title169",
    "item167",
    "left167",
    "icon167",
    "title170",
    "item168",
    "left168",
    "icon168",
    "title171",
    "section4",
    "header12",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title172",
    "item170",
    "left170",
    "icon170",
    "title173",
    "item171",
    "left171",
    "icon171",
    "title174",
    "item172",
    "left172",
    "icon172",
    "title175",
    "item173",
    "left173",
    "icon173",
    "title176",
    "item174",
    "left174",
    "icon174",
    "title177",
    "item175",
    "left175",
    "icon175",
    "title178",
    "item176",
    "left176",
    "icon176",
    "title179",
    "item177",
    "left177",
    "icon177",
    "title180",
    "item178",
    "left178",
    "icon178",
    "title181",
    "item179",
    "left179",
    "icon179",
    "title182",
    "item180",
    "left180",
    "icon180",
    "title183",
    "item181",
    "left181",
    "icon181",
    "title184",
    "item182",
    "left182",
    "icon182",
    "title185",
    "item183",
    "left183",
    "icon183",
    "title186",
    "item184",
    "left184",
    "icon184",
    "title187",
    "item185",
    "left185",
    "icon185",
    "title188",
    "item186",
    "left186",
    "icon186",
    "title189",
    "item187",
    "left187",
    "icon187",
    "title190",
    "item188",
    "left188",
    "icon188",
    "title191",
    "item189",
    "left189",
    "icon189",
    "title192",
    "item190",
    "left190",
    "icon190",
    "title193",
    "item191",
    "left191",
    "icon191",
    "title194",
    "item192",
    "left192",
    "icon192",
    "title195"
  ],
  section7: [
    "section7",
    "header9",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123"
  ],
  header9: ["header9"],
  list7: [
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123"
  ],
  item97: ["item97", "left97", "icon97", "title2"],
  left97: ["left97", "icon97"],
  icon97: ["icon97"],
  title2: ["title2"],
  item98: ["item98", "left98", "icon98", "title101"],
  left98: ["left98", "icon98"],
  icon98: ["icon98"],
  title101: ["title101"],
  item99: ["item99", "left99", "icon99", "title102"],
  left99: ["left99", "icon99"],
  icon99: ["icon99"],
  title102: ["title102"],
  item100: ["item100", "left100", "icon100", "title103"],
  left100: ["left100", "icon100"],
  icon100: ["icon100"],
  title103: ["title103"],
  item101: ["item101", "left101", "icon101", "title104"],
  left101: ["left101", "icon101"],
  icon101: ["icon101"],
  title104: ["title104"],
  item102: ["item102", "left102", "icon102", "title105"],
  left102: ["left102", "icon102"],
  icon102: ["icon102"],
  title105: ["title105"],
  item103: ["item103", "left103", "icon103", "title106"],
  left103: ["left103", "icon103"],
  icon103: ["icon103"],
  title106: ["title106"],
  item104: ["item104", "left104", "icon104", "title107"],
  left104: ["left104", "icon104"],
  icon104: ["icon104"],
  title107: ["title107"],
  item105: ["item105", "left105", "icon105", "title108"],
  left105: ["left105", "icon105"],
  icon105: ["icon105"],
  title108: ["title108"],
  item106: ["item106", "left106", "icon106", "title109"],
  left106: ["left106", "icon106"],
  icon106: ["icon106"],
  title109: ["title109"],
  item107: ["item107", "left107", "icon107", "title110"],
  left107: ["left107", "icon107"],
  icon107: ["icon107"],
  title110: ["title110"],
  item108: ["item108", "left108", "icon108", "title111"],
  left108: ["left108", "icon108"],
  icon108: ["icon108"],
  title111: ["title111"],
  item109: ["item109", "left109", "icon109", "title112"],
  left109: ["left109", "icon109"],
  icon109: ["icon109"],
  title112: ["title112"],
  item110: ["item110", "left110", "icon110", "title113"],
  left110: ["left110", "icon110"],
  icon110: ["icon110"],
  title113: ["title113"],
  item111: ["item111", "left111", "icon111", "title114"],
  left111: ["left111", "icon111"],
  icon111: ["icon111"],
  title114: ["title114"],
  item112: ["item112", "left112", "icon112", "title115"],
  left112: ["left112", "icon112"],
  icon112: ["icon112"],
  title115: ["title115"],
  item113: ["item113", "left113", "icon113", "title116"],
  left113: ["left113", "icon113"],
  icon113: ["icon113"],
  title116: ["title116"],
  item114: ["item114", "left114", "icon114", "title117"],
  left114: ["left114", "icon114"],
  icon114: ["icon114"],
  title117: ["title117"],
  item115: ["item115", "left115", "icon115", "title118"],
  left115: ["left115", "icon115"],
  icon115: ["icon115"],
  title118: ["title118"],
  item116: ["item116", "left116", "icon116", "title119"],
  left116: ["left116", "icon116"],
  icon116: ["icon116"],
  title119: ["title119"],
  item117: ["item117", "left117", "icon117", "title120"],
  left117: ["left117", "icon117"],
  icon117: ["icon117"],
  title120: ["title120"],
  item118: ["item118", "left118", "icon118", "title121"],
  left118: ["left118", "icon118"],
  icon118: ["icon118"],
  title121: ["title121"],
  item119: ["item119", "left119", "icon119", "title122"],
  left119: ["left119", "icon119"],
  icon119: ["icon119"],
  title122: ["title122"],
  item120: ["item120", "left120", "icon120", "title123"],
  left120: ["left120", "icon120"],
  icon120: ["icon120"],
  title123: ["title123"],
  section8: [
    "section8",
    "header10",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title124",
    "item122",
    "left122",
    "icon122",
    "title125",
    "item123",
    "left123",
    "icon123",
    "title126",
    "item124",
    "left124",
    "icon124",
    "title127",
    "item125",
    "left125",
    "icon125",
    "title128",
    "item126",
    "left126",
    "icon126",
    "title129",
    "item127",
    "left127",
    "icon127",
    "title130",
    "item128",
    "left128",
    "icon128",
    "title131",
    "item129",
    "left129",
    "icon129",
    "title132",
    "item130",
    "left130",
    "icon130",
    "title133",
    "item131",
    "left131",
    "icon131",
    "title134",
    "item132",
    "left132",
    "icon132",
    "title135",
    "item133",
    "left133",
    "icon133",
    "title136",
    "item134",
    "left134",
    "icon134",
    "title137",
    "item135",
    "left135",
    "icon135",
    "title138",
    "item136",
    "left136",
    "icon136",
    "title139",
    "item137",
    "left137",
    "icon137",
    "title140",
    "item138",
    "left138",
    "icon138",
    "title141",
    "item139",
    "left139",
    "icon139",
    "title142",
    "item140",
    "left140",
    "icon140",
    "title143",
    "item141",
    "left141",
    "icon141",
    "title144",
    "item142",
    "left142",
    "icon142",
    "title145",
    "item143",
    "left143",
    "icon143",
    "title146",
    "item144",
    "left144",
    "icon144",
    "title147"
  ],
  header10: ["header10"],
  list8: [
    "list8",
    "item121",
    "left121",
    "icon121",
    "title124",
    "item122",
    "left122",
    "icon122",
    "title125",
    "item123",
    "left123",
    "icon123",
    "title126",
    "item124",
    "left124",
    "icon124",
    "title127",
    "item125",
    "left125",
    "icon125",
    "title128",
    "item126",
    "left126",
    "icon126",
    "title129",
    "item127",
    "left127",
    "icon127",
    "title130",
    "item128",
    "left128",
    "icon128",
    "title131",
    "item129",
    "left129",
    "icon129",
    "title132",
    "item130",
    "left130",
    "icon130",
    "title133",
    "item131",
    "left131",
    "icon131",
    "title134",
    "item132",
    "left132",
    "icon132",
    "title135",
    "item133",
    "left133",
    "icon133",
    "title136",
    "item134",
    "left134",
    "icon134",
    "title137",
    "item135",
    "left135",
    "icon135",
    "title138",
    "item136",
    "left136",
    "icon136",
    "title139",
    "item137",
    "left137",
    "icon137",
    "title140",
    "item138",
    "left138",
    "icon138",
    "title141",
    "item139",
    "left139",
    "icon139",
    "title142",
    "item140",
    "left140",
    "icon140",
    "title143",
    "item141",
    "left141",
    "icon141",
    "title144",
    "item142",
    "left142",
    "icon142",
    "title145",
    "item143",
    "left143",
    "icon143",
    "title146",
    "item144",
    "left144",
    "icon144",
    "title147"
  ],
  item121: ["item121", "left121", "icon121", "title124"],
  left121: ["left121", "icon121"],
  icon121: ["icon121"],
  title124: ["title124"],
  item122: ["item122", "left122", "icon122", "title125"],
  left122: ["left122", "icon122"],
  icon122: ["icon122"],
  title125: ["title125"],
  item123: ["item123", "left123", "icon123", "title126"],
  left123: ["left123", "icon123"],
  icon123: ["icon123"],
  title126: ["title126"],
  item124: ["item124", "left124", "icon124", "title127"],
  left124: ["left124", "icon124"],
  icon124: ["icon124"],
  title127: ["title127"],
  item125: ["item125", "left125", "icon125", "title128"],
  left125: ["left125", "icon125"],
  icon125: ["icon125"],
  title128: ["title128"],
  item126: ["item126", "left126", "icon126", "title129"],
  left126: ["left126", "icon126"],
  icon126: ["icon126"],
  title129: ["title129"],
  item127: ["item127", "left127", "icon127", "title130"],
  left127: ["left127", "icon127"],
  icon127: ["icon127"],
  title130: ["title130"],
  item128: ["item128", "left128", "icon128", "title131"],
  left128: ["left128", "icon128"],
  icon128: ["icon128"],
  title131: ["title131"],
  item129: ["item129", "left129", "icon129", "title132"],
  left129: ["left129", "icon129"],
  icon129: ["icon129"],
  title132: ["title132"],
  item130: ["item130", "left130", "icon130", "title133"],
  left130: ["left130", "icon130"],
  icon130: ["icon130"],
  title133: ["title133"],
  item131: ["item131", "left131", "icon131", "title134"],
  left131: ["left131", "icon131"],
  icon131: ["icon131"],
  title134: ["title134"],
  item132: ["item132", "left132", "icon132", "title135"],
  left132: ["left132", "icon132"],
  icon132: ["icon132"],
  title135: ["title135"],
  item133: ["item133", "left133", "icon133", "title136"],
  left133: ["left133", "icon133"],
  icon133: ["icon133"],
  title136: ["title136"],
  item134: ["item134", "left134", "icon134", "title137"],
  left134: ["left134", "icon134"],
  icon134: ["icon134"],
  title137: ["title137"],
  item135: ["item135", "left135", "icon135", "title138"],
  left135: ["left135", "icon135"],
  icon135: ["icon135"],
  title138: ["title138"],
  item136: ["item136", "left136", "icon136", "title139"],
  left136: ["left136", "icon136"],
  icon136: ["icon136"],
  title139: ["title139"],
  item137: ["item137", "left137", "icon137", "title140"],
  left137: ["left137", "icon137"],
  icon137: ["icon137"],
  title140: ["title140"],
  item138: ["item138", "left138", "icon138", "title141"],
  left138: ["left138", "icon138"],
  icon138: ["icon138"],
  title141: ["title141"],
  item139: ["item139", "left139", "icon139", "title142"],
  left139: ["left139", "icon139"],
  icon139: ["icon139"],
  title142: ["title142"],
  item140: ["item140", "left140", "icon140", "title143"],
  left140: ["left140", "icon140"],
  icon140: ["icon140"],
  title143: ["title143"],
  item141: ["item141", "left141", "icon141", "title144"],
  left141: ["left141", "icon141"],
  icon141: ["icon141"],
  title144: ["title144"],
  item142: ["item142", "left142", "icon142", "title145"],
  left142: ["left142", "icon142"],
  icon142: ["icon142"],
  title145: ["title145"],
  item143: ["item143", "left143", "icon143", "title146"],
  left143: ["left143", "icon143"],
  icon143: ["icon143"],
  title146: ["title146"],
  item144: ["item144", "left144", "icon144", "title147"],
  left144: ["left144", "icon144"],
  icon144: ["icon144"],
  title147: ["title147"],
  section3: [
    "section3",
    "header11",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title148",
    "item146",
    "left146",
    "icon146",
    "title149",
    "item147",
    "left147",
    "icon147",
    "title150",
    "item148",
    "left148",
    "icon148",
    "title151",
    "item149",
    "left149",
    "icon149",
    "title152",
    "item150",
    "left150",
    "icon150",
    "title153",
    "item151",
    "left151",
    "icon151",
    "title154",
    "item152",
    "left152",
    "icon152",
    "title155",
    "item153",
    "left153",
    "icon153",
    "title156",
    "item154",
    "left154",
    "icon154",
    "title157",
    "item155",
    "left155",
    "icon155",
    "title158",
    "item156",
    "left156",
    "icon156",
    "title159",
    "item157",
    "left157",
    "icon157",
    "title160",
    "item158",
    "left158",
    "icon158",
    "title161",
    "item159",
    "left159",
    "icon159",
    "title162",
    "item160",
    "left160",
    "icon160",
    "title163",
    "item161",
    "left161",
    "icon161",
    "title164",
    "item162",
    "left162",
    "icon162",
    "title165",
    "item163",
    "left163",
    "icon163",
    "title166",
    "item164",
    "left164",
    "icon164",
    "title167",
    "item165",
    "left165",
    "icon165",
    "title168",
    "item166",
    "left166",
    "icon166",
    "title169",
    "item167",
    "left167",
    "icon167",
    "title170",
    "item168",
    "left168",
    "icon168",
    "title171"
  ],
  header11: ["header11"],
  list9: [
    "list9",
    "item145",
    "left145",
    "icon145",
    "title148",
    "item146",
    "left146",
    "icon146",
    "title149",
    "item147",
    "left147",
    "icon147",
    "title150",
    "item148",
    "left148",
    "icon148",
    "title151",
    "item149",
    "left149",
    "icon149",
    "title152",
    "item150",
    "left150",
    "icon150",
    "title153",
    "item151",
    "left151",
    "icon151",
    "title154",
    "item152",
    "left152",
    "icon152",
    "title155",
    "item153",
    "left153",
    "icon153",
    "title156",
    "item154",
    "left154",
    "icon154",
    "title157",
    "item155",
    "left155",
    "icon155",
    "title158",
    "item156",
    "left156",
    "icon156",
    "title159",
    "item157",
    "left157",
    "icon157",
    "title160",
    "item158",
    "left158",
    "icon158",
    "title161",
    "item159",
    "left159",
    "icon159",
    "title162",
    "item160",
    "left160",
    "icon160",
    "title163",
    "item161",
    "left161",
    "icon161",
    "title164",
    "item162",
    "left162",
    "icon162",
    "title165",
    "item163",
    "left163",
    "icon163",
    "title166",
    "item164",
    "left164",
    "icon164",
    "title167",
    "item165",
    "left165",
    "icon165",
    "title168",
    "item166",
    "left166",
    "icon166",
    "title169",
    "item167",
    "left167",
    "icon167",
    "title170",
    "item168",
    "left168",
    "icon168",
    "title171"
  ],
  item145: ["item145", "left145", "icon145", "title148"],
  left145: ["left145", "icon145"],
  icon145: ["icon145"],
  title148: ["title148"],
  item146: ["item146", "left146", "icon146", "title149"],
  left146: ["left146", "icon146"],
  icon146: ["icon146"],
  title149: ["title149"],
  item147: ["item147", "left147", "icon147", "title150"],
  left147: ["left147", "icon147"],
  icon147: ["icon147"],
  title150: ["title150"],
  item148: ["item148", "left148", "icon148", "title151"],
  left148: ["left148", "icon148"],
  icon148: ["icon148"],
  title151: ["title151"],
  item149: ["item149", "left149", "icon149", "title152"],
  left149: ["left149", "icon149"],
  icon149: ["icon149"],
  title152: ["title152"],
  item150: ["item150", "left150", "icon150", "title153"],
  left150: ["left150", "icon150"],
  icon150: ["icon150"],
  title153: ["title153"],
  item151: ["item151", "left151", "icon151", "title154"],
  left151: ["left151", "icon151"],
  icon151: ["icon151"],
  title154: ["title154"],
  item152: ["item152", "left152", "icon152", "title155"],
  left152: ["left152", "icon152"],
  icon152: ["icon152"],
  title155: ["title155"],
  item153: ["item153", "left153", "icon153", "title156"],
  left153: ["left153", "icon153"],
  icon153: ["icon153"],
  title156: ["title156"],
  item154: ["item154", "left154", "icon154", "title157"],
  left154: ["left154", "icon154"],
  icon154: ["icon154"],
  title157: ["title157"],
  item155: ["item155", "left155", "icon155", "title158"],
  left155: ["left155", "icon155"],
  icon155: ["icon155"],
  title158: ["title158"],
  item156: ["item156", "left156", "icon156", "title159"],
  left156: ["left156", "icon156"],
  icon156: ["icon156"],
  title159: ["title159"],
  item157: ["item157", "left157", "icon157", "title160"],
  left157: ["left157", "icon157"],
  icon157: ["icon157"],
  title160: ["title160"],
  item158: ["item158", "left158", "icon158", "title161"],
  left158: ["left158", "icon158"],
  icon158: ["icon158"],
  title161: ["title161"],
  item159: ["item159", "left159", "icon159", "title162"],
  left159: ["left159", "icon159"],
  icon159: ["icon159"],
  title162: ["title162"],
  item160: ["item160", "left160", "icon160", "title163"],
  left160: ["left160", "icon160"],
  icon160: ["icon160"],
  title163: ["title163"],
  item161: ["item161", "left161", "icon161", "title164"],
  left161: ["left161", "icon161"],
  icon161: ["icon161"],
  title164: ["title164"],
  item162: ["item162", "left162", "icon162", "title165"],
  left162: ["left162", "icon162"],
  icon162: ["icon162"],
  title165: ["title165"],
  item163: ["item163", "left163", "icon163", "title166"],
  left163: ["left163", "icon163"],
  icon163: ["icon163"],
  title166: ["title166"],
  item164: ["item164", "left164", "icon164", "title167"],
  left164: ["left164", "icon164"],
  icon164: ["icon164"],
  title167: ["title167"],
  item165: ["item165", "left165", "icon165", "title168"],
  left165: ["left165", "icon165"],
  icon165: ["icon165"],
  title168: ["title168"],
  item166: ["item166", "left166", "icon166", "title169"],
  left166: ["left166", "icon166"],
  icon166: ["icon166"],
  title169: ["title169"],
  item167: ["item167", "left167", "icon167", "title170"],
  left167: ["left167", "icon167"],
  icon167: ["icon167"],
  title170: ["title170"],
  item168: ["item168", "left168", "icon168", "title171"],
  left168: ["left168", "icon168"],
  icon168: ["icon168"],
  title171: ["title171"],
  section4: [
    "section4",
    "header12",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title172",
    "item170",
    "left170",
    "icon170",
    "title173",
    "item171",
    "left171",
    "icon171",
    "title174",
    "item172",
    "left172",
    "icon172",
    "title175",
    "item173",
    "left173",
    "icon173",
    "title176",
    "item174",
    "left174",
    "icon174",
    "title177",
    "item175",
    "left175",
    "icon175",
    "title178",
    "item176",
    "left176",
    "icon176",
    "title179",
    "item177",
    "left177",
    "icon177",
    "title180",
    "item178",
    "left178",
    "icon178",
    "title181",
    "item179",
    "left179",
    "icon179",
    "title182",
    "item180",
    "left180",
    "icon180",
    "title183",
    "item181",
    "left181",
    "icon181",
    "title184",
    "item182",
    "left182",
    "icon182",
    "title185",
    "item183",
    "left183",
    "icon183",
    "title186",
    "item184",
    "left184",
    "icon184",
    "title187",
    "item185",
    "left185",
    "icon185",
    "title188",
    "item186",
    "left186",
    "icon186",
    "title189",
    "item187",
    "left187",
    "icon187",
    "title190",
    "item188",
    "left188",
    "icon188",
    "title191",
    "item189",
    "left189",
    "icon189",
    "title192",
    "item190",
    "left190",
    "icon190",
    "title193",
    "item191",
    "left191",
    "icon191",
    "title194",
    "item192",
    "left192",
    "icon192",
    "title195"
  ],
  header12: ["header12"],
  list10: [
    "list10",
    "item169",
    "left169",
    "icon169",
    "title172",
    "item170",
    "left170",
    "icon170",
    "title173",
    "item171",
    "left171",
    "icon171",
    "title174",
    "item172",
    "left172",
    "icon172",
    "title175",
    "item173",
    "left173",
    "icon173",
    "title176",
    "item174",
    "left174",
    "icon174",
    "title177",
    "item175",
    "left175",
    "icon175",
    "title178",
    "item176",
    "left176",
    "icon176",
    "title179",
    "item177",
    "left177",
    "icon177",
    "title180",
    "item178",
    "left178",
    "icon178",
    "title181",
    "item179",
    "left179",
    "icon179",
    "title182",
    "item180",
    "left180",
    "icon180",
    "title183",
    "item181",
    "left181",
    "icon181",
    "title184",
    "item182",
    "left182",
    "icon182",
    "title185",
    "item183",
    "left183",
    "icon183",
    "title186",
    "item184",
    "left184",
    "icon184",
    "title187",
    "item185",
    "left185",
    "icon185",
    "title188",
    "item186",
    "left186",
    "icon186",
    "title189",
    "item187",
    "left187",
    "icon187",
    "title190",
    "item188",
    "left188",
    "icon188",
    "title191",
    "item189",
    "left189",
    "icon189",
    "title192",
    "item190",
    "left190",
    "icon190",
    "title193",
    "item191",
    "left191",
    "icon191",
    "title194",
    "item192",
    "left192",
    "icon192",
    "title195"
  ],
  item169: ["item169", "left169", "icon169", "title172"],
  left169: ["left169", "icon169"],
  icon169: ["icon169"],
  title172: ["title172"],
  item170: ["item170", "left170", "icon170", "title173"],
  left170: ["left170", "icon170"],
  icon170: ["icon170"],
  title173: ["title173"],
  item171: ["item171", "left171", "icon171", "title174"],
  left171: ["left171", "icon171"],
  icon171: ["icon171"],
  title174: ["title174"],
  item172: ["item172", "left172", "icon172", "title175"],
  left172: ["left172", "icon172"],
  icon172: ["icon172"],
  title175: ["title175"],
  item173: ["item173", "left173", "icon173", "title176"],
  left173: ["left173", "icon173"],
  icon173: ["icon173"],
  title176: ["title176"],
  item174: ["item174", "left174", "icon174", "title177"],
  left174: ["left174", "icon174"],
  icon174: ["icon174"],
  title177: ["title177"],
  item175: ["item175", "left175", "icon175", "title178"],
  left175: ["left175", "icon175"],
  icon175: ["icon175"],
  title178: ["title178"],
  item176: ["item176", "left176", "icon176", "title179"],
  left176: ["left176", "icon176"],
  icon176: ["icon176"],
  title179: ["title179"],
  item177: ["item177", "left177", "icon177", "title180"],
  left177: ["left177", "icon177"],
  icon177: ["icon177"],
  title180: ["title180"],
  item178: ["item178", "left178", "icon178", "title181"],
  left178: ["left178", "icon178"],
  icon178: ["icon178"],
  title181: ["title181"],
  item179: ["item179", "left179", "icon179", "title182"],
  left179: ["left179", "icon179"],
  icon179: ["icon179"],
  title182: ["title182"],
  item180: ["item180", "left180", "icon180", "title183"],
  left180: ["left180", "icon180"],
  icon180: ["icon180"],
  title183: ["title183"],
  item181: ["item181", "left181", "icon181", "title184"],
  left181: ["left181", "icon181"],
  icon181: ["icon181"],
  title184: ["title184"],
  item182: ["item182", "left182", "icon182", "title185"],
  left182: ["left182", "icon182"],
  icon182: ["icon182"],
  title185: ["title185"],
  item183: ["item183", "left183", "icon183", "title186"],
  left183: ["left183", "icon183"],
  icon183: ["icon183"],
  title186: ["title186"],
  item184: ["item184", "left184", "icon184", "title187"],
  left184: ["left184", "icon184"],
  icon184: ["icon184"],
  title187: ["title187"],
  item185: ["item185", "left185", "icon185", "title188"],
  left185: ["left185", "icon185"],
  icon185: ["icon185"],
  title188: ["title188"],
  item186: ["item186", "left186", "icon186", "title189"],
  left186: ["left186", "icon186"],
  icon186: ["icon186"],
  title189: ["title189"],
  item187: ["item187", "left187", "icon187", "title190"],
  left187: ["left187", "icon187"],
  icon187: ["icon187"],
  title190: ["title190"],
  item188: ["item188", "left188", "icon188", "title191"],
  left188: ["left188", "icon188"],
  icon188: ["icon188"],
  title191: ["title191"],
  item189: ["item189", "left189", "icon189", "title192"],
  left189: ["left189", "icon189"],
  icon189: ["icon189"],
  title192: ["title192"],
  item190: ["item190", "left190", "icon190", "title193"],
  left190: ["left190", "icon190"],
  icon190: ["icon190"],
  title193: ["title193"],
  item191: ["item191", "left191", "icon191", "title194"],
  left191: ["left191", "icon191"],
  icon191: ["icon191"],
  title194: ["title194"],
  item192: ["item192", "left192", "icon192", "title195"],
  left192: ["left192", "icon192"],
  icon192: ["icon192"],
  title195: ["title195"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  myEvaluations: "section";
  desktop: "div";
  row: "div";
  logo: typeof Logo;
  key2: "div";
  header: "header";
  list: "div";
  row2: "div";
  row3: "div";
  row4: "div";
  all: "div";
  title: "div";
  sections: "div";
  col: "div";
  header5: "div";
  list5: "div";
  item: "div";
  left: "div";
  icon: "div";
  title98: "div";
  item2: "div";
  left2: "div";
  icon2: "div";
  title99: "div";
  item3: "div";
  left3: "div";
  icon3: "div";
  title4: "div";
  item4: "div";
  left4: "div";
  icon4: "div";
  title5: "div";
  item5: "div";
  left5: "div";
  icon5: "div";
  title6: "div";
  item6: "div";
  left6: "div";
  icon6: "div";
  title7: "div";
  item7: "div";
  left7: "div";
  icon7: "div";
  title8: "div";
  item8: "div";
  left8: "div";
  icon8: "div";
  title9: "div";
  item9: "div";
  left9: "div";
  icon9: "div";
  title10: "div";
  item10: "div";
  left10: "div";
  icon10: "div";
  title11: "div";
  item11: "div";
  left11: "div";
  icon11: "div";
  title12: "div";
  item12: "div";
  left12: "div";
  icon12: "div";
  title13: "div";
  item13: "div";
  left13: "div";
  icon13: "div";
  title14: "div";
  item14: "div";
  left14: "div";
  icon14: "div";
  title15: "div";
  item15: "div";
  left15: "div";
  icon15: "div";
  title16: "div";
  item16: "div";
  left16: "div";
  icon16: "div";
  title17: "div";
  item17: "div";
  left17: "div";
  icon17: "div";
  title18: "div";
  item18: "div";
  left18: "div";
  icon18: "div";
  title19: "div";
  item19: "div";
  left19: "div";
  icon19: "div";
  title20: "div";
  item20: "div";
  left20: "div";
  icon20: "div";
  title21: "div";
  item21: "div";
  left21: "div";
  icon21: "div";
  title22: "div";
  item22: "div";
  left22: "div";
  icon22: "div";
  title23: "div";
  item23: "div";
  left23: "div";
  icon23: "div";
  title24: "div";
  item24: "div";
  left24: "div";
  icon24: "div";
  title25: "div";
  col2: "div";
  section: "div";
  header6: "div";
  list2: "div";
  item25: "div";
  left25: "div";
  icon25: "div";
  title26: "div";
  item26: "div";
  left26: "div";
  icon26: "div";
  title27: "div";
  item27: "div";
  left27: "div";
  icon27: "div";
  title28: "div";
  item28: "div";
  left28: "div";
  icon28: "div";
  title29: "div";
  item29: "div";
  left29: "div";
  icon29: "div";
  title30: "div";
  item30: "div";
  left30: "div";
  icon30: "div";
  title31: "div";
  item31: "div";
  left31: "div";
  icon31: "div";
  title32: "div";
  item32: "div";
  left32: "div";
  icon32: "div";
  title33: "div";
  item33: "div";
  left33: "div";
  icon33: "div";
  title34: "div";
  item34: "div";
  left34: "div";
  icon34: "div";
  title35: "div";
  item35: "div";
  left35: "div";
  icon35: "div";
  title36: "div";
  item36: "div";
  left36: "div";
  icon36: "div";
  title37: "div";
  item37: "div";
  left37: "div";
  icon37: "div";
  title38: "div";
  item38: "div";
  left38: "div";
  icon38: "div";
  title39: "div";
  item39: "div";
  left39: "div";
  icon39: "div";
  title40: "div";
  item40: "div";
  left40: "div";
  icon40: "div";
  title41: "div";
  item41: "div";
  left41: "div";
  icon41: "div";
  title42: "div";
  item42: "div";
  left42: "div";
  icon42: "div";
  title43: "div";
  item43: "div";
  left43: "div";
  icon43: "div";
  title44: "div";
  item44: "div";
  left44: "div";
  icon44: "div";
  title45: "div";
  item45: "div";
  left45: "div";
  icon45: "div";
  title46: "div";
  item46: "div";
  left46: "div";
  icon46: "div";
  title47: "div";
  item47: "div";
  left47: "div";
  icon47: "div";
  title48: "div";
  item48: "div";
  left48: "div";
  icon48: "div";
  title49: "div";
  section2: "div";
  header7: "div";
  list3: "div";
  item49: "div";
  left49: "div";
  icon49: "div";
  title50: "div";
  item50: "div";
  left50: "div";
  icon50: "div";
  title51: "div";
  item51: "div";
  left51: "div";
  icon51: "div";
  title52: "div";
  item52: "div";
  left52: "div";
  icon52: "div";
  title53: "div";
  item53: "div";
  left53: "div";
  icon53: "div";
  title54: "div";
  item54: "div";
  left54: "div";
  icon54: "div";
  title55: "div";
  item55: "div";
  left55: "div";
  icon55: "div";
  title56: "div";
  item56: "div";
  left56: "div";
  icon56: "div";
  title57: "div";
  item57: "div";
  left57: "div";
  icon57: "div";
  title58: "div";
  item58: "div";
  left58: "div";
  icon58: "div";
  title59: "div";
  item59: "div";
  left59: "div";
  icon59: "div";
  title60: "div";
  item60: "div";
  left60: "div";
  icon60: "div";
  title61: "div";
  item61: "div";
  left61: "div";
  icon61: "div";
  title62: "div";
  item62: "div";
  left62: "div";
  icon62: "div";
  title63: "div";
  item63: "div";
  left63: "div";
  icon63: "div";
  title64: "div";
  item64: "div";
  left64: "div";
  icon64: "div";
  title65: "div";
  item65: "div";
  left65: "div";
  icon65: "div";
  title66: "div";
  item66: "div";
  left66: "div";
  icon66: "div";
  title67: "div";
  item67: "div";
  left67: "div";
  icon67: "div";
  title68: "div";
  item68: "div";
  left68: "div";
  icon68: "div";
  title69: "div";
  item69: "div";
  left69: "div";
  icon69: "div";
  title70: "div";
  item70: "div";
  left70: "div";
  icon70: "div";
  title71: "div";
  item71: "div";
  left71: "div";
  icon71: "div";
  title72: "div";
  item72: "div";
  left72: "div";
  icon72: "div";
  title73: "div";
  col3: "div";
  header8: "div";
  list4: "div";
  item73: "div";
  left73: "div";
  icon73: "div";
  title74: "div";
  item74: "div";
  left74: "div";
  icon74: "div";
  title75: "div";
  item75: "div";
  left75: "div";
  icon75: "div";
  title76: "div";
  item76: "div";
  left76: "div";
  icon76: "div";
  title77: "div";
  item77: "div";
  left77: "div";
  icon77: "div";
  title78: "div";
  item78: "div";
  left78: "div";
  icon78: "div";
  title79: "div";
  item79: "div";
  left79: "div";
  icon79: "div";
  title80: "div";
  item80: "div";
  left80: "div";
  icon80: "div";
  title81: "div";
  item81: "div";
  left81: "div";
  icon81: "div";
  title82: "div";
  item82: "div";
  left82: "div";
  icon82: "div";
  title83: "div";
  item83: "div";
  left83: "div";
  icon83: "div";
  title84: "div";
  item84: "div";
  left84: "div";
  icon84: "div";
  title85: "div";
  item85: "div";
  left85: "div";
  icon85: "div";
  title86: "div";
  item86: "div";
  left86: "div";
  icon86: "div";
  title87: "div";
  item87: "div";
  left87: "div";
  icon87: "div";
  title88: "div";
  item88: "div";
  left88: "div";
  icon88: "div";
  title89: "div";
  item89: "div";
  left89: "div";
  icon89: "div";
  title90: "div";
  item90: "div";
  left90: "div";
  icon90: "div";
  title91: "div";
  item91: "div";
  left91: "div";
  icon91: "div";
  title92: "div";
  item92: "div";
  left92: "div";
  icon92: "div";
  title93: "div";
  item93: "div";
  left93: "div";
  icon93: "div";
  title94: "div";
  item94: "div";
  left94: "div";
  icon94: "div";
  title95: "div";
  item95: "div";
  left95: "div";
  icon95: "div";
  title96: "div";
  item96: "div";
  left96: "div";
  icon96: "div";
  title97: "div";
  tablet: "div";
  row6: "div";
  key4: "div";
  header4: "header";
  list11: "div";
  row7: "div";
  row8: "div";
  row9: "div";
  row10: "div";
  row11: "div";
  all3: "div";
  title3: "h2";
  sections3: "div";
  col8: "div";
  list12: "div";
  col9: "div";
  section5: "div";
  list13: "div";
  section6: "div";
  list14: "div";
  col10: "div";
  list15: "div";
  mobile: "div";
  header3: "div";
  key3: "div";
  header2: "header";
  list6: "div";
  all2: "div";
  title100: "div";
  sections2: "div";
  section7: "div";
  header9: "div";
  list7: "div";
  item97: "div";
  left97: "div";
  icon97: "div";
  title2: "div";
  item98: "div";
  left98: "div";
  icon98: "div";
  title101: "div";
  item99: "div";
  left99: "div";
  icon99: "div";
  title102: "div";
  item100: "div";
  left100: "div";
  icon100: "div";
  title103: "div";
  item101: "div";
  left101: "div";
  icon101: "div";
  title104: "div";
  item102: "div";
  left102: "div";
  icon102: "div";
  title105: "div";
  item103: "div";
  left103: "div";
  icon103: "div";
  title106: "div";
  item104: "div";
  left104: "div";
  icon104: "div";
  title107: "div";
  item105: "div";
  left105: "div";
  icon105: "div";
  title108: "div";
  item106: "div";
  left106: "div";
  icon106: "div";
  title109: "div";
  item107: "div";
  left107: "div";
  icon107: "div";
  title110: "div";
  item108: "div";
  left108: "div";
  icon108: "div";
  title111: "div";
  item109: "div";
  left109: "div";
  icon109: "div";
  title112: "div";
  item110: "div";
  left110: "div";
  icon110: "div";
  title113: "div";
  item111: "div";
  left111: "div";
  icon111: "div";
  title114: "div";
  item112: "div";
  left112: "div";
  icon112: "div";
  title115: "div";
  item113: "div";
  left113: "div";
  icon113: "div";
  title116: "div";
  item114: "div";
  left114: "div";
  icon114: "div";
  title117: "div";
  item115: "div";
  left115: "div";
  icon115: "div";
  title118: "div";
  item116: "div";
  left116: "div";
  icon116: "div";
  title119: "div";
  item117: "div";
  left117: "div";
  icon117: "div";
  title120: "div";
  item118: "div";
  left118: "div";
  icon118: "div";
  title121: "div";
  item119: "div";
  left119: "div";
  icon119: "div";
  title122: "div";
  item120: "div";
  left120: "div";
  icon120: "div";
  title123: "div";
  section8: "div";
  header10: "div";
  list8: "div";
  item121: "div";
  left121: "div";
  icon121: "div";
  title124: "div";
  item122: "div";
  left122: "div";
  icon122: "div";
  title125: "div";
  item123: "div";
  left123: "div";
  icon123: "div";
  title126: "div";
  item124: "div";
  left124: "div";
  icon124: "div";
  title127: "div";
  item125: "div";
  left125: "div";
  icon125: "div";
  title128: "div";
  item126: "div";
  left126: "div";
  icon126: "div";
  title129: "div";
  item127: "div";
  left127: "div";
  icon127: "div";
  title130: "div";
  item128: "div";
  left128: "div";
  icon128: "div";
  title131: "div";
  item129: "div";
  left129: "div";
  icon129: "div";
  title132: "div";
  item130: "div";
  left130: "div";
  icon130: "div";
  title133: "div";
  item131: "div";
  left131: "div";
  icon131: "div";
  title134: "div";
  item132: "div";
  left132: "div";
  icon132: "div";
  title135: "div";
  item133: "div";
  left133: "div";
  icon133: "div";
  title136: "div";
  item134: "div";
  left134: "div";
  icon134: "div";
  title137: "div";
  item135: "div";
  left135: "div";
  icon135: "div";
  title138: "div";
  item136: "div";
  left136: "div";
  icon136: "div";
  title139: "div";
  item137: "div";
  left137: "div";
  icon137: "div";
  title140: "div";
  item138: "div";
  left138: "div";
  icon138: "div";
  title141: "div";
  item139: "div";
  left139: "div";
  icon139: "div";
  title142: "div";
  item140: "div";
  left140: "div";
  icon140: "div";
  title143: "div";
  item141: "div";
  left141: "div";
  icon141: "div";
  title144: "div";
  item142: "div";
  left142: "div";
  icon142: "div";
  title145: "div";
  item143: "div";
  left143: "div";
  icon143: "div";
  title146: "div";
  item144: "div";
  left144: "div";
  icon144: "div";
  title147: "div";
  section3: "div";
  header11: "div";
  list9: "div";
  item145: "div";
  left145: "div";
  icon145: "div";
  title148: "div";
  item146: "div";
  left146: "div";
  icon146: "div";
  title149: "div";
  item147: "div";
  left147: "div";
  icon147: "div";
  title150: "div";
  item148: "div";
  left148: "div";
  icon148: "div";
  title151: "div";
  item149: "div";
  left149: "div";
  icon149: "div";
  title152: "div";
  item150: "div";
  left150: "div";
  icon150: "div";
  title153: "div";
  item151: "div";
  left151: "div";
  icon151: "div";
  title154: "div";
  item152: "div";
  left152: "div";
  icon152: "div";
  title155: "div";
  item153: "div";
  left153: "div";
  icon153: "div";
  title156: "div";
  item154: "div";
  left154: "div";
  icon154: "div";
  title157: "div";
  item155: "div";
  left155: "div";
  icon155: "div";
  title158: "div";
  item156: "div";
  left156: "div";
  icon156: "div";
  title159: "div";
  item157: "div";
  left157: "div";
  icon157: "div";
  title160: "div";
  item158: "div";
  left158: "div";
  icon158: "div";
  title161: "div";
  item159: "div";
  left159: "div";
  icon159: "div";
  title162: "div";
  item160: "div";
  left160: "div";
  icon160: "div";
  title163: "div";
  item161: "div";
  left161: "div";
  icon161: "div";
  title164: "div";
  item162: "div";
  left162: "div";
  icon162: "div";
  title165: "div";
  item163: "div";
  left163: "div";
  icon163: "div";
  title166: "div";
  item164: "div";
  left164: "div";
  icon164: "div";
  title167: "div";
  item165: "div";
  left165: "div";
  icon165: "div";
  title168: "div";
  item166: "div";
  left166: "div";
  icon166: "div";
  title169: "div";
  item167: "div";
  left167: "div";
  icon167: "div";
  title170: "div";
  item168: "div";
  left168: "div";
  icon168: "div";
  title171: "div";
  section4: "div";
  header12: "div";
  list10: "div";
  item169: "div";
  left169: "div";
  icon169: "div";
  title172: "div";
  item170: "div";
  left170: "div";
  icon170: "div";
  title173: "div";
  item171: "div";
  left171: "div";
  icon171: "div";
  title174: "div";
  item172: "div";
  left172: "div";
  icon172: "div";
  title175: "div";
  item173: "div";
  left173: "div";
  icon173: "div";
  title176: "div";
  item174: "div";
  left174: "div";
  icon174: "div";
  title177: "div";
  item175: "div";
  left175: "div";
  icon175: "div";
  title178: "div";
  item176: "div";
  left176: "div";
  icon176: "div";
  title179: "div";
  item177: "div";
  left177: "div";
  icon177: "div";
  title180: "div";
  item178: "div";
  left178: "div";
  icon178: "div";
  title181: "div";
  item179: "div";
  left179: "div";
  icon179: "div";
  title182: "div";
  item180: "div";
  left180: "div";
  icon180: "div";
  title183: "div";
  item181: "div";
  left181: "div";
  icon181: "div";
  title184: "div";
  item182: "div";
  left182: "div";
  icon182: "div";
  title185: "div";
  item183: "div";
  left183: "div";
  icon183: "div";
  title186: "div";
  item184: "div";
  left184: "div";
  icon184: "div";
  title187: "div";
  item185: "div";
  left185: "div";
  icon185: "div";
  title188: "div";
  item186: "div";
  left186: "div";
  icon186: "div";
  title189: "div";
  item187: "div";
  left187: "div";
  icon187: "div";
  title190: "div";
  item188: "div";
  left188: "div";
  icon188: "div";
  title191: "div";
  item189: "div";
  left189: "div";
  icon189: "div";
  title192: "div";
  item190: "div";
  left190: "div";
  icon190: "div";
  title193: "div";
  item191: "div";
  left191: "div";
  icon191: "div";
  title194: "div";
  item192: "div";
  left192: "div";
  icon192: "div";
  title195: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesMyEvaluations__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesMyEvaluations__VariantsArgs;
    args?: PlasmicFeaturesMyEvaluations__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeaturesMyEvaluations__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeaturesMyEvaluations__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesMyEvaluations__ArgProps,
          internalVariantPropNames: PlasmicFeaturesMyEvaluations__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesMyEvaluations__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "myEvaluations") {
    func.displayName = "PlasmicFeaturesMyEvaluations";
  } else {
    func.displayName = `PlasmicFeaturesMyEvaluations.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesMyEvaluations = Object.assign(
  // Top-level PlasmicFeaturesMyEvaluations renders the root element
  makeNodeComponent("myEvaluations"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    row: makeNodeComponent("row"),
    logo: makeNodeComponent("logo"),
    key2: makeNodeComponent("key2"),
    header: makeNodeComponent("header"),
    list: makeNodeComponent("list"),
    row2: makeNodeComponent("row2"),
    row3: makeNodeComponent("row3"),
    row4: makeNodeComponent("row4"),
    all: makeNodeComponent("all"),
    title: makeNodeComponent("title"),
    sections: makeNodeComponent("sections"),
    col: makeNodeComponent("col"),
    header5: makeNodeComponent("header5"),
    list5: makeNodeComponent("list5"),
    item: makeNodeComponent("item"),
    left: makeNodeComponent("left"),
    icon: makeNodeComponent("icon"),
    title98: makeNodeComponent("title98"),
    item2: makeNodeComponent("item2"),
    left2: makeNodeComponent("left2"),
    icon2: makeNodeComponent("icon2"),
    title99: makeNodeComponent("title99"),
    item3: makeNodeComponent("item3"),
    left3: makeNodeComponent("left3"),
    icon3: makeNodeComponent("icon3"),
    title4: makeNodeComponent("title4"),
    item4: makeNodeComponent("item4"),
    left4: makeNodeComponent("left4"),
    icon4: makeNodeComponent("icon4"),
    title5: makeNodeComponent("title5"),
    item5: makeNodeComponent("item5"),
    left5: makeNodeComponent("left5"),
    icon5: makeNodeComponent("icon5"),
    title6: makeNodeComponent("title6"),
    item6: makeNodeComponent("item6"),
    left6: makeNodeComponent("left6"),
    icon6: makeNodeComponent("icon6"),
    title7: makeNodeComponent("title7"),
    item7: makeNodeComponent("item7"),
    left7: makeNodeComponent("left7"),
    icon7: makeNodeComponent("icon7"),
    title8: makeNodeComponent("title8"),
    item8: makeNodeComponent("item8"),
    left8: makeNodeComponent("left8"),
    icon8: makeNodeComponent("icon8"),
    title9: makeNodeComponent("title9"),
    item9: makeNodeComponent("item9"),
    left9: makeNodeComponent("left9"),
    icon9: makeNodeComponent("icon9"),
    title10: makeNodeComponent("title10"),
    item10: makeNodeComponent("item10"),
    left10: makeNodeComponent("left10"),
    icon10: makeNodeComponent("icon10"),
    title11: makeNodeComponent("title11"),
    item11: makeNodeComponent("item11"),
    left11: makeNodeComponent("left11"),
    icon11: makeNodeComponent("icon11"),
    title12: makeNodeComponent("title12"),
    item12: makeNodeComponent("item12"),
    left12: makeNodeComponent("left12"),
    icon12: makeNodeComponent("icon12"),
    title13: makeNodeComponent("title13"),
    item13: makeNodeComponent("item13"),
    left13: makeNodeComponent("left13"),
    icon13: makeNodeComponent("icon13"),
    title14: makeNodeComponent("title14"),
    item14: makeNodeComponent("item14"),
    left14: makeNodeComponent("left14"),
    icon14: makeNodeComponent("icon14"),
    title15: makeNodeComponent("title15"),
    item15: makeNodeComponent("item15"),
    left15: makeNodeComponent("left15"),
    icon15: makeNodeComponent("icon15"),
    title16: makeNodeComponent("title16"),
    item16: makeNodeComponent("item16"),
    left16: makeNodeComponent("left16"),
    icon16: makeNodeComponent("icon16"),
    title17: makeNodeComponent("title17"),
    item17: makeNodeComponent("item17"),
    left17: makeNodeComponent("left17"),
    icon17: makeNodeComponent("icon17"),
    title18: makeNodeComponent("title18"),
    item18: makeNodeComponent("item18"),
    left18: makeNodeComponent("left18"),
    icon18: makeNodeComponent("icon18"),
    title19: makeNodeComponent("title19"),
    item19: makeNodeComponent("item19"),
    left19: makeNodeComponent("left19"),
    icon19: makeNodeComponent("icon19"),
    title20: makeNodeComponent("title20"),
    item20: makeNodeComponent("item20"),
    left20: makeNodeComponent("left20"),
    icon20: makeNodeComponent("icon20"),
    title21: makeNodeComponent("title21"),
    item21: makeNodeComponent("item21"),
    left21: makeNodeComponent("left21"),
    icon21: makeNodeComponent("icon21"),
    title22: makeNodeComponent("title22"),
    item22: makeNodeComponent("item22"),
    left22: makeNodeComponent("left22"),
    icon22: makeNodeComponent("icon22"),
    title23: makeNodeComponent("title23"),
    item23: makeNodeComponent("item23"),
    left23: makeNodeComponent("left23"),
    icon23: makeNodeComponent("icon23"),
    title24: makeNodeComponent("title24"),
    item24: makeNodeComponent("item24"),
    left24: makeNodeComponent("left24"),
    icon24: makeNodeComponent("icon24"),
    title25: makeNodeComponent("title25"),
    col2: makeNodeComponent("col2"),
    section: makeNodeComponent("section"),
    header6: makeNodeComponent("header6"),
    list2: makeNodeComponent("list2"),
    item25: makeNodeComponent("item25"),
    left25: makeNodeComponent("left25"),
    icon25: makeNodeComponent("icon25"),
    title26: makeNodeComponent("title26"),
    item26: makeNodeComponent("item26"),
    left26: makeNodeComponent("left26"),
    icon26: makeNodeComponent("icon26"),
    title27: makeNodeComponent("title27"),
    item27: makeNodeComponent("item27"),
    left27: makeNodeComponent("left27"),
    icon27: makeNodeComponent("icon27"),
    title28: makeNodeComponent("title28"),
    item28: makeNodeComponent("item28"),
    left28: makeNodeComponent("left28"),
    icon28: makeNodeComponent("icon28"),
    title29: makeNodeComponent("title29"),
    item29: makeNodeComponent("item29"),
    left29: makeNodeComponent("left29"),
    icon29: makeNodeComponent("icon29"),
    title30: makeNodeComponent("title30"),
    item30: makeNodeComponent("item30"),
    left30: makeNodeComponent("left30"),
    icon30: makeNodeComponent("icon30"),
    title31: makeNodeComponent("title31"),
    item31: makeNodeComponent("item31"),
    left31: makeNodeComponent("left31"),
    icon31: makeNodeComponent("icon31"),
    title32: makeNodeComponent("title32"),
    item32: makeNodeComponent("item32"),
    left32: makeNodeComponent("left32"),
    icon32: makeNodeComponent("icon32"),
    title33: makeNodeComponent("title33"),
    item33: makeNodeComponent("item33"),
    left33: makeNodeComponent("left33"),
    icon33: makeNodeComponent("icon33"),
    title34: makeNodeComponent("title34"),
    item34: makeNodeComponent("item34"),
    left34: makeNodeComponent("left34"),
    icon34: makeNodeComponent("icon34"),
    title35: makeNodeComponent("title35"),
    item35: makeNodeComponent("item35"),
    left35: makeNodeComponent("left35"),
    icon35: makeNodeComponent("icon35"),
    title36: makeNodeComponent("title36"),
    item36: makeNodeComponent("item36"),
    left36: makeNodeComponent("left36"),
    icon36: makeNodeComponent("icon36"),
    title37: makeNodeComponent("title37"),
    item37: makeNodeComponent("item37"),
    left37: makeNodeComponent("left37"),
    icon37: makeNodeComponent("icon37"),
    title38: makeNodeComponent("title38"),
    item38: makeNodeComponent("item38"),
    left38: makeNodeComponent("left38"),
    icon38: makeNodeComponent("icon38"),
    title39: makeNodeComponent("title39"),
    item39: makeNodeComponent("item39"),
    left39: makeNodeComponent("left39"),
    icon39: makeNodeComponent("icon39"),
    title40: makeNodeComponent("title40"),
    item40: makeNodeComponent("item40"),
    left40: makeNodeComponent("left40"),
    icon40: makeNodeComponent("icon40"),
    title41: makeNodeComponent("title41"),
    item41: makeNodeComponent("item41"),
    left41: makeNodeComponent("left41"),
    icon41: makeNodeComponent("icon41"),
    title42: makeNodeComponent("title42"),
    item42: makeNodeComponent("item42"),
    left42: makeNodeComponent("left42"),
    icon42: makeNodeComponent("icon42"),
    title43: makeNodeComponent("title43"),
    item43: makeNodeComponent("item43"),
    left43: makeNodeComponent("left43"),
    icon43: makeNodeComponent("icon43"),
    title44: makeNodeComponent("title44"),
    item44: makeNodeComponent("item44"),
    left44: makeNodeComponent("left44"),
    icon44: makeNodeComponent("icon44"),
    title45: makeNodeComponent("title45"),
    item45: makeNodeComponent("item45"),
    left45: makeNodeComponent("left45"),
    icon45: makeNodeComponent("icon45"),
    title46: makeNodeComponent("title46"),
    item46: makeNodeComponent("item46"),
    left46: makeNodeComponent("left46"),
    icon46: makeNodeComponent("icon46"),
    title47: makeNodeComponent("title47"),
    item47: makeNodeComponent("item47"),
    left47: makeNodeComponent("left47"),
    icon47: makeNodeComponent("icon47"),
    title48: makeNodeComponent("title48"),
    item48: makeNodeComponent("item48"),
    left48: makeNodeComponent("left48"),
    icon48: makeNodeComponent("icon48"),
    title49: makeNodeComponent("title49"),
    section2: makeNodeComponent("section2"),
    header7: makeNodeComponent("header7"),
    list3: makeNodeComponent("list3"),
    item49: makeNodeComponent("item49"),
    left49: makeNodeComponent("left49"),
    icon49: makeNodeComponent("icon49"),
    title50: makeNodeComponent("title50"),
    item50: makeNodeComponent("item50"),
    left50: makeNodeComponent("left50"),
    icon50: makeNodeComponent("icon50"),
    title51: makeNodeComponent("title51"),
    item51: makeNodeComponent("item51"),
    left51: makeNodeComponent("left51"),
    icon51: makeNodeComponent("icon51"),
    title52: makeNodeComponent("title52"),
    item52: makeNodeComponent("item52"),
    left52: makeNodeComponent("left52"),
    icon52: makeNodeComponent("icon52"),
    title53: makeNodeComponent("title53"),
    item53: makeNodeComponent("item53"),
    left53: makeNodeComponent("left53"),
    icon53: makeNodeComponent("icon53"),
    title54: makeNodeComponent("title54"),
    item54: makeNodeComponent("item54"),
    left54: makeNodeComponent("left54"),
    icon54: makeNodeComponent("icon54"),
    title55: makeNodeComponent("title55"),
    item55: makeNodeComponent("item55"),
    left55: makeNodeComponent("left55"),
    icon55: makeNodeComponent("icon55"),
    title56: makeNodeComponent("title56"),
    item56: makeNodeComponent("item56"),
    left56: makeNodeComponent("left56"),
    icon56: makeNodeComponent("icon56"),
    title57: makeNodeComponent("title57"),
    item57: makeNodeComponent("item57"),
    left57: makeNodeComponent("left57"),
    icon57: makeNodeComponent("icon57"),
    title58: makeNodeComponent("title58"),
    item58: makeNodeComponent("item58"),
    left58: makeNodeComponent("left58"),
    icon58: makeNodeComponent("icon58"),
    title59: makeNodeComponent("title59"),
    item59: makeNodeComponent("item59"),
    left59: makeNodeComponent("left59"),
    icon59: makeNodeComponent("icon59"),
    title60: makeNodeComponent("title60"),
    item60: makeNodeComponent("item60"),
    left60: makeNodeComponent("left60"),
    icon60: makeNodeComponent("icon60"),
    title61: makeNodeComponent("title61"),
    item61: makeNodeComponent("item61"),
    left61: makeNodeComponent("left61"),
    icon61: makeNodeComponent("icon61"),
    title62: makeNodeComponent("title62"),
    item62: makeNodeComponent("item62"),
    left62: makeNodeComponent("left62"),
    icon62: makeNodeComponent("icon62"),
    title63: makeNodeComponent("title63"),
    item63: makeNodeComponent("item63"),
    left63: makeNodeComponent("left63"),
    icon63: makeNodeComponent("icon63"),
    title64: makeNodeComponent("title64"),
    item64: makeNodeComponent("item64"),
    left64: makeNodeComponent("left64"),
    icon64: makeNodeComponent("icon64"),
    title65: makeNodeComponent("title65"),
    item65: makeNodeComponent("item65"),
    left65: makeNodeComponent("left65"),
    icon65: makeNodeComponent("icon65"),
    title66: makeNodeComponent("title66"),
    item66: makeNodeComponent("item66"),
    left66: makeNodeComponent("left66"),
    icon66: makeNodeComponent("icon66"),
    title67: makeNodeComponent("title67"),
    item67: makeNodeComponent("item67"),
    left67: makeNodeComponent("left67"),
    icon67: makeNodeComponent("icon67"),
    title68: makeNodeComponent("title68"),
    item68: makeNodeComponent("item68"),
    left68: makeNodeComponent("left68"),
    icon68: makeNodeComponent("icon68"),
    title69: makeNodeComponent("title69"),
    item69: makeNodeComponent("item69"),
    left69: makeNodeComponent("left69"),
    icon69: makeNodeComponent("icon69"),
    title70: makeNodeComponent("title70"),
    item70: makeNodeComponent("item70"),
    left70: makeNodeComponent("left70"),
    icon70: makeNodeComponent("icon70"),
    title71: makeNodeComponent("title71"),
    item71: makeNodeComponent("item71"),
    left71: makeNodeComponent("left71"),
    icon71: makeNodeComponent("icon71"),
    title72: makeNodeComponent("title72"),
    item72: makeNodeComponent("item72"),
    left72: makeNodeComponent("left72"),
    icon72: makeNodeComponent("icon72"),
    title73: makeNodeComponent("title73"),
    col3: makeNodeComponent("col3"),
    header8: makeNodeComponent("header8"),
    list4: makeNodeComponent("list4"),
    item73: makeNodeComponent("item73"),
    left73: makeNodeComponent("left73"),
    icon73: makeNodeComponent("icon73"),
    title74: makeNodeComponent("title74"),
    item74: makeNodeComponent("item74"),
    left74: makeNodeComponent("left74"),
    icon74: makeNodeComponent("icon74"),
    title75: makeNodeComponent("title75"),
    item75: makeNodeComponent("item75"),
    left75: makeNodeComponent("left75"),
    icon75: makeNodeComponent("icon75"),
    title76: makeNodeComponent("title76"),
    item76: makeNodeComponent("item76"),
    left76: makeNodeComponent("left76"),
    icon76: makeNodeComponent("icon76"),
    title77: makeNodeComponent("title77"),
    item77: makeNodeComponent("item77"),
    left77: makeNodeComponent("left77"),
    icon77: makeNodeComponent("icon77"),
    title78: makeNodeComponent("title78"),
    item78: makeNodeComponent("item78"),
    left78: makeNodeComponent("left78"),
    icon78: makeNodeComponent("icon78"),
    title79: makeNodeComponent("title79"),
    item79: makeNodeComponent("item79"),
    left79: makeNodeComponent("left79"),
    icon79: makeNodeComponent("icon79"),
    title80: makeNodeComponent("title80"),
    item80: makeNodeComponent("item80"),
    left80: makeNodeComponent("left80"),
    icon80: makeNodeComponent("icon80"),
    title81: makeNodeComponent("title81"),
    item81: makeNodeComponent("item81"),
    left81: makeNodeComponent("left81"),
    icon81: makeNodeComponent("icon81"),
    title82: makeNodeComponent("title82"),
    item82: makeNodeComponent("item82"),
    left82: makeNodeComponent("left82"),
    icon82: makeNodeComponent("icon82"),
    title83: makeNodeComponent("title83"),
    item83: makeNodeComponent("item83"),
    left83: makeNodeComponent("left83"),
    icon83: makeNodeComponent("icon83"),
    title84: makeNodeComponent("title84"),
    item84: makeNodeComponent("item84"),
    left84: makeNodeComponent("left84"),
    icon84: makeNodeComponent("icon84"),
    title85: makeNodeComponent("title85"),
    item85: makeNodeComponent("item85"),
    left85: makeNodeComponent("left85"),
    icon85: makeNodeComponent("icon85"),
    title86: makeNodeComponent("title86"),
    item86: makeNodeComponent("item86"),
    left86: makeNodeComponent("left86"),
    icon86: makeNodeComponent("icon86"),
    title87: makeNodeComponent("title87"),
    item87: makeNodeComponent("item87"),
    left87: makeNodeComponent("left87"),
    icon87: makeNodeComponent("icon87"),
    title88: makeNodeComponent("title88"),
    item88: makeNodeComponent("item88"),
    left88: makeNodeComponent("left88"),
    icon88: makeNodeComponent("icon88"),
    title89: makeNodeComponent("title89"),
    item89: makeNodeComponent("item89"),
    left89: makeNodeComponent("left89"),
    icon89: makeNodeComponent("icon89"),
    title90: makeNodeComponent("title90"),
    item90: makeNodeComponent("item90"),
    left90: makeNodeComponent("left90"),
    icon90: makeNodeComponent("icon90"),
    title91: makeNodeComponent("title91"),
    item91: makeNodeComponent("item91"),
    left91: makeNodeComponent("left91"),
    icon91: makeNodeComponent("icon91"),
    title92: makeNodeComponent("title92"),
    item92: makeNodeComponent("item92"),
    left92: makeNodeComponent("left92"),
    icon92: makeNodeComponent("icon92"),
    title93: makeNodeComponent("title93"),
    item93: makeNodeComponent("item93"),
    left93: makeNodeComponent("left93"),
    icon93: makeNodeComponent("icon93"),
    title94: makeNodeComponent("title94"),
    item94: makeNodeComponent("item94"),
    left94: makeNodeComponent("left94"),
    icon94: makeNodeComponent("icon94"),
    title95: makeNodeComponent("title95"),
    item95: makeNodeComponent("item95"),
    left95: makeNodeComponent("left95"),
    icon95: makeNodeComponent("icon95"),
    title96: makeNodeComponent("title96"),
    item96: makeNodeComponent("item96"),
    left96: makeNodeComponent("left96"),
    icon96: makeNodeComponent("icon96"),
    title97: makeNodeComponent("title97"),
    tablet: makeNodeComponent("tablet"),
    row6: makeNodeComponent("row6"),
    key4: makeNodeComponent("key4"),
    header4: makeNodeComponent("header4"),
    list11: makeNodeComponent("list11"),
    row7: makeNodeComponent("row7"),
    row8: makeNodeComponent("row8"),
    row9: makeNodeComponent("row9"),
    row10: makeNodeComponent("row10"),
    row11: makeNodeComponent("row11"),
    all3: makeNodeComponent("all3"),
    title3: makeNodeComponent("title3"),
    sections3: makeNodeComponent("sections3"),
    col8: makeNodeComponent("col8"),
    list12: makeNodeComponent("list12"),
    col9: makeNodeComponent("col9"),
    section5: makeNodeComponent("section5"),
    list13: makeNodeComponent("list13"),
    section6: makeNodeComponent("section6"),
    list14: makeNodeComponent("list14"),
    col10: makeNodeComponent("col10"),
    list15: makeNodeComponent("list15"),
    mobile: makeNodeComponent("mobile"),
    header3: makeNodeComponent("header3"),
    key3: makeNodeComponent("key3"),
    header2: makeNodeComponent("header2"),
    list6: makeNodeComponent("list6"),
    all2: makeNodeComponent("all2"),
    title100: makeNodeComponent("title100"),
    sections2: makeNodeComponent("sections2"),
    section7: makeNodeComponent("section7"),
    header9: makeNodeComponent("header9"),
    list7: makeNodeComponent("list7"),
    item97: makeNodeComponent("item97"),
    left97: makeNodeComponent("left97"),
    icon97: makeNodeComponent("icon97"),
    title2: makeNodeComponent("title2"),
    item98: makeNodeComponent("item98"),
    left98: makeNodeComponent("left98"),
    icon98: makeNodeComponent("icon98"),
    title101: makeNodeComponent("title101"),
    item99: makeNodeComponent("item99"),
    left99: makeNodeComponent("left99"),
    icon99: makeNodeComponent("icon99"),
    title102: makeNodeComponent("title102"),
    item100: makeNodeComponent("item100"),
    left100: makeNodeComponent("left100"),
    icon100: makeNodeComponent("icon100"),
    title103: makeNodeComponent("title103"),
    item101: makeNodeComponent("item101"),
    left101: makeNodeComponent("left101"),
    icon101: makeNodeComponent("icon101"),
    title104: makeNodeComponent("title104"),
    item102: makeNodeComponent("item102"),
    left102: makeNodeComponent("left102"),
    icon102: makeNodeComponent("icon102"),
    title105: makeNodeComponent("title105"),
    item103: makeNodeComponent("item103"),
    left103: makeNodeComponent("left103"),
    icon103: makeNodeComponent("icon103"),
    title106: makeNodeComponent("title106"),
    item104: makeNodeComponent("item104"),
    left104: makeNodeComponent("left104"),
    icon104: makeNodeComponent("icon104"),
    title107: makeNodeComponent("title107"),
    item105: makeNodeComponent("item105"),
    left105: makeNodeComponent("left105"),
    icon105: makeNodeComponent("icon105"),
    title108: makeNodeComponent("title108"),
    item106: makeNodeComponent("item106"),
    left106: makeNodeComponent("left106"),
    icon106: makeNodeComponent("icon106"),
    title109: makeNodeComponent("title109"),
    item107: makeNodeComponent("item107"),
    left107: makeNodeComponent("left107"),
    icon107: makeNodeComponent("icon107"),
    title110: makeNodeComponent("title110"),
    item108: makeNodeComponent("item108"),
    left108: makeNodeComponent("left108"),
    icon108: makeNodeComponent("icon108"),
    title111: makeNodeComponent("title111"),
    item109: makeNodeComponent("item109"),
    left109: makeNodeComponent("left109"),
    icon109: makeNodeComponent("icon109"),
    title112: makeNodeComponent("title112"),
    item110: makeNodeComponent("item110"),
    left110: makeNodeComponent("left110"),
    icon110: makeNodeComponent("icon110"),
    title113: makeNodeComponent("title113"),
    item111: makeNodeComponent("item111"),
    left111: makeNodeComponent("left111"),
    icon111: makeNodeComponent("icon111"),
    title114: makeNodeComponent("title114"),
    item112: makeNodeComponent("item112"),
    left112: makeNodeComponent("left112"),
    icon112: makeNodeComponent("icon112"),
    title115: makeNodeComponent("title115"),
    item113: makeNodeComponent("item113"),
    left113: makeNodeComponent("left113"),
    icon113: makeNodeComponent("icon113"),
    title116: makeNodeComponent("title116"),
    item114: makeNodeComponent("item114"),
    left114: makeNodeComponent("left114"),
    icon114: makeNodeComponent("icon114"),
    title117: makeNodeComponent("title117"),
    item115: makeNodeComponent("item115"),
    left115: makeNodeComponent("left115"),
    icon115: makeNodeComponent("icon115"),
    title118: makeNodeComponent("title118"),
    item116: makeNodeComponent("item116"),
    left116: makeNodeComponent("left116"),
    icon116: makeNodeComponent("icon116"),
    title119: makeNodeComponent("title119"),
    item117: makeNodeComponent("item117"),
    left117: makeNodeComponent("left117"),
    icon117: makeNodeComponent("icon117"),
    title120: makeNodeComponent("title120"),
    item118: makeNodeComponent("item118"),
    left118: makeNodeComponent("left118"),
    icon118: makeNodeComponent("icon118"),
    title121: makeNodeComponent("title121"),
    item119: makeNodeComponent("item119"),
    left119: makeNodeComponent("left119"),
    icon119: makeNodeComponent("icon119"),
    title122: makeNodeComponent("title122"),
    item120: makeNodeComponent("item120"),
    left120: makeNodeComponent("left120"),
    icon120: makeNodeComponent("icon120"),
    title123: makeNodeComponent("title123"),
    section8: makeNodeComponent("section8"),
    header10: makeNodeComponent("header10"),
    list8: makeNodeComponent("list8"),
    item121: makeNodeComponent("item121"),
    left121: makeNodeComponent("left121"),
    icon121: makeNodeComponent("icon121"),
    title124: makeNodeComponent("title124"),
    item122: makeNodeComponent("item122"),
    left122: makeNodeComponent("left122"),
    icon122: makeNodeComponent("icon122"),
    title125: makeNodeComponent("title125"),
    item123: makeNodeComponent("item123"),
    left123: makeNodeComponent("left123"),
    icon123: makeNodeComponent("icon123"),
    title126: makeNodeComponent("title126"),
    item124: makeNodeComponent("item124"),
    left124: makeNodeComponent("left124"),
    icon124: makeNodeComponent("icon124"),
    title127: makeNodeComponent("title127"),
    item125: makeNodeComponent("item125"),
    left125: makeNodeComponent("left125"),
    icon125: makeNodeComponent("icon125"),
    title128: makeNodeComponent("title128"),
    item126: makeNodeComponent("item126"),
    left126: makeNodeComponent("left126"),
    icon126: makeNodeComponent("icon126"),
    title129: makeNodeComponent("title129"),
    item127: makeNodeComponent("item127"),
    left127: makeNodeComponent("left127"),
    icon127: makeNodeComponent("icon127"),
    title130: makeNodeComponent("title130"),
    item128: makeNodeComponent("item128"),
    left128: makeNodeComponent("left128"),
    icon128: makeNodeComponent("icon128"),
    title131: makeNodeComponent("title131"),
    item129: makeNodeComponent("item129"),
    left129: makeNodeComponent("left129"),
    icon129: makeNodeComponent("icon129"),
    title132: makeNodeComponent("title132"),
    item130: makeNodeComponent("item130"),
    left130: makeNodeComponent("left130"),
    icon130: makeNodeComponent("icon130"),
    title133: makeNodeComponent("title133"),
    item131: makeNodeComponent("item131"),
    left131: makeNodeComponent("left131"),
    icon131: makeNodeComponent("icon131"),
    title134: makeNodeComponent("title134"),
    item132: makeNodeComponent("item132"),
    left132: makeNodeComponent("left132"),
    icon132: makeNodeComponent("icon132"),
    title135: makeNodeComponent("title135"),
    item133: makeNodeComponent("item133"),
    left133: makeNodeComponent("left133"),
    icon133: makeNodeComponent("icon133"),
    title136: makeNodeComponent("title136"),
    item134: makeNodeComponent("item134"),
    left134: makeNodeComponent("left134"),
    icon134: makeNodeComponent("icon134"),
    title137: makeNodeComponent("title137"),
    item135: makeNodeComponent("item135"),
    left135: makeNodeComponent("left135"),
    icon135: makeNodeComponent("icon135"),
    title138: makeNodeComponent("title138"),
    item136: makeNodeComponent("item136"),
    left136: makeNodeComponent("left136"),
    icon136: makeNodeComponent("icon136"),
    title139: makeNodeComponent("title139"),
    item137: makeNodeComponent("item137"),
    left137: makeNodeComponent("left137"),
    icon137: makeNodeComponent("icon137"),
    title140: makeNodeComponent("title140"),
    item138: makeNodeComponent("item138"),
    left138: makeNodeComponent("left138"),
    icon138: makeNodeComponent("icon138"),
    title141: makeNodeComponent("title141"),
    item139: makeNodeComponent("item139"),
    left139: makeNodeComponent("left139"),
    icon139: makeNodeComponent("icon139"),
    title142: makeNodeComponent("title142"),
    item140: makeNodeComponent("item140"),
    left140: makeNodeComponent("left140"),
    icon140: makeNodeComponent("icon140"),
    title143: makeNodeComponent("title143"),
    item141: makeNodeComponent("item141"),
    left141: makeNodeComponent("left141"),
    icon141: makeNodeComponent("icon141"),
    title144: makeNodeComponent("title144"),
    item142: makeNodeComponent("item142"),
    left142: makeNodeComponent("left142"),
    icon142: makeNodeComponent("icon142"),
    title145: makeNodeComponent("title145"),
    item143: makeNodeComponent("item143"),
    left143: makeNodeComponent("left143"),
    icon143: makeNodeComponent("icon143"),
    title146: makeNodeComponent("title146"),
    item144: makeNodeComponent("item144"),
    left144: makeNodeComponent("left144"),
    icon144: makeNodeComponent("icon144"),
    title147: makeNodeComponent("title147"),
    section3: makeNodeComponent("section3"),
    header11: makeNodeComponent("header11"),
    list9: makeNodeComponent("list9"),
    item145: makeNodeComponent("item145"),
    left145: makeNodeComponent("left145"),
    icon145: makeNodeComponent("icon145"),
    title148: makeNodeComponent("title148"),
    item146: makeNodeComponent("item146"),
    left146: makeNodeComponent("left146"),
    icon146: makeNodeComponent("icon146"),
    title149: makeNodeComponent("title149"),
    item147: makeNodeComponent("item147"),
    left147: makeNodeComponent("left147"),
    icon147: makeNodeComponent("icon147"),
    title150: makeNodeComponent("title150"),
    item148: makeNodeComponent("item148"),
    left148: makeNodeComponent("left148"),
    icon148: makeNodeComponent("icon148"),
    title151: makeNodeComponent("title151"),
    item149: makeNodeComponent("item149"),
    left149: makeNodeComponent("left149"),
    icon149: makeNodeComponent("icon149"),
    title152: makeNodeComponent("title152"),
    item150: makeNodeComponent("item150"),
    left150: makeNodeComponent("left150"),
    icon150: makeNodeComponent("icon150"),
    title153: makeNodeComponent("title153"),
    item151: makeNodeComponent("item151"),
    left151: makeNodeComponent("left151"),
    icon151: makeNodeComponent("icon151"),
    title154: makeNodeComponent("title154"),
    item152: makeNodeComponent("item152"),
    left152: makeNodeComponent("left152"),
    icon152: makeNodeComponent("icon152"),
    title155: makeNodeComponent("title155"),
    item153: makeNodeComponent("item153"),
    left153: makeNodeComponent("left153"),
    icon153: makeNodeComponent("icon153"),
    title156: makeNodeComponent("title156"),
    item154: makeNodeComponent("item154"),
    left154: makeNodeComponent("left154"),
    icon154: makeNodeComponent("icon154"),
    title157: makeNodeComponent("title157"),
    item155: makeNodeComponent("item155"),
    left155: makeNodeComponent("left155"),
    icon155: makeNodeComponent("icon155"),
    title158: makeNodeComponent("title158"),
    item156: makeNodeComponent("item156"),
    left156: makeNodeComponent("left156"),
    icon156: makeNodeComponent("icon156"),
    title159: makeNodeComponent("title159"),
    item157: makeNodeComponent("item157"),
    left157: makeNodeComponent("left157"),
    icon157: makeNodeComponent("icon157"),
    title160: makeNodeComponent("title160"),
    item158: makeNodeComponent("item158"),
    left158: makeNodeComponent("left158"),
    icon158: makeNodeComponent("icon158"),
    title161: makeNodeComponent("title161"),
    item159: makeNodeComponent("item159"),
    left159: makeNodeComponent("left159"),
    icon159: makeNodeComponent("icon159"),
    title162: makeNodeComponent("title162"),
    item160: makeNodeComponent("item160"),
    left160: makeNodeComponent("left160"),
    icon160: makeNodeComponent("icon160"),
    title163: makeNodeComponent("title163"),
    item161: makeNodeComponent("item161"),
    left161: makeNodeComponent("left161"),
    icon161: makeNodeComponent("icon161"),
    title164: makeNodeComponent("title164"),
    item162: makeNodeComponent("item162"),
    left162: makeNodeComponent("left162"),
    icon162: makeNodeComponent("icon162"),
    title165: makeNodeComponent("title165"),
    item163: makeNodeComponent("item163"),
    left163: makeNodeComponent("left163"),
    icon163: makeNodeComponent("icon163"),
    title166: makeNodeComponent("title166"),
    item164: makeNodeComponent("item164"),
    left164: makeNodeComponent("left164"),
    icon164: makeNodeComponent("icon164"),
    title167: makeNodeComponent("title167"),
    item165: makeNodeComponent("item165"),
    left165: makeNodeComponent("left165"),
    icon165: makeNodeComponent("icon165"),
    title168: makeNodeComponent("title168"),
    item166: makeNodeComponent("item166"),
    left166: makeNodeComponent("left166"),
    icon166: makeNodeComponent("icon166"),
    title169: makeNodeComponent("title169"),
    item167: makeNodeComponent("item167"),
    left167: makeNodeComponent("left167"),
    icon167: makeNodeComponent("icon167"),
    title170: makeNodeComponent("title170"),
    item168: makeNodeComponent("item168"),
    left168: makeNodeComponent("left168"),
    icon168: makeNodeComponent("icon168"),
    title171: makeNodeComponent("title171"),
    section4: makeNodeComponent("section4"),
    header12: makeNodeComponent("header12"),
    list10: makeNodeComponent("list10"),
    item169: makeNodeComponent("item169"),
    left169: makeNodeComponent("left169"),
    icon169: makeNodeComponent("icon169"),
    title172: makeNodeComponent("title172"),
    item170: makeNodeComponent("item170"),
    left170: makeNodeComponent("left170"),
    icon170: makeNodeComponent("icon170"),
    title173: makeNodeComponent("title173"),
    item171: makeNodeComponent("item171"),
    left171: makeNodeComponent("left171"),
    icon171: makeNodeComponent("icon171"),
    title174: makeNodeComponent("title174"),
    item172: makeNodeComponent("item172"),
    left172: makeNodeComponent("left172"),
    icon172: makeNodeComponent("icon172"),
    title175: makeNodeComponent("title175"),
    item173: makeNodeComponent("item173"),
    left173: makeNodeComponent("left173"),
    icon173: makeNodeComponent("icon173"),
    title176: makeNodeComponent("title176"),
    item174: makeNodeComponent("item174"),
    left174: makeNodeComponent("left174"),
    icon174: makeNodeComponent("icon174"),
    title177: makeNodeComponent("title177"),
    item175: makeNodeComponent("item175"),
    left175: makeNodeComponent("left175"),
    icon175: makeNodeComponent("icon175"),
    title178: makeNodeComponent("title178"),
    item176: makeNodeComponent("item176"),
    left176: makeNodeComponent("left176"),
    icon176: makeNodeComponent("icon176"),
    title179: makeNodeComponent("title179"),
    item177: makeNodeComponent("item177"),
    left177: makeNodeComponent("left177"),
    icon177: makeNodeComponent("icon177"),
    title180: makeNodeComponent("title180"),
    item178: makeNodeComponent("item178"),
    left178: makeNodeComponent("left178"),
    icon178: makeNodeComponent("icon178"),
    title181: makeNodeComponent("title181"),
    item179: makeNodeComponent("item179"),
    left179: makeNodeComponent("left179"),
    icon179: makeNodeComponent("icon179"),
    title182: makeNodeComponent("title182"),
    item180: makeNodeComponent("item180"),
    left180: makeNodeComponent("left180"),
    icon180: makeNodeComponent("icon180"),
    title183: makeNodeComponent("title183"),
    item181: makeNodeComponent("item181"),
    left181: makeNodeComponent("left181"),
    icon181: makeNodeComponent("icon181"),
    title184: makeNodeComponent("title184"),
    item182: makeNodeComponent("item182"),
    left182: makeNodeComponent("left182"),
    icon182: makeNodeComponent("icon182"),
    title185: makeNodeComponent("title185"),
    item183: makeNodeComponent("item183"),
    left183: makeNodeComponent("left183"),
    icon183: makeNodeComponent("icon183"),
    title186: makeNodeComponent("title186"),
    item184: makeNodeComponent("item184"),
    left184: makeNodeComponent("left184"),
    icon184: makeNodeComponent("icon184"),
    title187: makeNodeComponent("title187"),
    item185: makeNodeComponent("item185"),
    left185: makeNodeComponent("left185"),
    icon185: makeNodeComponent("icon185"),
    title188: makeNodeComponent("title188"),
    item186: makeNodeComponent("item186"),
    left186: makeNodeComponent("left186"),
    icon186: makeNodeComponent("icon186"),
    title189: makeNodeComponent("title189"),
    item187: makeNodeComponent("item187"),
    left187: makeNodeComponent("left187"),
    icon187: makeNodeComponent("icon187"),
    title190: makeNodeComponent("title190"),
    item188: makeNodeComponent("item188"),
    left188: makeNodeComponent("left188"),
    icon188: makeNodeComponent("icon188"),
    title191: makeNodeComponent("title191"),
    item189: makeNodeComponent("item189"),
    left189: makeNodeComponent("left189"),
    icon189: makeNodeComponent("icon189"),
    title192: makeNodeComponent("title192"),
    item190: makeNodeComponent("item190"),
    left190: makeNodeComponent("left190"),
    icon190: makeNodeComponent("icon190"),
    title193: makeNodeComponent("title193"),
    item191: makeNodeComponent("item191"),
    left191: makeNodeComponent("left191"),
    icon191: makeNodeComponent("icon191"),
    title194: makeNodeComponent("title194"),
    item192: makeNodeComponent("item192"),
    left192: makeNodeComponent("left192"),
    icon192: makeNodeComponent("icon192"),
    title195: makeNodeComponent("title195"),

    // Metadata about props expected for PlasmicFeaturesMyEvaluations
    internalVariantProps: PlasmicFeaturesMyEvaluations__VariantProps,
    internalArgProps: PlasmicFeaturesMyEvaluations__ArgProps
  }
);

export default PlasmicFeaturesMyEvaluations;
/* prettier-ignore-end */
